import * as React from "react";

export type ICON_TYPE =
	| AVAILABLE_ICONS.ADDRESS
	| "email"
	| "link"
	| "text"
	| "phone"
	| "loading"
	| "logo"
	| "success"
	| "socialProfile"
	| "instagram"
	| "facebook"
	| "twitter"
	| "pinterest"
	| "threads"
	| "snapchat"
	| "patreon"
	| "onlyFans"
	| "appStore"
	| "googlePlay"
	| "linkedin"
	| "tiktok"
	| "youtube"
	| "verified"
	| "vimeo"
	| "revolut"
	| "discord"
	| "venmo"
	| "twitch"
	| AVAILABLE_ICONS.PAYPAL
	| AVAILABLE_ICONS.GOOGLE_REVIEW
	| AVAILABLE_ICONS.CALENDLY
	| "phone_overlay"
	| "email_overlay"
	| "address_overlay"
	| "link_overlay"
	| "linkedin_overlay"
	| "facebook_overlay"
	| "youtube_overlay"
	| "instagram_overlay"
	| "tiktok_overlay"
	| "twitter_overlay"
	| "pinterest_overlay"
	| "threads_overlay"
	| "snapchat_overlay"
	| "patreon_overlay"
	| "onlyFans_overlay"
	| "appStore_overlay"
	| "googlePlay_overlay"
	| "vimeo_overlay"
	| "revolut_overlay"
	| AVAILABLE_ICONS.PAYPAL_OVERLAY
	| AVAILABLE_ICONS.GOOGLE_REVIEW_OVERLAY
	| AVAILABLE_ICONS.CALENDLY_OVERLAY
	| "qrCode"
	| "text_overlay";

export enum AVAILABLE_ICONS {
	ADDRESS = "address",
	EMAIL = "email",
	LINK = "link",
	TEXT = "text",
	PHONE = "phone",
	LOADING = "loading",
	LOGO = "logo",
	SUCCESS = "success",
	SOCIAL_PROFILE = "socialProfile",
	INSTAGRAM = "instagram",
	FACEBOOK = "facebook",
	TWITTER = "twitter",
	PINTEREST = "pinterest",
	THREADS = "threads",
	SNAPCHAT = "snapchat",
	PATREON = "patreon",
	ONLY_FANS = "onlyFans",
	APP_STORE = "appStore",
	GOOGLE_PLAY = "googlePlay",
	LINKED_IN = "linkedin",
	TIK_TOK = "tiktok",
	YOUTUBE = "youtube",
	VERIFIED = "verified",
	VIMEO = "vimeo",
	REVOLUT = "revolut",
	DISCORD = "discord",
	VENMO = "venmo",
	TWITCH = "twitch",
	PAYPAL = "payPal",
	GOOGLE_REVIEW = "googleReviews",
	CALENDLY = "calendly",
	PHONE_OVERLAY = "phone_overlay",
	EMAIL_OVERLAY = "email_overlay",
	ADDRESS_OVERLAY = "address_overlay",
	LINK_OVERLAY = "link_overlay",
	LINKED_IN_OVERLAY = "linkedin_overlay",
	FACEBOOK_OVERLAY = "facebook_overlay",
	YOUTUBE_OVERLAY = "youtube_overlay",
	INSTAGRAM_OVERLAY = "instagram_overlay",
	TIK_TOK_OVERLAY = "tiktok_overlay",
	TWITTER_OVERLAY = "twitter_overlay",
	PINTEREST_OVERLAY = "pinterest_overlay",
	THREADS_OVERLAY = "threads_overlay",
	SNAPCHAT_OVERLAY = "snapchat_overlay",
	PATREON_OVERLAY = "patreon_overlay",
	ONLY_FANS_OVERLAY = "onlyFans_overlay",
	APP_STORE_OVERLAY = "appStore_overlay",
	GOOGLE_PLAY_OVERLAY = "googlePlay_overlay",
	TEXT_OVERLAY = "text_overlay",
	VIMEO_OVERLAY = "vimeo_overlay",
	REVOLUT_OVERLAY = "revolut_overlay",
	PAYPAL_OVERLAY = "payPal_overlay",
	GOOGLE_REVIEW_OVERLAY = "googleReviews_overlay",
	CALENDLY_OVERLAY = "calendly_overlay",
	QR_CODE = "qrCode",
}

// Ak je overlay ikona dojebana, v Adobe Illustrator stroke 1, vnutorne, opacity 20% a export for screens a cely artboart
const Icon = ({
	icon,
	width,
	height,
	size,
	className,
}: {
	icon: ICON_TYPE;
	width?: string;
	height?: string;
	size?: number;
	className?: string;
}): JSX.Element | null => {
	const ICON_SIZE = size || "28";
	const icons = new Map<ICON_TYPE, any>([
		[
			AVAILABLE_ICONS.ADDRESS,
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M39.5001 15C39.5001 6.71253 32.7876 0 24.5 0C16.2125 0 9.50001 6.71253 9.50001 15C9.50001 23.5879 18.2411 35.0895 22.3778 40.0519C23.4992 41.3971 25.5008 41.3971 26.6222 40.0519C30.759 35.0895 39.5001 23.5879 39.5001 15ZM19.5 15C19.5 12.2375 21.7375 10 24.5 10C27.2625 10 29.5001 12.2375 29.5001 15C29.5001 17.7626 27.2625 20.0001 24.5 20.0001C21.7375 20.0001 19.5 17.7626 19.5 15ZM9.5 45C8.11929 45 7 46.1193 7 47.5C7 48.8807 8.11929 50 9.50001 50H39.5001C40.8808 50 42.0001 48.8807 42.0001 47.5C42.0001 46.1193 40.8808 45 39.5001 45H9.5Z"
					fill="currentColor"
				/>
			</svg>,
		],
		[
			"email",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M49.5685 11.7614C48.6812 9.55648 46.5224 8 44 8H6C3.5182 8 1.38833 9.50681 0.475344 11.6555L25.123 24.562L49.5685 11.7614ZM25.6219 28.7254C25.8042 28.6889 25.9844 28.6261 26.1574 28.5355L50 16.0506V36C50 39.3137 47.3137 42 44 42H6C2.68629 42 0 39.3137 0 36V15.9218L24.1562 28.5709C24.6259 28.8169 25.1486 28.8577 25.6219 28.7254Z"
					fill="currentColor"
				/>
			</svg>,
		],
		[
			"link",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_208_22)">
					<path
						d="M29.8067 18.932C28.7467 17.8733 27.5292 17.0733 26.2292 16.5133L24.073 18.6695C23.2217 19.5208 22.8267 20.6458 22.853 21.762C23.8317 21.9783 24.763 22.4545 25.523 23.2145L26.7867 24.4783C28.9105 26.6032 28.9105 30.062 26.7867 32.1857L16.6205 42.3531C14.4943 44.4769 11.0381 44.4769 8.91308 42.3531L7.64809 41.0894C5.5231 38.9632 5.5231 35.5069 7.64809 33.3807L15.0993 25.9307C14.1593 23.2783 14.1293 20.3795 14.998 17.7083C14.4855 18.0733 13.9918 18.4733 13.5318 18.932L3.36561 29.0982C-1.12061 33.5857 -1.12061 40.8844 3.36561 45.3719L4.63061 46.6344C9.11683 51.1218 16.4155 51.1218 20.9018 46.6344L31.0692 36.4682C35.5554 31.982 35.5554 24.6833 31.0704 20.197L29.8067 18.932Z"
						fill="currentColor"
					/>
					<path
						d="M46.6379 4.62966L45.3742 3.36467C40.8867 -1.12156 33.5867 -1.12156 29.1005 3.36467L18.9343 13.5309C17.6168 14.8483 16.6968 16.4108 16.1543 18.0708L16.1493 18.0846C16.0543 18.3796 15.9706 18.6796 15.8981 18.9821C15.8968 18.9921 15.8931 19.0021 15.8906 19.0133C15.4631 20.8358 15.4831 22.747 15.9468 24.5545C15.9543 24.5858 15.9606 24.617 15.9693 24.6483C16.0381 24.9058 16.1181 25.1595 16.2043 25.4108C16.7531 27.0158 17.6556 28.5245 18.9331 29.8058L20.1981 31.0695C21.2568 32.1295 22.4768 32.9282 23.7743 33.487L25.9293 31.332C26.7793 30.482 27.1855 29.3583 27.1593 28.242C26.178 28.0258 25.2405 27.5483 24.478 26.787L23.2143 25.5233C22.4306 24.7395 21.9393 23.772 21.7343 22.7583L21.6606 22.742L21.6406 21.8946C21.5806 20.4246 22.0931 18.9358 23.2131 17.8146L33.3805 7.64839C35.5042 5.5234 38.9617 5.5234 41.0867 7.64839L42.3517 8.91338C44.4767 11.0384 44.4767 14.4946 42.3517 16.6208L34.8967 24.0758C35.8355 26.7295 35.8705 29.6245 35.0005 32.2945C35.513 31.9282 36.0092 31.5282 36.468 31.0707L46.6329 20.9033C51.1216 16.4146 51.1216 9.11463 46.6379 4.62966Z"
						fill="currentColor"
					/>
				</g>
				<defs>
					<clipPath id="clip0_208_22">
						<rect width="50" height="50" fill="white" />
					</clipPath>
				</defs>
			</svg>,
		],
		[
			"text",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M47.5976 33.6432H2.40237C1.07554 33.6432 0 32.5677 0 31.2409V30.2805C0 28.9537 1.07554 27.8782 2.40237 27.8782H47.5976C48.9245 27.8782 50 28.9537 50 30.2805V31.2409C50 32.5685 48.9245 33.6432 47.5976 33.6432ZM47.5976 10.5966H2.40237C1.07554 10.5966 0 9.5211 0 8.19427V7.23397C0 5.90714 1.07554 4.8324 2.40237 4.8324H47.5976C48.9245 4.8324 50 5.90794 50 7.23397V8.19427C50 9.5211 48.9245 10.5966 47.5976 10.5966ZM2.40237 16.3553H37.9946C39.3214 16.3553 40.3961 17.4308 40.3961 18.7569V19.7172C40.3961 21.044 39.3206 22.1187 37.9946 22.1187H2.40237C1.07554 22.1187 0 21.0432 0 19.7172V18.7569C0 17.4308 1.07554 16.3553 2.40237 16.3553ZM2.40237 39.4027H28.3915C29.7183 39.4027 30.7939 40.4782 30.7939 41.805V42.7653C30.7939 44.0922 29.7183 45.1677 28.3915 45.1677H2.40237C1.07554 45.1677 0 44.0922 0 42.7653V41.805C0 40.4782 1.07554 39.4027 2.40237 39.4027Z"
					fill="currentColor"
				/>
			</svg>,
		],
		[
			"phone",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M42.7562 42.7251L37.814 34.1648C37.0612 32.8616 35.274 32.4718 33.8422 33.2986L29.4649 35.8261C24.0726 32.2508 18.5675 22.7181 18.1685 16.2608L22.5458 13.7333C23.9782 12.9066 24.5352 11.1651 23.782 9.86065L18.8398 1.30041C18.0865 -0.00404135 16.2998 -0.392487 14.8681 0.434929L10.2933 3.07596C2.74094 7.43614 10.0591 25.8053 13.6017 31.9411C17.1449 38.0781 29.3934 53.5989 36.9452 49.2386L41.52 46.5976C42.9522 45.7703 43.5087 44.0281 42.756 42.7251H42.7562Z"
					fill="currentColor"
				/>
			</svg>,
		],
		[
			"socialProfile",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M45.9542 0.0101738C44.7195 0.090481 43.5926 0.76147 42.9485 1.88899C42.1702 3.23097 42.3044 4.8144 43.136 5.99517L38.681 10.4771C38.3054 10.1817 37.9028 9.88641 37.5002 9.64496C32.7768 6.90769 26.7649 8.54444 24.0546 13.2683C23.7323 13.7781 23.5178 14.3149 23.3027 14.8786L12.1115 11.5776C12.1919 9.40353 11.0919 7.28329 9.07888 6.10252C6.18038 4.43876 2.50376 5.43154 0.813088 8.33002C-0.850674 11.2285 0.11515 14.932 3.01367 16.5958C5.88512 18.2596 9.56187 17.3207 11.2531 14.4756L22.7397 17.8569C22.6324 21.3461 24.4034 24.8347 27.651 26.7134C29.4226 27.7331 31.3547 28.1357 33.2604 28.0014H33.2874L36.8838 38.817C36.0786 39.3269 35.4076 40.0518 34.9248 40.9104C33.2341 43.8089 34.2268 47.4855 37.1253 49.1762C40.0238 50.8399 43.7274 49.8741 45.3911 46.9756C47.0818 44.0771 46.0621 40.3465 43.1636 38.6829C42.0901 38.0658 40.9092 37.7974 39.7554 37.8777L36.2398 27.3035C38.2259 26.4983 39.9704 25.1029 41.1243 23.117C43.0564 19.7356 42.7615 15.7097 40.7217 12.677L45.9004 7.52462C47.3233 7.65882 48.7455 6.98783 49.4968 5.67286C50.5435 3.87493 49.8994 1.54017 48.1015 0.493031C47.4036 0.11739 46.6787 -0.0437662 45.9544 0.0101325L45.9542 0.0101738Z"
					fill="currentColor"
				/>
			</svg>,
		],
		[
			"loading",
			<svg
				width="30"
				height="30"
				viewBox="0 0 138 138"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M15 69C15 39.1766 39.1766 15 69 15C76.733 15 84.0863 16.6255 90.737 19.5533L92.9505 16.6888L95.891 13.4023L98.8315 10.4618L101.469 8.10161C91.7922 2.93121 80.7384 0 69 0C30.8923 0 0 30.8923 0 69C0 107.108 30.8923 138 69 138C107.108 138 138 107.108 138 69C138 56.6203 134.74 45.0021 129.031 34.957L126.24 37.1897L122.954 40.4761L120.359 43.4166L118.284 46.1841L118.089 46.4684C121.242 53.3261 123 60.9577 123 69C123 98.8234 98.8234 123 69 123C39.1766 123 15 98.8234 15 69Z"
					fill="black"
				/>
			</svg>,
		],
		[
			"verified",
			<svg
				width="16"
				height="16"
				viewBox="0 0 16 16"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M15.1798 9.02529H15.1822C15.1203 8.88766 15.0699 8.73425 15.0343 8.56825C14.9127 8.00964 14.9801 7.42763 15.1828 6.97452H15.1798C15.4122 6.5468 15.4752 6.02825 15.3126 5.52824C15.15 5.02823 14.794 4.64544 14.3541 4.43597L14.3561 4.4345C14.2247 4.35931 14.0949 4.26456 13.9679 4.15178C13.5412 3.77089 13.2536 3.25973 13.151 2.77534L13.1486 2.77681C13.0894 2.32905 12.8668 1.90373 12.4957 1.59813C12.4664 1.57419 12.4366 1.55075 12.4054 1.52831C11.9801 1.21874 11.4669 1.11915 10.9879 1.20799L10.9885 1.20556C10.8381 1.22118 10.6775 1.22168 10.5085 1.20459C9.93919 1.14696 9.40602 0.903301 9.03779 0.570793L9.03689 0.573731C8.7015 0.220692 8.22737 0 7.70155 0C7.17569 0 6.70209 0.220723 6.36658 0.573731L6.36564 0.570325C6.25286 0.671889 6.12295 0.76761 5.97648 0.85255C5.48231 1.14015 4.90767 1.25684 4.41401 1.20412L4.41547 1.20803C3.9365 1.11915 3.42283 1.21878 2.99804 1.52835C2.70263 1.74219 2.48928 2.02882 2.36577 2.34571C2.31109 2.48437 2.27396 2.6294 2.25443 2.77684L2.25199 2.77487C2.22127 2.92281 2.17146 3.07613 2.10308 3.23141C1.87261 3.75486 1.47613 4.18646 1.04596 4.43353L1.0489 4.43597C0.609456 4.64544 0.253042 5.02823 0.0909444 5.52824C-0.0721528 6.02825 -0.00868269 6.5468 0.22376 6.97452H0.220353C0.282355 7.11321 0.332168 7.26603 0.368294 7.43157C0.489891 7.99064 0.422452 8.57315 0.220353 9.02535H0.22376C-0.00868269 9.45408 -0.0721528 9.97262 0.0909444 10.4726C0.253073 10.9726 0.609487 11.3554 1.0489 11.5644L1.0465 11.5664C1.17781 11.6415 1.30822 11.7363 1.43416 11.8496C1.86139 12.2305 2.14899 12.7412 2.25152 13.2266L2.25446 13.2237C2.26568 13.3047 2.2818 13.3847 2.3033 13.4639C2.40878 13.8555 2.64412 14.2159 2.99807 14.4727C3.26123 14.6631 3.55811 14.7754 3.85987 14.8106C4.0459 14.8331 4.23294 14.8272 4.41551 14.793L4.41454 14.7959C4.56495 14.7803 4.72604 14.7793 4.89452 14.7969C5.46334 14.8545 5.99654 15.0977 6.36517 15.4307L6.36664 15.4268C6.70209 15.7803 7.17575 16 7.70161 16C8.22743 16 8.70154 15.7803 9.03698 15.4268L9.03748 15.4287C9.15026 15.3272 9.2802 15.2325 9.42718 15.1475C9.92131 14.8594 10.4955 14.7432 10.9891 14.7959L10.9881 14.793C11.0477 14.8037 11.1068 14.8125 11.1673 14.8174C11.5926 14.8534 12.033 14.7432 12.4056 14.4727C12.7346 14.2334 12.9617 13.9063 13.0764 13.5459C13.1106 13.4405 13.134 13.333 13.1487 13.2237L13.1507 13.2256C13.1814 13.0772 13.2308 12.924 13.2996 12.7686C13.5306 12.2452 13.927 11.8135 14.3573 11.5665L14.3542 11.5645C14.7942 11.3555 15.1502 10.9717 15.3128 10.4727C15.4752 9.9725 15.4122 9.45298 15.1798 9.02529Z"
					fill="#3478F6"
				/>
				<rect
					x="5.30664"
					y="9.84814"
					width="6.8267"
					height="1.6"
					rx="0.8"
					transform="rotate(-45 5.30664 9.84814)"
					fill="white"
				/>
				<rect
					x="5.15601"
					y="7.70837"
					width="3.18579"
					height="1.44"
					rx="0.72"
					transform="rotate(45 5.15601 7.70837)"
					fill="white"
				/>
			</svg>,
		],
		[
			"logo",
			<svg
				width={width || "47"}
				height={height || "30"}
				viewBox="0 0 47 30"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M28.1198 25.033L27.5636 25.7528L26.9712 26.4148L26.3786 27.0076L25.9881 27.3569L25.8802 27.4534L26.0087 27.5202C27.9518 28.5297 30.1594 29.1 32.5001 29.1C40.2874 29.1 46.6001 22.7873 46.6001 15C46.6001 7.21274 40.2874 0.9 32.5001 0.9C29.0201 0.9 25.8345 2.16076 23.3753 4.25032L22.9288 4.60741L22.9284 4.60693L22.9205 4.6148L22.2538 5.28162L22.2537 5.28149L22.2496 5.28616L21.7231 5.88275L21.7228 5.88254L21.7181 5.88891L21.5159 6.15843C19.5669 8.57688 18.4001 11.6522 18.4001 15C18.4001 17.5296 19.0663 19.9039 20.2329 21.9568L20.2908 22.0587L20.3823 21.9855L20.9486 21.5323L20.9489 21.5328L20.9568 21.5249L21.6235 20.8582L21.6236 20.8584L21.6278 20.8537L22.1542 20.2571L22.1545 20.2573L22.1593 20.2509L22.5805 19.6893L22.5806 19.6894L22.583 19.6859L22.6139 19.6408L22.646 19.594L22.6222 19.5424C21.9855 18.1603 21.6306 16.6217 21.6306 15C21.6306 8.997 26.4969 4.13043 32.5001 4.13043C38.5031 4.13043 43.3697 8.997 43.3697 15C43.3697 21.0032 38.5031 25.8696 32.5001 25.8696C30.9871 25.8696 29.5466 25.5607 28.2382 25.0022L28.1671 24.9719L28.1198 25.033ZM21.5197 2.64712L21.6274 2.55066L21.4991 2.4839C19.5542 1.47193 17.3438 0.9 15 0.9C7.2128 0.9 0.9 7.21274 0.9 15C0.9 22.7873 7.2128 29.1 15 29.1C18.442 29.1 21.5962 27.8666 24.0442 25.8177C24.0445 25.8175 24.0449 25.8172 24.0452 25.8169L24.6497 25.3333L24.6501 25.3338L24.658 25.3259L25.3247 24.6592L25.3248 24.6593L25.3289 24.6547L25.8554 24.0581L25.8557 24.0583L25.8605 24.0519L26.0134 23.8478L26.0725 23.7689L26.0538 23.7544C27.9609 21.3496 29.1 18.3076 29.1 15C29.1 12.4786 28.4381 10.1112 27.2782 8.06297L27.2204 7.96083L27.1287 8.03415L26.455 8.57317L26.4546 8.57269L26.4467 8.58054L25.78 9.24724L25.7799 9.2471L25.7758 9.25179L25.2493 9.84859L25.249 9.84838L25.2443 9.85474L24.881 10.339L24.8452 10.3868L24.8703 10.441C25.5116 11.8274 25.8695 13.3717 25.8695 15C25.8695 21.0032 21.0032 25.8696 15 25.8696C8.99692 25.8696 4.13043 21.0032 4.13043 15C4.13043 8.997 8.99693 4.13043 15 4.13043C16.523 4.13043 17.9725 4.44356 19.288 5.00883L19.3644 5.04167L19.4106 4.9725L19.4226 4.9545L20.0149 4.18798L20.6072 3.52593L21.2001 2.93321L21.5197 2.64712Z"
					fill="url(#paint0_linear_146_21)"
				/>
				<path
					d="M28.1198 25.033L27.5636 25.7528L26.9712 26.4148L26.3786 27.0076L25.9881 27.3569L25.8802 27.4534L26.0087 27.5202C27.9518 28.5297 30.1594 29.1 32.5001 29.1C40.2874 29.1 46.6001 22.7873 46.6001 15C46.6001 7.21274 40.2874 0.9 32.5001 0.9C29.0201 0.9 25.8345 2.16076 23.3753 4.25032L22.9288 4.60741L22.9284 4.60693L22.9205 4.6148L22.2538 5.28162L22.2537 5.28149L22.2496 5.28616L21.7231 5.88275L21.7228 5.88254L21.7181 5.88891L21.5159 6.15843C19.5669 8.57688 18.4001 11.6522 18.4001 15C18.4001 17.5296 19.0663 19.9039 20.2329 21.9568L20.2908 22.0587L20.3823 21.9855L20.9486 21.5323L20.9489 21.5328L20.9568 21.5249L21.6235 20.8582L21.6236 20.8584L21.6278 20.8537L22.1542 20.2571L22.1545 20.2573L22.1593 20.2509L22.5805 19.6893L22.5806 19.6894L22.583 19.6859L22.6139 19.6408L22.646 19.594L22.6222 19.5424C21.9855 18.1603 21.6306 16.6217 21.6306 15C21.6306 8.997 26.4969 4.13043 32.5001 4.13043C38.5031 4.13043 43.3697 8.997 43.3697 15C43.3697 21.0032 38.5031 25.8696 32.5001 25.8696C30.9871 25.8696 29.5466 25.5607 28.2382 25.0022L28.1671 24.9719L28.1198 25.033ZM21.5197 2.64712L21.6274 2.55066L21.4991 2.4839C19.5542 1.47193 17.3438 0.9 15 0.9C7.2128 0.9 0.9 7.21274 0.9 15C0.9 22.7873 7.2128 29.1 15 29.1C18.442 29.1 21.5962 27.8666 24.0442 25.8177C24.0445 25.8175 24.0449 25.8172 24.0452 25.8169L24.6497 25.3333L24.6501 25.3338L24.658 25.3259L25.3247 24.6592L25.3248 24.6593L25.3289 24.6547L25.8554 24.0581L25.8557 24.0583L25.8605 24.0519L26.0134 23.8478L26.0725 23.7689L26.0538 23.7544C27.9609 21.3496 29.1 18.3076 29.1 15C29.1 12.4786 28.4381 10.1112 27.2782 8.06297L27.2204 7.96083L27.1287 8.03415L26.455 8.57317L26.4546 8.57269L26.4467 8.58054L25.78 9.24724L25.7799 9.2471L25.7758 9.25179L25.2493 9.84859L25.249 9.84838L25.2443 9.85474L24.881 10.339L24.8452 10.3868L24.8703 10.441C25.5116 11.8274 25.8695 13.3717 25.8695 15C25.8695 21.0032 21.0032 25.8696 15 25.8696C8.99692 25.8696 4.13043 21.0032 4.13043 15C4.13043 8.997 8.99693 4.13043 15 4.13043C16.523 4.13043 17.9725 4.44356 19.288 5.00883L19.3644 5.04167L19.4106 4.9725L19.4226 4.9545L20.0149 4.18798L20.6072 3.52593L21.2001 2.93321L21.5197 2.64712Z"
					fill="white"
				/>
				<path
					d="M28.1198 25.033L27.5636 25.7528L26.9712 26.4148L26.3786 27.0076L25.9881 27.3569L25.8802 27.4534L26.0087 27.5202C27.9518 28.5297 30.1594 29.1 32.5001 29.1C40.2874 29.1 46.6001 22.7873 46.6001 15C46.6001 7.21274 40.2874 0.9 32.5001 0.9C29.0201 0.9 25.8345 2.16076 23.3753 4.25032L22.9288 4.60741L22.9284 4.60693L22.9205 4.6148L22.2538 5.28162L22.2537 5.28149L22.2496 5.28616L21.7231 5.88275L21.7228 5.88254L21.7181 5.88891L21.5159 6.15843C19.5669 8.57688 18.4001 11.6522 18.4001 15C18.4001 17.5296 19.0663 19.9039 20.2329 21.9568L20.2908 22.0587L20.3823 21.9855L20.9486 21.5323L20.9489 21.5328L20.9568 21.5249L21.6235 20.8582L21.6236 20.8584L21.6278 20.8537L22.1542 20.2571L22.1545 20.2573L22.1593 20.2509L22.5805 19.6893L22.5806 19.6894L22.583 19.6859L22.6139 19.6408L22.646 19.594L22.6222 19.5424C21.9855 18.1603 21.6306 16.6217 21.6306 15C21.6306 8.997 26.4969 4.13043 32.5001 4.13043C38.5031 4.13043 43.3697 8.997 43.3697 15C43.3697 21.0032 38.5031 25.8696 32.5001 25.8696C30.9871 25.8696 29.5466 25.5607 28.2382 25.0022L28.1671 24.9719L28.1198 25.033ZM21.5197 2.64712L21.6274 2.55066L21.4991 2.4839C19.5542 1.47193 17.3438 0.9 15 0.9C7.2128 0.9 0.9 7.21274 0.9 15C0.9 22.7873 7.2128 29.1 15 29.1C18.442 29.1 21.5962 27.8666 24.0442 25.8177C24.0445 25.8175 24.0449 25.8172 24.0452 25.8169L24.6497 25.3333L24.6501 25.3338L24.658 25.3259L25.3247 24.6592L25.3248 24.6593L25.3289 24.6547L25.8554 24.0581L25.8557 24.0583L25.8605 24.0519L26.0134 23.8478L26.0725 23.7689L26.0538 23.7544C27.9609 21.3496 29.1 18.3076 29.1 15C29.1 12.4786 28.4381 10.1112 27.2782 8.06297L27.2204 7.96083L27.1287 8.03415L26.455 8.57317L26.4546 8.57269L26.4467 8.58054L25.78 9.24724L25.7799 9.2471L25.7758 9.25179L25.2493 9.84859L25.249 9.84838L25.2443 9.85474L24.881 10.339L24.8452 10.3868L24.8703 10.441C25.5116 11.8274 25.8695 13.3717 25.8695 15C25.8695 21.0032 21.0032 25.8696 15 25.8696C8.99692 25.8696 4.13043 21.0032 4.13043 15C4.13043 8.997 8.99693 4.13043 15 4.13043C16.523 4.13043 17.9725 4.44356 19.288 5.00883L19.3644 5.04167L19.4106 4.9725L19.4226 4.9545L20.0149 4.18798L20.6072 3.52593L21.2001 2.93321L21.5197 2.64712Z"
					fill="black"
				/>
				<path
					d="M28.1198 25.033L27.5636 25.7528L26.9712 26.4148L26.3786 27.0076L25.9881 27.3569L25.8802 27.4534L26.0087 27.5202C27.9518 28.5297 30.1594 29.1 32.5001 29.1C40.2874 29.1 46.6001 22.7873 46.6001 15C46.6001 7.21274 40.2874 0.9 32.5001 0.9C29.0201 0.9 25.8345 2.16076 23.3753 4.25032L22.9288 4.60741L22.9284 4.60693L22.9205 4.6148L22.2538 5.28162L22.2537 5.28149L22.2496 5.28616L21.7231 5.88275L21.7228 5.88254L21.7181 5.88891L21.5159 6.15843C19.5669 8.57688 18.4001 11.6522 18.4001 15C18.4001 17.5296 19.0663 19.9039 20.2329 21.9568L20.2908 22.0587L20.3823 21.9855L20.9486 21.5323L20.9489 21.5328L20.9568 21.5249L21.6235 20.8582L21.6236 20.8584L21.6278 20.8537L22.1542 20.2571L22.1545 20.2573L22.1593 20.2509L22.5805 19.6893L22.5806 19.6894L22.583 19.6859L22.6139 19.6408L22.646 19.594L22.6222 19.5424C21.9855 18.1603 21.6306 16.6217 21.6306 15C21.6306 8.997 26.4969 4.13043 32.5001 4.13043C38.5031 4.13043 43.3697 8.997 43.3697 15C43.3697 21.0032 38.5031 25.8696 32.5001 25.8696C30.9871 25.8696 29.5466 25.5607 28.2382 25.0022L28.1671 24.9719L28.1198 25.033ZM21.5197 2.64712L21.6274 2.55066L21.4991 2.4839C19.5542 1.47193 17.3438 0.9 15 0.9C7.2128 0.9 0.9 7.21274 0.9 15C0.9 22.7873 7.2128 29.1 15 29.1C18.442 29.1 21.5962 27.8666 24.0442 25.8177C24.0445 25.8175 24.0449 25.8172 24.0452 25.8169L24.6497 25.3333L24.6501 25.3338L24.658 25.3259L25.3247 24.6592L25.3248 24.6593L25.3289 24.6547L25.8554 24.0581L25.8557 24.0583L25.8605 24.0519L26.0134 23.8478L26.0725 23.7689L26.0538 23.7544C27.9609 21.3496 29.1 18.3076 29.1 15C29.1 12.4786 28.4381 10.1112 27.2782 8.06297L27.2204 7.96083L27.1287 8.03415L26.455 8.57317L26.4546 8.57269L26.4467 8.58054L25.78 9.24724L25.7799 9.2471L25.7758 9.25179L25.2493 9.84859L25.249 9.84838L25.2443 9.85474L24.881 10.339L24.8452 10.3868L24.8703 10.441C25.5116 11.8274 25.8695 13.3717 25.8695 15C25.8695 21.0032 21.0032 25.8696 15 25.8696C8.99692 25.8696 4.13043 21.0032 4.13043 15C4.13043 8.997 8.99693 4.13043 15 4.13043C16.523 4.13043 17.9725 4.44356 19.288 5.00883L19.3644 5.04167L19.4106 4.9725L19.4226 4.9545L20.0149 4.18798L20.6072 3.52593L21.2001 2.93321L21.5197 2.64712Z"
					stroke="black"
					strokeWidth="0.2"
				/>
				<defs>
					<linearGradient
						id="paint0_linear_146_21"
						x1="5.67616"
						y1="2.81442"
						x2="43.8766"
						y2="27.2155"
						gradientUnits="userSpaceOnUse"
					>
						<stop offset="0.25" stopColor="white" />
						<stop offset="1" stopColor="#959595" />
					</linearGradient>
				</defs>
			</svg>,
		],
		[
			"success",
			<svg
				width="55"
				height="55"
				viewBox="0 0 55 55"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M37.6948 20.1889C38.3689 19.2723 38.1726 17.9826 37.256 17.3082C36.3394 16.6339 35.0495 16.8303 34.3752 17.7469L22.2007 34.2959C21.5263 35.2125 21.7228 36.5023 22.6394 37.1764C23.556 37.8508 24.8458 37.6545 25.5202 36.7379L37.6948 20.1889Z"
					fill="#5BD8AB"
					stroke="#5BD8AB"
					strokeWidth="0.5"
				/>
				<path
					d="M20.503 28.8722C19.7294 28.0376 18.4257 27.9884 17.5911 28.7619C16.7566 29.5355 16.7072 30.8393 17.4808 31.6738L22.2225 36.7891C22.9961 37.6236 24.2998 37.6731 25.1344 36.8996C25.9689 36.126 26.0182 34.8222 25.2446 33.9877L20.503 28.8722Z"
					fill="#5BD8AB"
					stroke="#5BD8AB"
					strokeWidth="0.5"
				/>
				<path
					d="M27.5 51.413C40.7068 51.413 51.413 40.7068 51.413 27.5C51.413 14.2931 40.7068 3.58691 27.5 3.58691C14.2931 3.58691 3.58691 14.2931 3.58691 27.5C3.58691 40.7068 14.2931 51.413 27.5 51.413Z"
					stroke="#5BD8AB"
					strokeWidth="3"
				/>
			</svg>,
		],
		[
			"instagram",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_1561_2152)">
					<g clipPath="url(#clip1_1561_2152)">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M7.01548 48.774C8.08987 49.1931 9.70517 49.6879 12.6787 49.8232C15.8929 49.9718 16.8589 50 24.9993 50C33.1426 50 34.1085 49.9703 37.3228 49.8232C40.2963 49.6879 41.9116 49.1931 42.986 48.774C44.4096 48.2198 45.426 47.56 46.493 46.493C47.56 45.426 48.2198 44.4111 48.774 42.9875C49.1901 41.9131 49.6879 40.2978 49.8232 37.3243C49.9703 34.1071 50 33.1411 50 25.0007C50 16.8574 49.9703 15.8944 49.8232 12.6772C49.6879 9.70369 49.1931 8.08839 48.774 7.014C48.2198 5.59039 47.5614 4.57396 46.493 3.507C45.4246 2.44004 44.4096 1.77728 42.986 1.22596C41.9086 0.809879 40.2963 0.312063 37.3228 0.176836C34.1056 0.0326924 33.1426 0 24.9993 0C16.8589 0 15.8929 0.0297203 12.6772 0.176836C9.70369 0.312063 8.08839 0.806907 7.014 1.22596C5.58891 1.77728 4.57396 2.44004 3.507 3.507C2.44153 4.57693 1.78025 5.59188 1.22596 7.01548C0.809879 8.09285 0.312063 9.70517 0.176836 12.6787C0.0326924 15.8959 0 16.8589 0 25.0022C0 33.1456 0.0297203 34.11 0.178322 37.3243C0.31355 40.2978 0.808393 41.9131 1.22745 42.9875C1.77876 44.4111 2.44004 45.426 3.50849 46.493C4.57693 47.56 5.59188 48.2198 7.01548 48.774ZM25.052 18.9143C21.6325 18.9143 18.8613 21.6871 18.8613 25.1065C18.8613 28.526 21.6325 31.2988 25.052 31.2988C28.4715 31.2988 31.2442 28.526 31.2442 25.1065C31.2442 21.6871 28.4715 18.9143 25.052 18.9143ZM25.052 34.6447C19.7841 34.6447 15.5139 30.3745 15.5139 25.1065H15.514C15.514 19.8383 19.7841 15.5684 25.052 15.5684C30.3199 15.5684 34.5902 19.8386 34.5902 25.1065C34.5902 30.3745 30.3199 34.6447 25.052 34.6447ZM33.114 16.4287C32.8693 16.0621 32.7387 15.6311 32.7389 15.1902C32.7394 14.5993 32.9744 14.0327 33.3924 13.6149C33.8103 13.1972 34.377 12.9624 34.9679 12.9621H34.9688C35.4097 12.9623 35.8406 13.0932 36.207 13.3382C36.5735 13.5833 36.8591 13.9315 37.0276 14.3389C37.1961 14.7463 37.2401 15.1945 37.1539 15.6268C37.0677 16.0592 36.8553 16.4563 36.5434 16.7679C36.2316 17.0795 35.8343 17.2916 35.4019 17.3775C34.9695 17.4633 34.5213 17.419 34.1141 17.2501C33.7068 17.0812 33.3588 16.7954 33.114 16.4287ZM14.0981 39.5875C14.7523 39.8423 15.7366 40.144 17.5476 40.2265V40.2268C19.505 40.3168 20.0915 40.3348 25.052 40.3348C30.0125 40.3348 30.6007 40.3168 32.5586 40.2268C34.3696 40.1444 35.3543 39.8428 36.0081 39.5878C36.8754 39.2502 37.495 38.8474 38.1447 38.1984C38.7944 37.5493 39.1965 36.9305 39.5341 36.0632C39.7875 35.4091 40.0907 34.4248 40.1731 32.6138C40.2632 30.6541 40.2812 30.0676 40.2812 25.1071C40.2812 20.1467 40.2632 19.5601 40.1731 17.6005C40.0908 15.7895 39.7891 14.8049 39.5341 14.151C39.1965 13.2838 38.7953 12.6641 38.1447 12.0144C37.4941 11.3648 36.8754 10.9612 36.0081 10.625C35.3523 10.3724 34.3696 10.0685 32.5586 9.98603C30.599 9.89687 30.0103 9.8777 25.052 9.8777C20.0938 9.8777 19.5056 9.89568 17.5476 9.98574C15.7366 10.0681 14.752 10.3697 14.0981 10.6247C13.2294 10.9609 12.6112 11.3636 11.9615 12.0141C11.3119 12.6647 10.9097 13.2835 10.5721 14.1507C10.3195 14.8065 10.0156 15.7892 9.93313 17.6002C9.84457 19.5598 9.8251 20.1464 9.8251 25.1068C9.8251 30.0673 9.84308 30.6555 9.93313 32.6135C10.0155 34.4245 10.3171 35.4091 10.5721 36.063C10.9083 36.9302 11.311 37.5484 11.9615 38.1981C12.6121 38.8477 13.2309 39.2499 14.0981 39.5875ZM12.8851 7.50661C14.0652 7.04744 15.4164 6.73389 17.3938 6.64383H17.3946C19.3762 6.55229 20.0106 6.53134 25.0542 6.53134C30.0979 6.53134 30.7308 6.55333 32.7117 6.64383C34.6876 6.7324 36.0381 7.04744 37.2204 7.50661C38.4403 7.9808 39.4772 8.61533 40.5094 9.64915C41.5416 10.683 42.1764 11.7183 42.652 12.9396C43.1111 14.1197 43.4247 15.4708 43.5147 17.4484C43.6048 19.4289 43.6257 20.0621 43.6257 25.1065C43.6257 30.151 43.6048 30.7827 43.5147 32.7647C43.4262 34.7422 43.1111 36.0927 42.652 37.2735C42.1764 38.4948 41.5432 39.5318 40.5094 40.5639C39.4756 41.5961 38.4403 42.231 37.2189 42.7065C36.0381 43.1657 34.6878 43.4792 32.7102 43.5693C30.7296 43.6608 30.0964 43.6818 25.052 43.6818C20.0076 43.6818 19.3754 43.6593 17.3938 43.5693C15.4164 43.4792 14.0674 43.1657 12.8851 42.7065C11.6623 42.231 10.6283 41.5957 9.59462 40.5639C8.56094 39.5322 7.92627 38.4948 7.45208 37.2735C6.9929 36.0927 6.67935 34.7423 6.5893 32.7647C6.49776 30.7842 6.47681 30.151 6.47681 25.1065C6.47681 20.0621 6.49776 19.4289 6.5893 17.4484C6.67935 15.4709 6.9929 14.1204 7.45208 12.9396C7.92627 11.7168 8.5608 10.6813 9.59462 9.64915C10.6284 8.61697 11.6637 7.9808 12.8851 7.50661Z"
							fill="currentColor"
						/>
					</g>
				</g>
				<defs>
					<clipPath id="clip0_1561_2152">
						<rect width="50" height="50" fill="white" />
					</clipPath>
					<clipPath id="clip1_1561_2152">
						<rect width="50" height="50" fill="white" />
					</clipPath>
				</defs>
			</svg>,
		],
		[
			"facebook",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_1561_2147)">
					<g clipPath="url(#clip1_1561_2147)">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M40.625 0H9.375C4.19737 0 0 4.19737 0 9.375V40.625C0 45.8026 4.19737 50 9.375 50H40.625C45.8026 50 50 45.8026 50 40.625V9.375C50 4.19737 45.8026 0 40.625 0ZM39.3553 26.9276H34.6776V44.2434H26.8618V26.9276H23.8289V21.0921H26.8618V17.375C26.8618 12.5066 28.8882 9.61184 34.625 9.61184H40.4408V15.4211H37.0592C34.8224 15.4211 34.6776 16.2566 34.6776 17.8092L34.6711 21.0855H39.9868L39.3487 26.9211L39.3553 26.9276Z"
							fill="currentColor"
						/>
					</g>
				</g>
				<defs>
					<clipPath id="clip0_1561_2147">
						<rect width="50" height="50" fill="white" />
					</clipPath>
					<clipPath id="clip1_1561_2147">
						<rect width="50" height="50" fill="white" />
					</clipPath>
				</defs>
			</svg>,
		],
		[
			"twitter",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_3046_2120)">
					<path
						d="M1.11703 2L19.6493 26.7794L1 46.9261H5.19721L21.5246 29.2874L34.7167 46.9261H49L29.425 20.7529L46.7836 2H42.5864L27.5497 18.2449L15.4003 2H1.11703ZM7.28933 5.09167H13.8511L42.8267 43.8339H36.265L7.28933 5.09167Z"
						fill="currentColor"
						stroke="currentColor"
					/>
				</g>
				<defs>
					<clipPath id="clip0_3046_2120">
						<rect width="50" height="50" fill="white" />
					</clipPath>
				</defs>
			</svg>,
		],
		[
			"pinterest",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M6 17.9461C6 15.8466 6.4399 13.762 7.32471 11.6975C8.20952 9.63292 9.47425 7.71333 11.1239 5.94871C12.7735 4.1841 14.9381 2.74941 17.6225 1.64964C20.3069 0.549881 23.2813 0 26.5456 0C31.8444 0 36.1935 1.63465 39.5927 4.89894C42.992 8.16324 44.6916 12.0124 44.6916 16.4464C44.6916 22.1452 43.2519 26.8542 40.3676 30.5684C37.4832 34.2826 33.759 36.1422 29.195 36.1422C27.6953 36.1422 26.2856 35.7923 24.9709 35.0924C23.6562 34.3926 22.7314 33.5427 22.1965 32.543L20.1969 40.4413C20.032 41.0761 19.812 41.716 19.5471 42.3658C19.2821 43.0157 18.9872 43.6406 18.6723 44.2404C18.3573 44.8403 18.0374 45.4052 17.7225 45.9401C17.4075 46.475 17.0876 46.9748 16.7727 47.4397C16.4577 47.9046 16.1828 48.2996 15.9478 48.6145C15.7129 48.9294 15.4979 49.2044 15.298 49.4393L14.9981 49.8392C14.8981 49.9742 14.7631 50.0242 14.5981 49.9892C14.4332 49.9542 14.3332 49.8542 14.2982 49.6893C14.2982 49.6543 14.2732 49.4243 14.2232 48.9894C14.1732 48.5545 14.1232 48.0996 14.0733 47.6147C14.0233 47.1298 13.9733 46.5049 13.9233 45.7401C13.8733 44.9753 13.8583 44.2304 13.8733 43.5156C13.8883 42.8007 13.9383 42.0059 14.0233 41.1411C14.1082 40.2763 14.2332 39.4765 14.3982 38.7416C14.7631 37.177 15.9978 31.9581 18.0974 23.095C17.8324 22.5601 17.6125 21.9203 17.4475 21.1704C17.2826 20.4206 17.1976 19.8107 17.1976 19.3458L17.1476 18.596C17.1476 16.4614 17.6875 14.6868 18.7722 13.2721C19.857 11.8574 21.1617 11.1476 22.6964 11.1476C23.9311 11.1476 24.8859 11.5575 25.5708 12.3723C26.2556 13.1871 26.5955 14.2119 26.5955 15.4467C26.5955 16.2115 26.4556 17.1563 26.1706 18.271C25.8857 19.3858 25.5108 20.6705 25.0459 22.1202C24.581 23.5699 24.2461 24.7447 24.0461 25.6445C23.7112 27.1441 24.0061 28.4439 24.9209 29.5436C25.8357 30.6434 27.0604 31.1933 28.5951 31.1933C31.2295 31.1933 33.4041 29.7036 35.1187 26.7192C36.8333 23.7349 37.6931 20.1306 37.6931 15.8966C37.6931 12.6623 36.6434 10.0228 34.5438 7.97328C32.4443 5.92372 29.5099 4.89894 25.7457 4.89894C21.5466 4.89894 18.1374 6.24865 15.5229 8.94807C12.9085 11.6475 11.5988 14.8818 11.5988 18.646C11.5988 20.8805 12.2337 22.7601 13.4984 24.2947C13.9333 24.7946 14.0633 25.3295 13.8983 25.8944C13.8333 26.0594 13.7333 26.4443 13.5984 27.0442C13.4634 27.644 13.3634 28.0289 13.2984 28.1939C13.2334 28.5588 13.0635 28.8038 12.7985 28.9187C12.5336 29.0337 12.2337 29.0287 11.8987 28.8938C9.93415 28.0939 8.45947 26.7192 7.47468 24.7696C6.48989 22.8201 6 20.5456 6 17.9461Z"
					fill="currentColor"
				/>
			</svg>,
		],
		[
			"threads",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M36.4732 23.174C36.2578 23.0708 36.0391 22.9715 35.8174 22.8763C35.4315 15.7652 31.5458 11.694 25.0213 11.6523C24.9918 11.6522 24.9624 11.6522 24.9328 11.6522C21.0303 11.6522 17.7847 13.3179 15.787 16.3491L19.3753 18.8106C20.8676 16.5464 23.2097 16.0637 24.9345 16.0637C24.9545 16.0637 24.9745 16.0637 24.9942 16.0639C27.1424 16.0776 28.7635 16.7022 29.8128 17.9203C30.5763 18.8071 31.087 20.0326 31.3398 21.5791C29.4352 21.2554 27.3753 21.1559 25.1732 21.2821C18.97 21.6394 14.9821 25.2573 15.2499 30.2844C15.3858 32.8344 16.6562 35.0281 18.8268 36.4612C20.6621 37.6727 23.0258 38.2651 25.4824 38.131C28.7266 37.9531 31.2716 36.7154 33.0471 34.4521C34.3956 32.7333 35.2484 30.506 35.625 27.6995C37.1711 28.6326 38.3169 29.8604 38.9497 31.3365C40.0258 33.8456 40.0885 37.9687 36.7242 41.3302C33.7766 44.275 30.2333 45.549 24.8785 45.5883C18.9386 45.5443 14.4463 43.6393 11.5255 39.9263C8.79049 36.4495 7.37701 31.4276 7.32427 25C7.37701 18.5723 8.79049 13.5504 11.5255 10.0736C14.4463 6.36065 18.9385 4.45573 24.8784 4.41159C30.8615 4.45607 35.432 6.37016 38.4646 10.101C39.9516 11.9306 41.0727 14.2315 41.8117 16.9141L46.0167 15.7922C45.1208 12.4902 43.7112 9.64471 41.793 7.2849C37.9052 2.50174 32.2193 0.0508198 24.8931 0H24.8638C17.5525 0.0506432 11.9302 2.51089 8.1532 7.31232C4.79216 11.585 3.05844 17.5301 3.00018 24.9824L3 25L3.00018 25.0176C3.05844 32.4698 4.79216 38.4151 8.1532 42.6878C11.9302 47.4891 17.5525 49.9495 24.8638 50H24.8931C31.3932 49.9549 35.975 48.2531 39.7495 44.482C44.6878 39.5484 44.5391 33.3643 42.9115 29.568C41.7437 26.8456 39.5174 24.6344 36.4732 23.174ZM25.2501 33.7258C22.5314 33.8789 19.7069 32.6586 19.5676 30.0448C19.4644 28.1068 20.9468 25.9443 25.417 25.6867C25.9289 25.6571 26.4312 25.6427 26.9247 25.6427C28.5484 25.6427 30.0674 25.8004 31.4484 26.1023C30.9333 32.5352 27.912 33.5797 25.2501 33.7258Z"
					fill="currentColor"
				/>
			</svg>,
		],
		[
			"revolut",
			<svg
				id="10375e8e-a6ec-4108-849d-17f39493c275"
				width={ICON_SIZE}
				height={ICON_SIZE}
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 50 50"
			>
				<path
					d="M5 3.95668V7.91337L17.349 7.97585L29.6772 8.03832L30.6351 8.51728C32.1553 9.26697 33.2382 10.329 33.9254 11.7243C35.1124 14.0566 34.7168 16.8055 32.9675 18.763C32.4469 19.3461 31.5306 20.075 30.9475 20.3873C29.8855 20.9496 29.8646 20.9496 24.3669 21.0537L18.8484 21.1579L18.7859 25.0729L18.7443 28.9879L23.055 34.9646C25.4082 38.2549 28.8234 42.9821 30.5935 45.4602L33.8421 49.9792L39.2982 50H44.7543L43.3798 48.0633C42.6093 47.0221 40.1937 43.6693 38.0071 40.6289C30.4269 30.1125 29.7397 29.1545 29.8438 29.0296C29.9063 28.9671 30.656 28.8005 31.489 28.6547C37.0283 27.6968 41.6722 23.3028 43.005 17.7843C43.2965 16.5973 43.359 15.7018 43.2757 13.7234C43.1716 11.4952 43.0883 10.9538 42.526 9.49604C40.8184 5.16452 37.5906 2.14494 33.0092 0.624741C31.5514 0.12495 31.5306 0.12495 18.2861 0.0624733L5 0V3.95668Z"
					fill="currentColor"
				/>
				<path
					d="M5 31.2578V50H9.58142H14.1628V31.2578V12.5156H9.58142H5V31.2578Z"
					fill="currentColor"
				/>
			</svg>,
		],
		[
			"discord",
			<svg
				id="10375e8e-a6ec-4108-849d-17f39493c275"
				width={ICON_SIZE}
				height={ICON_SIZE}
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 50 39"
			>
				<path
					d="M42.3916 3.21763C48.0385 11.5201 50.8272 20.8851 49.7847 31.6663C49.7804 31.712 49.7566 31.7538 49.7191 31.7813C45.4429 34.9213 41.2997 36.827 37.2148 38.0907C37.1829 38.1004 37.1489 38.0998 37.1174 38.0892C37.0859 38.0785 37.0586 38.0583 37.0391 38.0313C36.0954 36.7182 35.2379 35.3338 34.4866 33.8801C34.4435 33.7945 34.4829 33.6913 34.5716 33.6576C35.9335 33.1445 37.2285 32.5295 38.4741 31.8013C38.5723 31.7438 38.5785 31.6032 38.4879 31.5357C38.2235 31.3395 37.9616 31.1332 37.711 30.927C37.6641 30.8888 37.601 30.8813 37.5479 30.907C29.461 34.6413 20.6023 34.6413 12.4198 30.907C12.3667 30.8832 12.3035 30.8913 12.2579 30.9288C12.0079 31.1351 11.7454 31.3395 11.4835 31.5357C11.3929 31.6032 11.4004 31.7438 11.4992 31.8013C12.7448 32.5157 14.0398 33.1445 15.3998 33.6601C15.4879 33.6938 15.5298 33.7945 15.486 33.8801C14.751 35.3357 13.8935 36.7201 12.9323 38.0332C12.8904 38.0863 12.8217 38.1107 12.7567 38.0907C8.69105 36.827 4.54793 34.9213 0.271689 31.7813C0.236064 31.7538 0.210439 31.7101 0.206689 31.6645C-0.66456 22.3388 1.11106 12.8964 7.59293 3.21575C7.60855 3.19013 7.6323 3.17013 7.6598 3.15825C10.8492 1.69451 14.266 0.617634 17.8373 0.00263469C17.9023 -0.00736529 17.9673 0.0226347 18.001 0.0801346C18.4423 0.861383 18.9467 1.86326 19.2879 2.68201C23.0523 2.10701 26.8754 2.10701 30.7185 2.68201C31.0598 1.88076 31.5466 0.861383 31.986 0.0801346C32.0017 0.0516095 32.0259 0.0287567 32.0553 0.0148389C32.0847 0.000921072 32.1178 -0.00335026 32.1498 0.00263469C35.7229 0.619509 39.1397 1.69638 42.3266 3.15825C42.3547 3.17013 42.3779 3.19013 42.3916 3.21763ZM21.2017 20.9488C21.241 18.192 19.231 15.9107 16.7079 15.9107C14.2054 15.9107 12.2148 18.172 12.2148 20.9488C12.2148 23.7251 14.2448 25.9863 16.7079 25.9863C19.211 25.9863 21.2017 23.7251 21.2017 20.9488ZM37.8154 20.9488C37.8547 18.192 35.8448 15.9107 33.3223 15.9107C30.8191 15.9107 28.8285 18.172 28.8285 20.9488C28.8285 23.7251 30.8585 25.9863 33.3223 25.9863C35.8448 25.9863 37.8154 23.7251 37.8154 20.9488Z"
					fill="black"
				/>
			</svg>,
		],
		[
			"venmo",
			<svg
				id="10375e8e-a6ec-4108-849d-17f39493c275"
				width={ICON_SIZE}
				height={ICON_SIZE}
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 48 50"
			>
				<mask id="path-1-inside-1_4968_2498" fill="white">
					<path
						fill-rule="evenodd"
						clip-rule="evenodd"
						d="M47.361 9.97757C47.361 6.05381 46.5762 3.02691 44.6704 0L28.9753 3.13901C29.9843 5.26906 30.657 7.84753 30.657 11.5471C30.657 18.3856 25.8363 28.3632 21.9126 34.6413L17.7646 1.00897L0.5 2.69058L8.45964 50H28.0785C36.7108 38.565 47.361 22.4215 47.361 9.97757Z"
					/>
				</mask>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M47.361 9.97757C47.361 6.05381 46.5762 3.02691 44.6704 0L28.9753 3.13901C29.9843 5.26906 30.657 7.84753 30.657 11.5471C30.657 18.3856 25.8363 28.3632 21.9126 34.6413L17.7646 1.00897L0.5 2.69058L8.45964 50H28.0785C36.7108 38.565 47.361 22.4215 47.361 9.97757Z"
					fill="black"
				/>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M47.361 9.97757C47.361 6.05381 46.5762 3.02691 44.6704 0L28.9753 3.13901C29.9843 5.26906 30.657 7.84753 30.657 11.5471C30.657 18.3856 25.8363 28.3632 21.9126 34.6413L17.7646 1.00897L0.5 2.69058L8.45964 50H28.0785C36.7108 38.565 47.361 22.4215 47.361 9.97757Z"
					fill="black"
					fill-opacity="0.2"
				/>
				<path
					d="M44.6704 0L45.5166 -0.532813L45.1497 -1.11566L44.4743 -0.980581L44.6704 0ZM28.9753 3.13901L28.7792 2.15843L27.5233 2.40961L28.0716 3.5671L28.9753 3.13901ZM21.9126 34.6413L20.9201 34.7637L21.2654 37.5635L22.7606 35.1713L21.9126 34.6413ZM17.7646 1.00897L18.7571 0.886564L18.6377 -0.0808109L17.6676 0.0136805L17.7646 1.00897ZM0.5 2.69058L0.403056 1.69529L-0.664022 1.79923L-0.48614 2.8565L0.5 2.69058ZM8.45964 50L7.4735 50.1659L7.61383 51H8.45964V50ZM28.0785 50V51H28.5765L28.8766 50.6025L28.0785 50ZM43.8242 0.532813C45.6154 3.37769 46.361 6.2139 46.361 9.97757H48.361C48.361 5.89371 47.5371 2.67613 45.5166 -0.532813L43.8242 0.532813ZM29.1715 4.11959L44.8665 0.980581L44.4743 -0.980581L28.7792 2.15843L29.1715 4.11959ZM31.657 11.5471C31.657 7.71357 30.9572 4.98697 29.8791 2.71092L28.0716 3.5671C29.0114 5.55115 29.657 7.98149 29.657 11.5471H31.657ZM22.7606 35.1713C24.7474 31.9922 26.961 27.878 28.6814 23.6839C30.3926 19.5117 31.657 15.1629 31.657 11.5471H29.657C29.657 14.7698 28.5109 18.8291 26.831 22.9249C25.16 26.9986 23.0014 31.0123 21.0646 34.1113L22.7606 35.1713ZM16.7721 1.13138L20.9201 34.7637L22.905 34.5189L18.7571 0.886564L16.7721 1.13138ZM0.596944 3.68587L17.8615 2.00426L17.6676 0.0136805L0.403056 1.69529L0.596944 3.68587ZM9.44578 49.8341L1.48614 2.52467L-0.48614 2.8565L7.4735 50.1659L9.44578 49.8341ZM28.0785 49H8.45964V51H28.0785V49ZM46.361 9.97757C46.361 15.9497 43.793 22.9191 40.0743 29.8968C36.3685 36.8506 31.5834 43.6974 27.2804 49.3975L28.8766 50.6025C33.2059 44.8676 38.062 37.9252 41.8393 30.8375C45.6038 23.7738 48.361 16.4494 48.361 9.97757H46.361Z"
					fill="black"
					mask="url(#path-1-inside-1_4968_2498)"
				/>
			</svg>,
		],
		[
			"twitch",
			<svg
				id="10375e8e-a6ec-4108-849d-17f39493c275"
				width={ICON_SIZE}
				height={ICON_SIZE}
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 48 50"
			>
				<path
					fill-rule="evenodd"
					clip-rule="evenodd"
					d="M34.7667 43.4667H24.9833L18.4667 50H11.95V43.4667H0V8.7L3.25 0H47.8V30.4333L34.7667 43.4667ZM43.4667 28.2667V4.35H7.6V35.8667H17.3833V42.3833L23.9 35.8667H35.85L43.4667 28.2667Z"
					fill="black"
				/>
				<path
					d="M31.5008 13.0498V26.0998H35.8508V13.0498H31.5008ZM19.5508 26.0831H23.9008V13.0498H19.5508V26.0831Z"
					fill="black"
				/>
			</svg>,
		],
		[
			AVAILABLE_ICONS.PAYPAL,
			<svg
				id="10375e8e-a6ec-4108-849d-17f39493c275"
				width={ICON_SIZE}
				height={ICON_SIZE}
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 50 50"
			>
				<path
					d="M40.077 3.77019C37.7618 1.13133 33.5767 0 28.2229 0H12.6844C11.589 0 10.6582 0.796637 10.4867 1.8768L4.0168 42.9105C3.88817 43.7196 4.51469 44.4526 5.33484 44.4526H14.9277L17.3369 29.1713L17.2623 29.6498C17.4338 28.5697 18.3576 27.773 19.4516 27.773H24.0102C32.9654 27.773 39.9775 24.1356 42.0258 13.6134C42.0866 13.3022 42.1392 12.9993 42.1848 12.7033C41.9262 12.5664 41.9262 12.5664 42.1848 12.7033C42.7947 8.81418 42.1807 6.16702 40.077 3.77019Z"
					fill="currentColor"
					fillOpacity="0.8"
				/>
				<path
					d="M42.0252 13.6132C39.9769 24.134 32.9648 27.7728 24.0095 27.7728H19.4496C18.3556 27.7728 17.4318 28.5695 17.2617 29.6496L14.2646 48.65C14.1526 49.3581 14.7002 49.9998 15.4167 49.9998H23.5034C24.4604 49.9998 25.275 49.3028 25.4244 48.3581L25.5032 47.946L27.0274 38.2868L27.1256 37.7529C27.2749 36.8083 28.0895 36.1112 29.0466 36.1112H30.2568C38.0904 36.1112 44.2242 32.9288 46.0166 23.7246C46.7649 19.8784 46.3776 16.6669 44.3985 14.4112C43.7982 13.728 43.0528 13.1637 42.1842 12.7031C42.1372 13.0005 42.086 13.302 42.0252 13.6132Z"
					fill="currentColor"
				/>
				<path
					d="M40.0411 11.8491C39.7285 11.7578 39.4063 11.6748 39.0744 11.6015C38.7424 11.5282 38.3994 11.4632 38.0481 11.4065C36.8172 11.2073 35.4729 11.1133 34.029 11.1133H21.8485C21.5484 11.1133 21.2635 11.1811 21.009 11.3041C20.4461 11.5738 20.0298 12.1049 19.9274 12.7563L17.3384 29.1718L17.2637 29.6503C17.4338 28.5701 18.3577 27.7735 19.4517 27.7735H24.0116C32.9668 27.7735 39.9789 24.1361 42.0272 13.6138C42.088 13.3026 42.1392 13.0011 42.1862 12.7038C41.6676 12.4299 41.1061 12.1934 40.5017 11.9929C40.3509 11.9431 40.1974 11.8947 40.0411 11.8491Z"
					fill="currentColor"
				/>
			</svg>,
		],
		[
			AVAILABLE_ICONS.GOOGLE_REVIEW,
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 50 50"
			>
				<g clipPath="url(#clip0_4968_2470)">
					<path
						d="M49.2623 21.1473L49.01 20.077H25.7467V29.923H39.6462C38.2031 36.7757 31.5067 40.3828 26.0368 40.3828C22.0569 40.3828 17.8616 38.7087 15.0848 36.0179C13.6198 34.5755 12.4536 32.8583 11.6531 30.9646C10.8526 29.071 10.4334 27.038 10.4196 24.9821C10.4196 20.8348 12.2835 16.6864 14.9955 13.9576C17.7076 11.2288 21.8036 9.70201 25.8761 9.70201C30.5402 9.70201 33.8828 12.1786 35.1328 13.308L42.1295 6.34821C40.077 4.54464 34.4386 0 25.6507 0C18.8705 0 12.3694 2.5971 7.61719 7.33371C2.92745 11.9978 0.5 18.7422 0.5 25C0.5 31.2578 2.79688 37.6652 7.34152 42.3661C12.1975 47.3795 19.0748 50 26.1562 50C32.5993 50 38.7065 47.4754 43.0592 42.8951C47.3382 38.3862 49.5513 32.1473 49.5513 25.6071C49.5513 22.8538 49.2746 21.2188 49.2623 21.1473Z"
						fill="currentColor"
					/>
				</g>
				<defs>
					<clipPath id="clip0_4968_2470">
						<rect width="50" height="50" fill="white" />
					</clipPath>
				</defs>
			</svg>,
		],
		[
			AVAILABLE_ICONS.CALENDLY,
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 50 50"
			>
				<g clipPath="url(#clip0_4968_2530)">
					<path
						d="M33.6265 32.4223C32.0395 33.8306 30.0575 35.5822 26.4638 35.5822H24.3148C21.7144 35.5822 19.348 34.6382 17.6564 32.9254C16.0023 31.2502 15.0913 28.959 15.0913 26.4715V23.5314C15.0913 21.0439 16.0023 18.7527 17.6564 17.0787C19.348 15.3659 21.7144 14.4219 24.3148 14.4219H26.4638C30.0622 14.4219 32.0395 16.1723 33.6265 17.5806C35.2747 19.0337 36.696 20.3021 40.4872 20.3021C41.0656 20.3021 41.6428 20.2563 42.2141 20.1646L42.2 20.1305C41.9743 19.5674 41.7074 19.0195 41.4041 18.4929L38.8696 14.1033C36.5443 10.0758 32.2464 7.59532 27.597 7.59532H22.5279C17.8774 7.59532 13.5795 10.0758 11.2542 14.1033L8.71964 18.4929C6.39554 22.5204 6.39554 27.4825 8.71964 31.5112L11.2542 35.8996C13.5795 39.9271 17.8774 42.4076 22.5279 42.4076H27.597C32.2464 42.4076 36.5443 39.9271 38.8696 35.8996L41.4041 31.5171C41.7074 30.9904 41.9743 30.4438 42.2 29.8795L42.2141 29.8489C41.6428 29.7525 41.0656 29.7043 40.4872 29.7032C36.696 29.7032 35.2747 30.9646 33.6265 32.4234"
						fill="currentColor"
					/>
					<path
						d="M26.4665 17.086H24.3175C20.3594 17.086 17.7578 19.9133 17.7578 23.5317V26.4718C17.7578 30.0914 20.3594 32.9175 24.3175 32.9175H26.4665C32.2338 32.9175 31.7812 27.0373 40.4899 27.0373C41.3151 27.0361 42.1392 27.1113 42.9492 27.263C43.2137 25.7676 43.2137 24.237 42.9492 22.7405C42.138 22.891 41.3151 22.9674 40.4899 22.9662C31.7777 22.9662 32.2338 17.086 26.4665 17.086Z"
						fill="currentColor"
					/>
					<path
						d="M47.9512 29.4107C46.4676 28.3245 44.7571 27.5898 42.9491 27.2606V27.3041C42.7927 28.1705 42.5494 29.0205 42.2226 29.8375C43.7167 30.0691 45.1345 30.6533 46.3583 31.5409C46.3583 31.5526 46.3512 31.5668 46.3465 31.5809C42.7128 43.346 30.227 49.9398 18.4607 46.3061C6.69439 42.6724 0.1006 30.1866 3.73548 18.4203C7.36917 6.65399 19.8538 0.0601921 31.6201 3.69507C38.6606 5.8687 44.1729 11.381 46.3465 18.4203C46.3465 18.4332 46.3536 18.4485 46.3583 18.4603C45.1345 19.3478 43.7167 19.9309 42.2226 20.1613C42.5494 20.9807 42.7927 21.8306 42.9491 22.6982C42.9479 22.7112 42.9479 22.7253 42.9491 22.7394C44.7571 22.4102 46.4676 21.6755 47.9512 20.5904C49.3771 19.5348 49.1009 18.3415 48.8846 17.6362C44.8171 4.44508 30.8277 -2.95045 17.6366 1.11586C4.44552 5.18334 -2.95119 19.1739 1.1163 32.365C5.18378 45.5549 19.1743 52.9504 32.3642 48.8841C40.2641 46.4483 46.4488 40.2636 48.8846 32.365C49.1009 31.6584 49.3771 30.4664 47.9512 29.4107Z"
						fill="currentColor"
					/>
				</g>
				<defs>
					<clipPath id="clip0_4968_2530">
						<rect width="50" height="50" fill="white" />
					</clipPath>
				</defs>
			</svg>,
		],
		[
			"vimeo",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="currentColor"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M49.9755 12.9818C49.7514 17.8374 46.3525 24.4858 39.7788 32.9271C32.9809 41.7419 27.2288 46.1493 22.5226 46.1493C19.6092 46.1493 17.1441 43.4601 15.1271 38.0816L11.0932 23.2906C9.5992 17.9121 7.99309 15.2228 6.27497 15.2228C5.90146 15.2228 4.59416 16.0072 2.35307 17.576L0 14.5505C2.44431 12.4028 4.87219 10.2363 7.28341 8.05148C10.5703 5.21281 13.0354 3.7188 14.6789 3.56938C18.5634 3.19588 20.9538 5.8478 21.8502 11.5251C22.8214 17.6506 23.4937 21.4604 23.8671 22.9545C24.9877 28.0342 26.2202 30.5741 27.5649 30.5741C28.6107 30.5741 30.1795 28.9306 32.2711 25.6438C34.3628 22.3569 35.4833 19.8544 35.6326 18.1362C35.9314 15.2976 34.8109 13.8783 32.2711 13.8783C31.0758 13.8783 29.8432 14.1397 28.5733 14.6626C31.0385 6.66954 35.7447 2.78505 42.692 3.00917C47.8464 3.1586 50.2743 6.48283 49.9754 12.9819L49.9755 12.9818Z"
					fill="currentColor"
				/>
			</svg>,
		],
		[
			"snapchat",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M49.4966 37.4416C42.329 36.2615 39.1189 28.939 38.9864 28.6264L38.9714 28.5989C38.7677 28.266 38.6393 27.8925 38.5953 27.5047C38.5512 27.1168 38.5926 26.7241 38.7164 26.3539C39.1964 25.2189 40.7915 24.7139 41.844 24.3789C42.109 24.2964 42.3565 24.2164 42.5515 24.1389C44.459 23.3889 44.8465 22.6064 44.8365 22.0839C44.7865 21.759 44.6409 21.4565 44.4183 21.2147C44.1956 20.973 43.9061 20.8029 43.5865 20.7263L43.569 20.7213C43.2862 20.607 42.984 20.5484 42.679 20.5488C42.4099 20.545 42.1431 20.5987 41.8965 20.7063C41.152 21.0827 40.3407 21.3087 39.5089 21.3714C39.0288 21.3826 38.5599 21.2251 38.1839 20.9263L38.2639 19.6013L38.2739 19.4388C38.7556 16.0702 38.5515 12.639 37.6739 9.3512C36.6387 6.99035 34.9309 4.98679 32.7638 3.59068C30.5967 2.19458 28.0664 1.4678 25.4888 1.50109L24.4837 1.51359C21.9106 1.48199 19.3852 2.20892 17.2226 3.60365C15.0601 4.99838 13.3562 6.99913 12.3236 9.3562C11.4449 12.6403 11.2391 16.0682 11.7186 19.4338C11.7519 19.9322 11.7819 20.4305 11.8086 20.9288C11.394 21.2533 10.8736 21.4119 10.3486 21.3739C9.46512 21.3359 8.60035 21.1073 7.81352 20.7038C7.6208 20.6186 7.4117 20.5768 7.20102 20.5813C6.7667 20.5647 6.33804 20.6842 5.97496 20.9231C5.61188 21.162 5.33254 21.5084 5.17599 21.9139C4.97099 22.9889 6.50601 23.7714 7.44102 24.1389C7.64102 24.2189 7.88602 24.2964 8.14853 24.3789C9.20354 24.7139 10.7986 25.2189 11.2786 26.3539C11.4021 26.7241 11.4433 27.1168 11.3992 27.5046C11.3552 27.8924 11.227 28.2659 11.0236 28.5989L11.0086 28.6264C10.3181 30.1313 9.41832 31.531 8.33603 32.784C6.36977 35.2286 3.58794 36.8823 0.500929 37.4416C0.355277 37.466 0.223735 37.5432 0.131481 37.6585C0.0392269 37.7738 -0.00725875 37.9191 0.000921924 38.0666C0.00655982 38.1785 0.0319513 38.2885 0.0759228 38.3916C0.518429 39.4191 2.72346 40.2666 6.45851 40.8441C6.80851 40.8991 6.95351 41.4691 7.15852 42.3991C7.23852 42.7741 7.32352 43.1616 7.44102 43.5616C7.48006 43.7389 7.58351 43.8953 7.73132 44.0006C7.87912 44.1059 8.06076 44.1526 8.24103 44.1317C8.59803 44.1122 8.95268 44.0621 9.30104 43.9817C10.2211 43.7807 11.1594 43.6743 12.1011 43.6641C12.7788 43.6654 13.4552 43.7222 14.1236 43.8342C15.5337 44.1913 16.8452 44.8612 17.9612 45.7942C19.8447 47.4026 22.2118 48.3354 24.6862 48.4442C24.7687 48.4442 24.8537 48.4417 24.9362 48.4342C25.0362 48.4392 25.1738 48.4442 25.3138 48.4442C27.7897 48.3355 30.1585 47.4028 32.0438 45.7942C33.1581 44.8615 34.468 44.1916 35.8764 43.8342C36.544 43.7226 37.2196 43.6657 37.8964 43.6641C38.8374 43.6688 39.7755 43.7685 40.6965 43.9617C41.0459 44.0375 41.4015 44.0819 41.759 44.0942H41.819C41.9877 44.1076 42.1556 44.0592 42.2913 43.958C42.427 43.8568 42.5212 43.7097 42.5565 43.5441C42.6655 43.1627 42.7606 42.7775 42.8415 42.3891C43.044 41.4616 43.1915 40.8941 43.5415 40.8391C47.2765 40.2641 49.4841 39.4141 49.9191 38.3941C49.9645 38.2912 49.9916 38.1813 49.9991 38.0691C50.0073 37.9216 49.9608 37.7763 49.8685 37.661C49.7763 37.5457 49.6447 37.4685 49.4991 37.4441L49.4966 37.4416Z"
					fill="currentColor"
				/>
			</svg>,
		],
		[
			"patreon",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_2742_1809)">
					<path
						d="M31.9654 37.0714C41.9263 37.0714 50.0011 28.9966 50.0011 19.0357C50.0011 9.07487 41.9263 1 31.9654 1C22.0046 1 13.9297 9.07487 13.9297 19.0357C13.9297 28.9966 22.0046 37.0714 31.9654 37.0714Z"
						fill="currentColor"
					/>
					<path d="M0 1H8.81554V49.1152H0V1Z" fill="black" />
				</g>
				<defs>
					<clipPath id="clip0_2742_1809">
						<rect width="50" height="50" fill="white" />
					</clipPath>
				</defs>
			</svg>,
		],
		[
			"onlyFans",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_2799_1862)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M23.0446 9.2721C21.0226 8.43216 18.8555 8 16.6666 8C9.92585 8 3.84868 12.0721 1.26884 18.3175C-1.31037 24.5629 0.115574 31.7514 4.88187 36.5315C9.64816 41.3115 16.8167 42.7412 23.0446 40.1545C27.1272 38.4588 30.2786 35.2559 31.9652 31.3461C38.5892 30.8565 43.183 26.8802 44.6321 20.5346C44.6321 20.5346 39.6338 21.7567 35.3991 20.5346H35.3997C43.774 18.9079 48.5998 14.1841 49.9994 8H41.6301C34.4409 8 30.5752 8.38595 27.5591 12.0633C26.2146 10.8988 24.6907 9.9559 23.0446 9.2721ZM21.446 26.1918C21.5926 25.7134 21.6673 25.215 21.6668 24.713C21.6668 22.6848 20.4485 20.8567 18.5804 20.0805C16.7122 19.3044 14.5614 19.7334 13.1317 21.1675C11.702 22.6016 11.2742 24.758 12.0479 26.6318C12.8215 28.5055 14.6452 29.727 16.6672 29.727H16.6666C17.3233 29.7276 17.9737 29.5987 18.581 29.3473C19.1883 29.0959 19.7393 28.7263 20.2039 28.2604C20.6686 27.7944 21.0364 27.2415 21.2878 26.633C21.3391 26.5084 21.3853 26.382 21.4264 26.2541L21.446 26.1918Z"
						fill="currentColor"
					/>
				</g>
				<defs>
					<clipPath id="clip0_2799_1862">
						<rect width="50" height="50" fill="white" />
					</clipPath>
				</defs>
			</svg>,
		],
		[
			"appStore",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_3118_3340)">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M12 0C5.37258 0 0 5.37258 0 12V38C0 44.6274 5.37258 50 12 50H38C44.6274 50 50 44.6274 50 38V12C50 5.37258 44.6274 0 38 0H12ZM15.8879 37.0475C15.7345 37.3092 15.5149 37.5259 15.2512 37.6757C14.9875 37.8256 14.689 37.9034 14.3856 37.9013C14.0765 37.904 13.7728 37.8205 13.5084 37.6603C13.3116 37.5462 13.1392 37.3944 13.0012 37.2136C12.8632 37.0327 12.7623 36.8264 12.7042 36.6065C12.6462 36.3865 12.6321 36.1573 12.6628 35.9319C12.6936 35.7065 12.7686 35.4894 12.8834 35.2931L14.5899 32.456C14.6761 32.3096 14.7992 32.1883 14.9468 32.1041C15.0944 32.0199 15.2615 31.9758 15.4314 31.9761H15.6836C16.9214 31.9761 17.7874 32.7205 18.0397 33.4415L15.8879 37.0475ZM30.3354 31.4672L19.1602 31.4795H11.7327C11.4991 31.4804 11.2676 31.434 11.0524 31.3428C10.8373 31.2517 10.6428 31.1177 10.481 30.9492C10.3191 30.7806 10.1931 30.581 10.1108 30.3623C10.0284 30.1436 9.99129 29.9105 10.0017 29.677C10.0374 28.7395 10.8555 28.0297 11.7874 28.0297H17.1714L23.5542 17.1647L21.4872 13.6435C21.0218 12.8411 21.2283 11.783 22.0263 11.2786C22.223 11.1513 22.4434 11.0652 22.6743 11.0253C22.9052 10.9855 23.1417 10.9927 23.3697 11.0466C23.5977 11.1005 23.8125 11.2 24.0011 11.339C24.1897 11.478 24.3482 11.6537 24.4671 11.8556L25.572 13.7429H25.5843L26.6903 11.8556C26.8094 11.6548 26.9677 11.48 27.1557 11.3417C27.3438 11.2033 27.5578 11.1043 27.785 11.0505C28.0121 10.9966 28.2478 10.9891 28.4779 11.0282C28.7081 11.0674 28.928 11.1526 29.1245 11.2786C29.918 11.783 30.1223 12.8411 29.6535 13.6469L27.5865 17.1681L25.5776 20.5933L21.2149 28.033V28.0453H27.6446C28.4504 28.0453 29.4604 28.4783 29.8689 29.1748L29.9046 29.2473C30.2651 29.86 30.4694 30.2808 30.4694 30.8935C30.4635 31.0925 30.4191 31.2884 30.3388 31.4705L30.3354 31.4672ZM39.0129 31.4795H35.9872V31.4917L38.1993 35.254C38.4372 35.6503 38.51 36.124 38.4021 36.5734C38.2942 37.0228 38.0141 37.4119 37.6223 37.6569C37.3506 37.8225 37.0386 37.9102 36.7205 37.9103C36.418 37.9101 36.1207 37.8317 35.8574 37.6827C35.5942 37.5337 35.374 37.3191 35.2182 37.0598L31.9493 31.4951L29.918 28.0353L27.2975 23.5554C26.9179 22.9157 26.7116 22.1881 26.6989 21.4444C26.6862 20.7007 26.8675 19.9666 27.2249 19.3143C27.7428 18.4002 28.139 18.1603 28.139 18.1603L33.9682 28.0196H38.9805C39.918 28.0196 40.7227 28.7406 40.7662 29.6658C40.7753 29.9011 40.7366 30.1357 40.6527 30.3556C40.5688 30.5756 40.4412 30.7762 40.2778 30.9456C40.1143 31.115 39.9183 31.2496 39.7015 31.3414C39.4847 31.4331 39.2516 31.4801 39.0162 31.4795H39.0129Z"
						fill="currentColor"
					/>
				</g>
				<defs>
					<clipPath id="clip0_3118_3340">
						<rect width="50" height="50" fill="white" />
					</clipPath>
				</defs>
			</svg>,
		],
		[
			"googlePlay",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M26.5007 22.5L33.5007 15L6.33398 0.333333C6.16732 0.166667 5.83398 0.166667 5.33398 0L26.5007 22.5Z"
					fill="currentColor"
				/>
				<path
					d="M36.4994 33.3327L46.3327 27.9993C47.4993 27.3327 48.166 26.3327 48.166 24.9993C48.166 23.666 47.4993 22.4993 46.3327 21.9993L36.4994 16.666L28.666 24.9993L36.4994 33.3327Z"
					fill="currentColor"
				/>
				<path
					d="M2.16667 1.5C1.66667 2 1.5 2.66667 1.5 3.33333V46.6667C1.5 47.3333 1.66667 48 2.16667 48.6667L24.1667 25L2.16667 1.5Z"
					fill="currentColor"
				/>
				<path
					d="M26.5007 27.5L5.33398 50C5.66732 50 6.00065 49.8333 6.33398 49.6667L33.5007 35L26.5007 27.5Z"
					fill="currentColor"
				/>
			</svg>,
		],
		[
			"linkedin",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_1561_2141)">
					<g clipPath="url(#clip1_1561_2141)">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M3.69531 0C1.65508 0 0 1.60469 0 3.58164V46.4195C0 48.3967 1.65527 50 3.69531 50H46.3047C48.3457 50 50 48.3965 50 46.4189V3.58164C50 1.60469 48.3457 0 46.3047 0H3.69531ZM15.1945 19.3332V41.8433H7.7125V19.3332H15.1945ZM15.6877 12.3717C15.6877 14.5318 14.0637 16.2603 11.4551 16.2603L11.4545 16.2601H11.4061C8.89492 16.2601 7.27148 14.5316 7.27148 12.3715C7.27148 10.1623 8.94394 8.48203 11.5047 8.48203C14.0637 8.48203 15.6389 10.1623 15.6877 12.3717ZM26.8174 41.8433H19.3359L19.3357 41.8441C19.3357 41.8441 19.434 21.4457 19.3363 19.334H26.818V22.5202C27.8125 20.9867 29.5925 18.8055 33.5611 18.8055C38.4836 18.8055 42.1742 22.0228 42.1742 28.9367V41.8433H34.693V29.8023C34.693 26.776 33.6096 24.7119 30.9029 24.7119C28.8355 24.7119 27.6045 26.1039 27.0639 27.4486C26.8662 27.9285 26.8174 28.6021 26.8174 29.274V41.8433Z"
							fill="currentColor"
						/>
					</g>
				</g>
				<defs>
					<clipPath id="clip0_1561_2141">
						<rect width="50" height="50" fill="white" />
					</clipPath>
					<clipPath id="clip1_1561_2141">
						<rect width="50" height="50" fill="white" />
					</clipPath>
				</defs>
			</svg>,
		],
		[
			"tiktok",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M46.9394 20.6657V11.8894C35.3017 11.4081 35.0163 0.984951 35.0163 0.00447083V0H26.0752V34.1024C26.0752 37.9773 22.8959 41.1129 18.9928 41.1077C15.0907 41.1077 11.9227 37.9667 11.9272 34.0884C11.9296 30.2134 15.1269 27.0769 19.0283 27.0769C19.7217 27.0769 20.3994 27.1804 21.1084 27.3839V18.3343C12.3105 17.2013 4.273 23.3425 3.13548 32.0499C1.99628 40.7575 8.1665 48.7328 16.9351 49.8661C25.7016 50.9957 33.7477 44.8517 34.8852 36.1495C35.0094 35.2084 35.0163 34.3409 35.0163 33.4357V16.6109C39.1309 20.3447 46.9394 20.6657 46.9394 20.6657Z"
					fill="currentColor"
				/>
			</svg>,
		],
		[
			"youtube",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M26.1077 42.5415L15.8497 42.3539C12.5283 42.2885 9.19872 42.419 5.94252 41.7417C0.98907 40.7298 0.63815 35.7681 0.27095 31.6061C-0.235015 25.755 -0.0391407 19.7976 0.91568 13.9953C1.45471 10.7396 3.576 8.7969 6.85651 8.5855C17.9306 7.81828 29.0784 7.90921 40.128 8.26714C41.2949 8.29995 42.4699 8.47929 43.6206 8.68343C49.3007 9.67908 49.4392 15.3018 49.8074 20.0351C50.1746 24.8172 50.0196 29.6239 49.3177 34.3734C48.7547 38.3059 47.6774 41.6037 43.1309 41.9221C37.4346 42.3384 31.869 42.6735 26.1566 42.5668C26.1568 42.5415 26.124 42.5415 26.1077 42.5415ZM20.077 32.5855C24.3697 30.1208 28.5804 27.6972 32.8486 25.249C28.5479 22.7843 24.3451 20.3607 20.077 17.9125V32.5855Z"
					fill="currentColor"
				/>
				<path
					d="M26.1077 42.5415L15.8497 42.3539C12.5283 42.2885 9.19872 42.419 5.94252 41.7417C0.98907 40.7298 0.63815 35.7681 0.27095 31.6061C-0.235015 25.755 -0.0391407 19.7976 0.91568 13.9953C1.45471 10.7396 3.576 8.7969 6.85651 8.5855C17.9306 7.81828 29.0784 7.90921 40.128 8.26714C41.2949 8.29995 42.4699 8.47929 43.6206 8.68343C49.3007 9.67908 49.4392 15.3018 49.8074 20.0351C50.1746 24.8172 50.0196 29.6239 49.3177 34.3734C48.7547 38.3059 47.6774 41.6037 43.1309 41.9221C37.4346 42.3384 31.869 42.6735 26.1566 42.5668C26.1568 42.5415 26.124 42.5415 26.1077 42.5415ZM20.077 32.5855C24.3697 30.1208 28.5804 27.6972 32.8486 25.249C28.5479 22.7843 24.3451 20.3607 20.077 17.9125V32.5855Z"
					fill="currentColor"
				/>
			</svg>,
		],
		[
			"phone_overlay",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M42.3232 42.9751L42.3233 42.9752C42.916 44.0012 42.5027 45.4525 41.27 46.1646C41.27 46.1646 41.2699 46.1646 41.2699 46.1646L36.6952 48.8056L36.6952 48.8056C34.991 49.7896 32.9856 49.6805 30.8014 48.7764C28.6134 47.8707 26.3139 46.1916 24.1092 44.1587C19.7019 40.0949 15.7844 34.7217 14.0347 31.6911L13.6017 31.9411L14.0347 31.6911C12.2852 28.6611 9.59052 22.5818 8.27468 16.7329C7.61643 13.807 7.31198 10.9759 7.62161 8.62812C7.93071 6.28438 8.83895 4.49295 10.5433 3.50898C10.5433 3.50898 10.5433 3.50898 10.5433 3.50898L15.1181 0.867951L15.1183 0.867836C16.3502 0.155869 17.8133 0.522758 18.4068 1.55044L23.3489 10.1106L23.349 10.1107C23.9423 11.1382 23.5286 12.5887 22.2958 13.3003L22.2957 13.3003L17.9185 15.8278L17.6504 15.9827L17.6695 16.2917C17.8755 19.6264 19.3901 23.7007 21.5112 27.3742C23.6324 31.0478 26.404 34.3965 29.1886 36.2428L29.4468 36.4139L29.715 36.2591L34.0922 33.7316C35.3241 33.0203 36.7879 33.3881 37.3809 34.4148C37.381 34.4148 37.381 34.4149 37.381 34.4149L42.3232 42.9751Z"
					stroke="black"
					strokeOpacity="0.2"
				/>
			</svg>,
		],
		[
			"email_overlay",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<mask id="path-1-inside-1_1561_2192" fill="white">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M49.5685 11.7614C48.6812 9.55648 46.5224 8 44 8H6C3.5182 8 1.38833 9.50681 0.475344 11.6555L25.123 24.562L49.5685 11.7614ZM25.6219 28.7254C25.8042 28.6889 25.9844 28.6261 26.1574 28.5355L50 16.0506V36C50 39.3137 47.3137 42 44 42H6C2.68629 42 0 39.3137 0 36V15.9218L24.1562 28.5709C24.6259 28.8169 25.1486 28.8577 25.6219 28.7254Z"
					/>
				</mask>
				<path
					d="M49.5685 11.7614L50.0323 12.6473L50.834 12.2275L50.4962 11.3881L49.5685 11.7614ZM0.475344 11.6555L-0.445018 11.2644L-0.805776 12.1134L0.0114557 12.5414L0.475344 11.6555ZM25.123 24.562L24.6591 25.4478L25.123 25.6908L25.5869 25.4478L25.123 24.562ZM25.6219 28.7254L25.4254 27.7449L25.3887 27.7523L25.3528 27.7623L25.6219 28.7254ZM26.1574 28.5355L26.6213 29.4214V29.4214L26.1574 28.5355ZM50 16.0506H51V14.3982L49.5361 15.1647L50 16.0506ZM0 15.9218L0.463888 15.0359L-1 14.2693V15.9218H0ZM24.1562 28.5709L24.6201 27.685L24.1562 28.5709ZM50.4962 11.3881C49.4618 8.81751 46.9443 7 44 7V9C46.1004 9 47.9006 10.2954 48.6407 12.1347L50.4962 11.3881ZM44 7H6V9H44V7ZM6 7C3.103 7 0.619284 8.75963 -0.445018 11.2644L1.39571 12.0466C2.15738 10.254 3.9334 9 6 9V7ZM0.0114557 12.5414L24.6591 25.4478L25.5869 23.6761L0.939232 10.7696L0.0114557 12.5414ZM49.1046 10.8755L24.6591 23.6761L25.5869 25.4478L50.0323 12.6473L49.1046 10.8755ZM25.8185 29.7059C26.0929 29.6509 26.3632 29.5565 26.6213 29.4214L25.6935 27.6496C25.6055 27.6957 25.5154 27.7269 25.4254 27.7449L25.8185 29.7059ZM26.6213 29.4214L50.4639 16.9365L49.5361 15.1647L25.6935 27.6496L26.6213 29.4214ZM51 36V16.0506H49V36H51ZM44 43C47.866 43 51 39.866 51 36H49C49 38.7614 46.7614 41 44 41V43ZM6 43H44V41H6V43ZM-1 36C-1 39.866 2.13401 43 6 43V41C3.23858 41 1 38.7614 1 36H-1ZM-1 15.9218V36H1V15.9218H-1ZM24.6201 27.685L0.463888 15.0359L-0.463888 16.8077L23.6923 29.4568L24.6201 27.685ZM25.3528 27.7623C25.115 27.8288 24.8554 27.8082 24.6201 27.685L23.6923 29.4568C24.3964 29.8255 25.1823 29.8866 25.8911 29.6885L25.3528 27.7623Z"
					fill="black"
					fillOpacity="0.2"
					mask="url(#path-1-inside-1_1561_2192)"
				/>
			</svg>,
		],
		[
			"address_overlay",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M24.5 0.5C32.5114 0.5 39.0001 6.98867 39.0001 15C39.0001 19.1521 36.8761 24.0759 34.1821 28.631C31.4989 33.1677 28.2982 37.2606 26.2382 39.7317C25.3167 40.8371 23.6834 40.8371 22.7619 39.7317C20.7019 37.2606 17.5012 33.1677 14.818 28.631C12.124 24.0759 10 19.1521 10 15C10 6.98867 16.4887 0.5 24.5 0.5ZM24.5 9.50004C21.4614 9.50004 19 11.9614 19 15C19 18.0387 21.4614 20.5001 24.5 20.5001C27.5387 20.5001 30.0001 18.0387 30.0001 15C30.0001 11.9614 27.5387 9.50004 24.5 9.50004ZM7.5 47.5C7.5 46.3954 8.39543 45.5 9.5 45.5H39.5001C40.6046 45.5 41.5001 46.3954 41.5001 47.5C41.5001 48.6046 40.6046 49.5 39.5001 49.5H9.50001C8.39543 49.5 7.5 48.6046 7.5 47.5Z"
					stroke="black"
					strokeOpacity="0.2"
				/>
			</svg>,
		],
		[
			"link_overlay",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 50 50"
			>
				<defs>
					<clipPath id="clip-path">
						<rect width="50" height="50" fill="none" />
					</clipPath>
				</defs>
				<g clipPath="url(#clip-path)">
					<g opacity="0.2">
						<path d="M26.44,17.72a10.4,10.4,0,0,1,2.66,1.92l1.26,1.27a10.52,10.52,0,0,1,0,14.86L20.19,45.93a10.52,10.52,0,0,1-14.86,0L4.07,44.67a10.52,10.52,0,0,1,0-14.86l9.35-9.35A13.84,13.84,0,0,0,14,25.66l-7,7a6.46,6.46,0,0,0,0,9.12l1.26,1.26a6.46,6.46,0,0,0,9.12,0L27.49,32.89a6.46,6.46,0,0,0,0-9.12l-1.26-1.26A6.37,6.37,0,0,0,23.91,21a3.15,3.15,0,0,1,.87-1.65l1.66-1.66m-.21-1.2-2.16,2.16a4.2,4.2,0,0,0-1.22,3.09,5.4,5.4,0,0,1,2.67,1.45l1.26,1.26a5.46,5.46,0,0,1,0,7.71L16.62,42.35a5.46,5.46,0,0,1-7.71,0L7.65,41.09a5.46,5.46,0,0,1,0-7.71l7.45-7.45a12.8,12.8,0,0,1-.1-8.22,11.53,11.53,0,0,0-1.47,1.22L3.36,29.1a11.52,11.52,0,0,0,0,16.27l1.26,1.26a11.52,11.52,0,0,0,16.27,0L31.07,36.47a11.52,11.52,0,0,0,0-16.27l-1.26-1.26a11.45,11.45,0,0,0-3.58-2.42Z" />
						<path d="M37.24,1a10.44,10.44,0,0,1,7.43,3.07l1.26,1.27a10.52,10.52,0,0,1,0,14.86l-9.35,9.36a13.87,13.87,0,0,0-.53-5.2l7-7a6.46,6.46,0,0,0,0-9.12L41.79,6.94a6.45,6.45,0,0,0-9.12,0L22.5,17.11a6.37,6.37,0,0,0-1.86,4.81l0,.85,0,.78.24.05a6.4,6.4,0,0,0,1.59,2.63l1.26,1.26A6.39,6.39,0,0,0,26.1,29a3.18,3.18,0,0,1-.88,1.65l-1.66,1.66a10.34,10.34,0,0,1-2.66-1.92L19.64,29.1a10.4,10.4,0,0,1-2.49-4c-.08-.23-.15-.46-.22-.72v0h0a10.64,10.64,0,0,1-.06-5l0-.09v0q.1-.39.22-.78a10.35,10.35,0,0,1,2.54-4.14L29.81,4.07A10.43,10.43,0,0,1,37.24,1m0-1A11.47,11.47,0,0,0,29.1,3.36L18.93,13.53a11.4,11.4,0,0,0-2.78,4.54h0c-.1.3-.18.59-.25.9v0a11.65,11.65,0,0,0,.06,5.54l0,.09c.07.26.15.51.24.76a11.44,11.44,0,0,0,2.73,4.39l1.27,1.26a11.42,11.42,0,0,0,3.58,2.42l2.16-2.15a4.21,4.21,0,0,0,1.23-3.09,5.42,5.42,0,0,1-2.68-1.45l-1.26-1.26a5.41,5.41,0,0,1-1.48-2.76l-.07,0,0-.85a5.42,5.42,0,0,1,1.57-4.08L33.38,7.65a5.45,5.45,0,0,1,7.71,0l1.26,1.26a5.46,5.46,0,0,1,0,7.71l-7.45,7.45a12.79,12.79,0,0,1,.1,8.22,11.67,11.67,0,0,0,1.47-1.22L46.63,20.9a11.52,11.52,0,0,0,0-16.27L45.37,3.36A11.47,11.47,0,0,0,37.24,0Z" />
					</g>
				</g>
			</svg>,
		],
		[
			"text_overlay",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M47.5976 33.1429H2.40237C1.35169 33.1429 0.5 32.2912 0.5 31.2405V30.2802C0.5 29.2295 1.35169 28.3778 2.40237 28.3778H47.5976C48.6483 28.3778 49.5 29.2295 49.5 30.2802V31.2405C49.5 32.2919 48.6484 33.1429 47.5976 33.1429ZM47.5976 10.0963H2.40237C1.35169 10.0963 0.5 9.24459 0.5 8.19391V7.2336C0.5 6.18313 1.35147 5.33203 2.40237 5.33203H47.5976C48.6484 5.33203 49.5 6.18383 49.5 7.2336V8.19391C49.5 9.24459 48.6483 10.0963 47.5976 10.0963ZM2.40237 16.8549H37.9946C39.0451 16.8549 39.8961 17.7065 39.8961 18.7565V19.7168C39.8961 20.7674 39.0445 21.6184 37.9946 21.6184H2.40237C1.35158 21.6184 0.5 20.7666 0.5 19.7168V18.7565C0.5 17.7067 1.35158 16.8549 2.40237 16.8549ZM2.40237 39.9023H28.3915C29.4422 39.9023 30.2939 40.754 30.2939 41.8047V42.765C30.2939 43.8157 29.4422 44.6673 28.3915 44.6673H2.40237C1.35169 44.6673 0.5 43.8157 0.5 42.765V41.8047C0.5 40.754 1.35169 39.9023 2.40237 39.9023Z"
					stroke="black"
					strokeOpacity="0.2"
				/>
			</svg>,
		],
		[
			"twitter_overlay",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_3046_2123)">
					<path
						d="M1.11703 2L19.6493 26.7794L1 46.9261H5.19721L21.5246 29.2874L34.7167 46.9261H49L29.425 20.7529L46.7836 2H42.5864L27.5497 18.2449L15.4003 2H1.11703ZM7.28933 5.09167H13.8511L42.8267 43.8339H36.265L7.28933 5.09167Z"
						stroke="black"
						strokeOpacity="0.2"
					/>
				</g>
				<defs>
					<clipPath id="clip0_3046_2123">
						<rect width="50" height="50" fill="white" />
					</clipPath>
				</defs>
			</svg>,
		],
		[
			"pinterest_overlay",
			<svg
				id="adcda57d-5773-4df4-88db-b5fedb34c52e"
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g opacity="0.2">
					<path d="M26.55,1A17.18,17.18,0,0,1,38.9,5.62a14.41,14.41,0,0,1,4.79,10.83c0,5.45-1.38,10-4.11,13.51a12.46,12.46,0,0,1-10.38,5.19,7.91,7.91,0,0,1-3.75-.93,5.49,5.49,0,0,1-2.36-2.14L21.86,29.8l-.63,2.5-2,7.89a14.21,14.21,0,0,1-.61,1.8c-.24.59-.52,1.19-.83,1.79s-.58,1.07-.93,1.66-.59,1-.92,1.45-.57.83-.8,1.14l0,0-.06-.53c0-.47-.1-1.09-.15-1.84s-.06-1.43,0-2.14.06-1.46.15-2.3A18.89,18.89,0,0,1,15.37,39q.55-2.35,3.7-15.64l.08-.35L19,22.65a7.45,7.45,0,0,1-.57-1.7,8.06,8.06,0,0,1-.23-1.61v-.07l0-.72a7.44,7.44,0,0,1,1.42-4.68,3.84,3.84,0,0,1,3.13-1.73,2.55,2.55,0,0,1,2.11.87,3.62,3.62,0,0,1,.79,2.43A10.81,10.81,0,0,1,25.2,18c-.28,1.1-.65,2.37-1.11,3.79s-.82,2.69-1,3.61a5.29,5.29,0,0,0,1.08,4.76,5.51,5.51,0,0,0,4.44,2c3,0,5.49-1.67,7.39-5A22.46,22.46,0,0,0,38.69,15.9a11.6,11.6,0,0,0-3.45-8.64C33,5,29.76,3.9,25.75,3.9A14.63,14.63,0,0,0,10.6,18.65,9.61,9.61,0,0,0,12.74,25a.63.63,0,0,1,.2.63,10.92,10.92,0,0,0-.32,1.24,9.34,9.34,0,0,1-.25,1l0,.09V28l0,0a7.33,7.33,0,0,1-3.91-3.65A14,14,0,0,1,7,17.95a14.81,14.81,0,0,1,1.24-5.85,18.93,18.93,0,0,1,3.61-5.46A17.25,17.25,0,0,1,18,2.57,22.44,22.44,0,0,1,26.55,1m0-1a23.33,23.33,0,0,0-8.92,1.65,18.15,18.15,0,0,0-6.5,4.3,19.84,19.84,0,0,0-3.8,5.75A15.74,15.74,0,0,0,6,17.95a15,15,0,0,0,1.47,6.82,8.36,8.36,0,0,0,4.42,4.12,1.35,1.35,0,0,0,.5.11,1,1,0,0,0,.4-.08.9.9,0,0,0,.5-.72A10.34,10.34,0,0,0,13.6,27a10.33,10.33,0,0,1,.3-1.15,1.63,1.63,0,0,0-.4-1.6,8.58,8.58,0,0,1-1.9-5.65,13.45,13.45,0,0,1,3.92-9.7,13.6,13.6,0,0,1,10.22-4q5.65,0,8.8,3.07a10.58,10.58,0,0,1,3.15,7.92,21.38,21.38,0,0,1-2.57,10.82q-2.57,4.48-6.52,4.47a4.53,4.53,0,0,1-3.67-1.65,4.32,4.32,0,0,1-.87-3.9q.3-1.35,1-3.52t1.12-3.85a11.75,11.75,0,0,0,.42-2.82,4.61,4.61,0,0,0-1-3.07,3.55,3.55,0,0,0-2.87-1.22,4.82,4.82,0,0,0-3.92,2.12,8.49,8.49,0,0,0-1.62,5.32l.05.75a9,9,0,0,0,.25,1.82,8.41,8.41,0,0,0,.65,1.92q-3.15,13.29-3.7,15.65a19.81,19.81,0,0,0-.37,2.4c-.09.86-.14,1.66-.15,2.37s0,1.46.05,2.22.1,1.39.15,1.87.1.94.15,1.37.07.66.07.7a.36.36,0,0,0,.3.3h.1a.36.36,0,0,0,.3-.16l.3-.4c.2-.23.41-.51.65-.82s.51-.71.82-1.17.63-1,.95-1.5.63-1.1.95-1.7.61-1.22.87-1.87a15.3,15.3,0,0,0,.65-1.92l2-7.9A6.43,6.43,0,0,0,25,35.09a8.86,8.86,0,0,0,4.22,1,13.52,13.52,0,0,0,11.17-5.57Q44.69,25,44.69,16.45A15.49,15.49,0,0,0,39.59,4.9a18.07,18.07,0,0,0-13-4.9Z" />
				</g>
			</svg>,
		],
		[
			"threads_overlay",
			<svg
				id="10375e8e-a6ec-4108-849d-17f39493c275"
				width={ICON_SIZE}
				height={ICON_SIZE}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 50 50"
			>
				<g opacity="0.2">
					<path d="M24.89,1C31.9,1,37.33,3.38,41,7.92a21.39,21.39,0,0,1,3.75,7.17l-2.28.61a18.89,18.89,0,0,0-3.25-6.23c-3.23-4-8.06-6-14.37-6.06s-11,2.08-14.13,6C7.86,13.11,6.38,18.34,6.32,25s1.54,11.88,4.42,15.54c3.12,4,7.87,6,14.15,6,5.64,0,9.39-1.4,12.55-4.55a10.07,10.07,0,0,0,2.44-11.1,8.9,8.9,0,0,0-3.73-4.1l-1.31-.79-.2,1.51a12.6,12.6,0,0,1-2.37,6.27,8.87,8.87,0,0,1-6.83,3.3l-.63,0a9.93,9.93,0,0,1-5.42-1.52,6.78,6.78,0,0,1-3.13-5.4c-.24-4.43,3.37-7.63,9-8,.59,0,1.19-.05,1.76-.05a25.08,25.08,0,0,1,4.18.34l1.38.23-.23-1.38a8.3,8.3,0,0,0-1.76-4.15A7,7,0,0,0,25,15.06h-.07a7.49,7.49,0,0,0-5.78,2.39l-2-1.34a9.67,9.67,0,0,1,7.73-3.46H25c6,0,9.45,3.69,9.8,10.28l0,.62.57.24.62.28A11.79,11.79,0,0,1,42,30,12.53,12.53,0,0,1,39,43.77C35.47,47.35,31.1,49,24.87,49c-7,0-12.35-2.38-15.93-6.93C5.72,38,4.06,32.24,4,25S5.72,12,8.94,7.93C12.52,3.38,17.88,1,24.86,1h0M24.8,34.74h.51c4.42-.24,6.69-3,7.14-8.54l.07-.87-.85-.19a22.26,22.26,0,0,0-4.74-.48c-.51,0-1,0-1.57,0-5.21.3-6.91,3.1-6.79,5.41.15,2.73,2.71,4.64,6.23,4.64M24.89,0h0C17.55.05,11.93,2.51,8.15,7.31,4.79,11.58,3.06,17.53,3,25v0c.06,7.45,1.79,13.4,5.15,17.67,3.78,4.8,9.4,7.26,16.71,7.31h0c6.5,0,11.08-1.75,14.86-5.52a13.53,13.53,0,0,0,3.16-14.91,12.78,12.78,0,0,0-6.44-6.39l-.66-.3c-.39-7.11-4.27-11.18-10.8-11.22h-.09a10.54,10.54,0,0,0-9.15,4.7l3.59,2.46a6.36,6.36,0,0,1,5.56-2.75H25a6.1,6.1,0,0,1,4.82,1.86,7.32,7.32,0,0,1,1.53,3.66A26,26,0,0,0,27,21.23q-.89,0-1.81.05c-6.2.36-10.19,4-9.92,9a7.75,7.75,0,0,0,3.58,6.18,10.87,10.87,0,0,0,6,1.69l.68,0A9.83,9.83,0,0,0,33,34.45a13.62,13.62,0,0,0,2.58-6.75,8,8,0,0,1,3.32,3.64,9.08,9.08,0,0,1-2.23,10c-2.95,2.94-6.49,4.22-11.85,4.26-5.94,0-10.43-1.95-13.35-5.66C8.79,36.45,7.38,31.43,7.32,25s1.47-11.45,4.2-14.93c2.92-3.71,7.41-5.62,13.35-5.66s10.55,2,13.59,5.69a18.5,18.5,0,0,1,3.35,6.81L46,15.79a22.76,22.76,0,0,0-4.22-8.51C37.91,2.5,32.22.05,24.89,0Zm-.1,33.74c-2.57,0-5.1-1.23-5.23-3.69-.1-1.94,1.38-4.1,5.85-4.36q.77,0,1.51,0a21.25,21.25,0,0,1,4.52.46c-.52,6.43-3.54,7.48-6.2,7.62Z" />
				</g>
			</svg>,
		],
		[
			"revolut_overlay",
			<svg
				id="10375e8e-a6ec-4108-849d-17f39493c275"
				width={ICON_SIZE}
				height={ICON_SIZE}
				xmlns="http://www.w3.org/2000/svg"
				fill="none"
				viewBox="0 0 50 50"
			>
				<defs>
					<clipPath id="clip_revolut_0">
						<path
							transform="matrix(1,0,0,-1,0,50)"
							d="M5 46.043317V42.086629L17.34902 42.024156 29.677216 41.96168 30.635149 41.482717C32.15535 40.73303 33.23823 39.67097 33.925447 38.27572 35.11245 35.943357 34.71678 33.1945 32.96751 31.236985 32.44689 30.653893 31.53061 29.92503 30.94752 29.612662 29.885462 29.050395 29.864638 29.050395 24.366929 28.946272L18.848397 28.842148 18.785922 24.927113 18.74427 21.012078 23.054976 15.0354C25.408162 11.745106 28.823405 7.01791 30.5935 4.539776L33.842149 .020824 39.298208 0H44.754266L43.379838 1.936691C42.609327 2.977924 40.193666 6.330696 38.007078 9.371094 30.426903 19.887547 29.739689 20.84548 29.843813 20.970429 29.906287 21.032902 30.655974 21.1995 31.48896 21.345273 37.028318 22.303208 41.672216 26.697209 43.004995 32.215745 43.29654 33.40275 43.359014 34.29821 43.275716 36.27655 43.171594 38.504789 43.08829 39.04623 42.526029 40.503957 40.818407 44.835485 37.590585 47.85506 33.00916 49.37526 31.551434 49.87505 31.53061 49.87505 18.286129 49.937528L5 50V46.043317Z"
							fillRule="evenodd"
						/>
					</clipPath>
					<clipPath id="clip_revolut_1">
						<path
							transform="matrix(1,0,0,-1,0,50)"
							d="M5 18.74219V0H9.581425 14.162848V18.74219 37.48438H9.581425 5V18.74219Z"
							fillRule="evenodd"
						/>
					</clipPath>
				</defs>
				<g clipPath="url(#clip_revolut_0)">
					<path
						transform="matrix(1,0,-0,1,5,0)"
						d="M0 7.913372-.005059 8.913357-1 8.908325V7.913372H0ZM12.34902 7.975845 12.354079 6.975857H12.354087L12.34902 7.975845ZM24.677216 8.038319 24.682284 7.03833 24.915675 7.039513 25.124428 7.14389 24.677216 8.038319ZM25.635149 8.517284 25.19285 9.414169 25.187935 9.411713 25.635149 8.517284ZM28.925444 11.724281 28.034146 12.177891 28.028355 12.166134 28.925444 11.724281ZM27.96751 18.763016 27.221573 18.097 27.221856 18.096686 27.96751 18.763016ZM25.94752 20.387339 26.419747 21.26883 26.415408 21.271128 25.94752 20.387339ZM19.366929 21.053729 19.385865 22.053549 19.385794 22.05355 19.366929 21.053729ZM13.848395 21.157853 12.848522 21.141896 12.863932 20.176249 13.829531 20.15803 13.848395 21.157853ZM13.785921 25.072888 12.785963 25.062249 12.786048 25.05693 13.785921 25.072888ZM13.744271 28.987923 12.93322 29.572897 12.740829 29.306153 12.744328 28.977286 13.744271 28.987923ZM18.054976 34.9646 18.866034 34.37962 18.86836 34.382875 18.054976 34.9646ZM25.5935 45.460226 24.781537 46.04394 24.779767 46.041463 25.5935 45.460226ZM28.842146 49.979177 28.83833 50.979169 28.328047 50.97722 28.030186 50.56289 28.842146 49.979177ZM34.298208 50V51.000009L34.294389 50.999994 34.298208 50ZM39.754266 50 40.56977 49.421255 41.690176 51H39.754266V50ZM38.379838 48.06331 39.183679 47.468465 39.18959 47.476457 39.195344 47.48456 38.379838 48.06331ZM33.007078 40.628908 33.818307 40.044179 33.818929 40.04504 33.007078 40.628908ZM24.843813 29.029572 24.07559 28.389388 24.10463 28.35454 24.136706 28.322464 24.843813 29.029572ZM26.48896 28.654728 26.31658 27.669695 26.318558 27.669354 26.48896 28.654728ZM38.004995 17.784256 37.032934 17.549496 37.033857 17.545735 38.004995 17.784256ZM38.275716 13.72345 39.274637 13.676769 39.27483 13.681381 38.275716 13.72345ZM37.526029 9.496044 38.456369 9.129276 38.459028 9.136173 37.526029 9.496044ZM28.00916 .624741 27.69421 1.573902 27.684836 1.570686 28.00916 .624741ZM13.286129 .062473 13.290832-.937515H13.290846L13.286129 .062473ZM0 0H-1V-1.004711L.004702-.999989 0 0ZM1 3.956684V7.913372H-1V3.956684H1ZM.005059 6.913383 12.354079 6.975857 12.343961 8.97583-.005059 8.913357 .005059 6.913383ZM12.354087 6.975857 24.682284 7.03833 24.672148 9.038307 12.343952 8.97583 12.354087 6.975857ZM25.124428 7.14389 26.082364 7.62286 25.187935 9.411713 24.230002 8.932747 25.124428 7.14389ZM26.077443 7.620415C27.779416 8.459743 29.03047 9.674301 29.822533 11.282433L28.028355 12.166134C27.445992 10.983757 26.531283 10.074203 25.192856 9.414158L26.077443 7.620415ZM29.816666 11.270714C31.196703 13.982365 30.728428 17.174176 28.713168 19.429348L27.221856 18.096686C28.705136 16.436825 29.028197 14.130924 28.034224 12.177849L29.816666 11.270714ZM28.713448 19.429032C28.122969 20.09037 27.116135 20.89575 26.41974 21.26882L25.475298 19.50586C25.945084 19.254189 26.77082 18.601843 27.221573 18.097L28.713448 19.429032ZM26.415408 21.271128C26.159811 21.406443 25.890898 21.550362 25.566428 21.660744 25.233088 21.774144 24.878314 21.84112 24.421029 21.887282 23.543496 21.975865 22.106793 22.002017 19.385865 22.053549L19.347992 20.053908C22.124772 20.001318 23.447337 19.975407 24.220158 19.897395 24.58805 19.860257 24.781224 19.8153 24.922297 19.76731 25.072236 19.716301 25.204197 19.649369 25.479632 19.503552L26.415408 21.271128ZM19.385794 22.05355 13.867259 22.157673 13.829531 20.15803 19.348065 20.053906 19.385794 22.05355ZM14.848268 21.173808 14.785793 25.088843 12.786048 25.05693 12.848522 21.141896 14.848268 21.173808ZM14.785865 25.083525 14.744215 28.99856 12.744328 28.977286 12.785977 25.06225 14.785865 25.083525ZM14.555324 28.402949 18.866026 34.379625 17.243924 35.549573 12.93322 29.572897 14.555324 28.402949ZM18.86836 34.382875C21.206036 37.65148 24.647698 42.415639 26.407235 44.878988L24.779767 46.041463C22.999112 43.548547 19.610287 38.858308 17.241589 35.546327L18.86836 34.382875ZM26.40546 44.87651 29.654107 49.395463 28.030186 50.56289 24.78154 46.043939 26.40546 44.87651ZM28.845963 48.979185 34.30202 49.000009 34.294389 50.999994 28.83833 50.979169 28.845963 48.979185ZM34.298208 49H39.754266V51H34.298208V49ZM38.93876 50.578748 37.56433 48.642057 39.195344 47.48456 40.56977 49.421255 38.93876 50.578748ZM37.575998 48.65815C36.800298 47.60991 34.379228 44.249574 32.195226 41.21277L33.818929 40.04504C36.008104 43.08904 38.418355 46.43424 39.183679 47.468465L37.575998 48.65815ZM32.195848 41.21363C28.407853 35.95831 26.33669 33.083757 25.226452 31.508522 24.675297 30.72653 24.345458 30.24303 24.159213 29.942229 24.071785 29.801028 23.9842 29.6502 23.926146 29.50601 23.8983 29.436852 23.84942 29.30322 23.83755 29.135502 23.82414 28.946099 23.85636 28.652466 24.07559 28.389388L25.612034 29.669756C25.81825 29.422297 25.843636 29.15079 25.832556 28.99428 25.823012 28.859456 25.785624 28.769488 25.781409 28.75902 25.770617 28.732214 25.778857 28.758885 25.859656 28.88938 26.009858 29.13197 26.306059 29.56866 26.861214 30.356328 27.963595 31.920413 30.026127 34.78305 33.818307 40.044179L32.195848 41.21363ZM24.136706 28.322464C24.253329 28.205842 24.372696 28.14453 24.406533 28.12715 24.458903 28.10025 24.506422 28.080817 24.539023 28.068266 24.605282 28.04276 24.673663 28.021492 24.73178 28.004652 24.851542 27.969952 24.999114 27.933684 25.156924 27.898005 25.47635 27.825787 25.888728 27.744572 26.31658 27.669697L26.66134 29.63976C26.256207 29.710658 25.877245 29.785628 25.597966 29.848769 25.45642 29.88077 25.352795 29.906977 25.28839 29.925639 25.254422 29.93548 25.247477 29.938616 25.257525 29.934748 25.26202 29.933018 25.286213 29.923712 25.320332 29.906186 25.335915 29.898182 25.442105 29.845492 25.550919 29.73668L24.136706 28.322464ZM26.318558 27.669354C31.458065 26.780566 35.792146 22.687167 37.03294 17.549496L38.977048 18.019019C37.552289 23.918416 32.59857 28.613022 26.659363 29.640103L26.318558 27.669354ZM37.033857 17.545735C37.293684 16.487874 37.35796 15.697788 37.2766 13.765518L39.27483 13.681381C39.360067 15.705795 39.299398 16.70663 38.97613 18.022782L37.033857 17.545735ZM37.276807 13.770126C37.22446 12.650002 37.179304 12.017933 37.08759 11.49287 36.99972 10.989822 36.864397 10.559467 36.593027 9.855915L38.459028 9.136173C38.749925 9.890347 38.93738 10.459576 39.05776 11.148739 39.17429 11.815887 39.222845 12.568661 39.274625 13.676773L37.276807 13.770126ZM36.59571 9.862804C35.000577 5.816608 32.004323 3.004021 27.694228 1.573856L28.324093-.324371C33.176847 1.285858 36.636236 4.512424 38.45634 9.129284L36.59571 9.862804ZM27.684836 1.570686C27.324166 1.447029 27.115033 1.376881 26.78654 1.320324 26.439377 1.260551 25.939335 1.213581 25.02957 1.178886 23.208178 1.109428 19.915715 1.093758 13.281412 1.062466L13.290846-.937515C19.901024-.906334 23.241213-.890766 25.105786-.81966 26.039002-.784073 26.64527-.733425 27.125887-.650677 27.625174-.564716 27.96529-.447441 28.333485-.321205L27.684836 1.570686ZM13.281427 1.062466-.004702 .999989 .004702-.999989 13.290832-.937515 13.281427 1.062466ZM1 0V3.956684H-1V0H1Z"
						fillOpacity=".2"
					/>
				</g>
				<g clipPath="url(#clip_revolut_1)">
					<path
						transform="matrix(1,0,-0,1,5,12.515625)"
						d="M0 37.484376V38.484376H-1V37.484376H0ZM9.162848 37.484376H10.162848V38.484376H9.162848V37.484376ZM9.162848-.000004V-1.000004H10.162848V-.000004H9.162848ZM0-.000004H-1V-1.000004H0V-.000004ZM1 18.742186V37.484376H-1V18.742186H1ZM0 36.484376H4.581424V38.484376H0V36.484376ZM4.581424 36.484376H9.162848V38.484376H4.581424V36.484376ZM8.162848 37.484376V18.742186H10.162848V37.484376H8.162848ZM8.162848 18.742186V-.000004H10.162848V18.742186H8.162848ZM9.162848 .999996H4.581424V-1.000004H9.162848V.999996ZM4.581424 .999996H0V-1.000004H4.581424V.999996ZM1-.000004V18.742186H-1V-.000004H1Z"
						fillOpacity=".2"
					/>
				</g>
			</svg>,
		],
		[
			"vimeo_overlay",
			<svg
				id="10375e8e-a6ec-4108-849d-17f39493c275"
				width={ICON_SIZE}
				height={ICON_SIZE}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 50 50"
			>
				<g opacity="0.2">
					<path
						d="M29.3676 13.8429C30.5621 10.399 32.2044 7.84515 34.2702 6.14006C36.5164 4.28606 39.3059 3.40019 42.6759 3.50891L42.6775 3.50896C45.1433 3.58044 46.8748 4.40302 47.9749 5.90931C49.0925 7.43948 49.623 9.76117 49.476 12.9589L49.4741 12.9988C49.3586 15.3196 48.4861 18.1097 46.8131 21.3822C45.1326 24.6692 42.6593 28.4144 39.3843 32.6199L39.3829 32.6218C35.9979 37.0111 32.8906 40.2797 30.0622 42.4469C27.229 44.6178 24.7205 45.6493 22.5226 45.6493C21.2399 45.6493 20.0207 45.0638 18.8573 43.7945C17.6888 42.5198 16.5987 40.5764 15.6034 37.9276L11.5756 23.1591L11.575 23.1568C10.8238 20.4525 10.0345 18.3851 9.19741 16.9834C8.37758 15.6107 7.41705 14.7228 6.27497 14.7228C6.15195 14.7228 6.03307 14.7529 5.93742 14.7838C5.83522 14.8168 5.72451 14.8626 5.60831 14.9168C5.37581 15.0253 5.09066 15.1822 4.75712 15.3824C4.16778 15.736 3.4 16.241 2.45655 16.8946L0.683688 14.6151C3.00899 12.5689 5.31939 10.5058 7.61472 8.42601C9.24457 7.01869 10.6577 5.95614 11.8566 5.22956C13.0658 4.4967 14.0151 4.1318 14.7242 4.06733L14.7267 4.06708C16.5283 3.89386 17.9355 4.41678 19.0137 5.61296C20.1156 6.83542 20.9149 8.80702 21.3564 11.6031L21.3564 11.6034C22.3248 17.7116 23 21.5441 23.3803 23.0689C23.9428 25.6174 24.5406 27.5655 25.1821 28.8875C25.5028 29.5483 25.8476 30.0806 26.2264 30.454C26.6089 30.8309 27.0571 31.0741 27.5649 31.0741C27.9552 31.0741 28.3425 30.9224 28.7134 30.6893C29.0874 30.4542 29.4788 30.1148 29.8875 29.6867C30.7047 28.8306 31.6401 27.5666 32.6929 25.9122C34.7846 22.6253 35.9679 20.0341 36.1303 18.1843C36.2849 16.7095 36.0853 15.4898 35.4088 14.6329C34.7196 13.7599 33.6288 13.3783 32.2711 13.3783C31.3183 13.3783 30.35 13.5348 29.3676 13.8429Z"
						stroke="black"
						strokeOpacity="0.2"
					/>
				</g>
			</svg>,
		],
		[
			AVAILABLE_ICONS.PAYPAL_OVERLAY,
			<svg
				id="10375e8e-a6ec-4108-849d-17f39493c275"
				width={ICON_SIZE}
				height={ICON_SIZE}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 50 50"
			>
				<defs>
					<clipPath id="clip_paypal_0">
						<path
							transform="matrix(1,0,0,-1,0,50)"
							d="M40.077047 46.229806C37.76182 48.868665 33.57671 50 28.222926 50H12.684366C11.588991 50 10.658199 49.203367 10.486701 48.123205L4.016796 7.089508C3.888172 6.280426 4.514693 5.547409 5.334842 5.547409H14.927672L17.336945 20.828719 17.26226 20.350184C17.433758 21.430346 18.357636 22.226983 19.451628 22.226983H24.010157C32.9654 22.226983 39.977468 25.864403 42.02576 36.386644 42.086618 36.69783 42.13917 37.000719 42.18481 37.296689 41.92618 37.433614 41.92618 37.433614 42.18481 37.296689 42.794736 41.185827 42.180665 43.83298 40.077047 46.229806Z"
							fillRule="evenodd"
						/>
					</clipPath>
					<clipPath id="clip_paypal_1">
						<path
							transform="matrix(1,0,0,-1,0,50)"
							d="M39.07436 38.398504C39.406293 38.325204 39.728548 38.242219 40.041116 38.150938 40.1974 38.105298 40.350915 38.05689 40.50167 38.0071 41.106065 37.806558 41.66758 37.570055 42.186223 37.29621 42.186204 37.296087 42.18618 37.29596 42.186166 37.295835 43.05388 36.83547 43.798669 36.271524 44.39846 35.588808 46.377607 33.333055 46.764863 30.121617 46.016633 26.275357 44.224199 17.07116 38.090379 13.888763 30.256783 13.888763H29.046616C28.089547 13.888763 27.27493 13.191708 27.12556 12.247086L27.027363 11.713226 25.503243 2.054008 25.424408 1.641861C25.27504 .697239 24.460423 .000183 23.503354 .000183H15.416663C14.700244 .000183 14.152556 .641918 14.264583 1.35004L17.26165 20.35037C17.266571 20.381619 17.272124 20.412629 17.278294 20.44339L17.338356 20.828242 19.927426 37.243658C20.02977 37.895074 20.446068 38.426164 21.008969 38.695859 21.26345 38.81895 21.548359 38.88672 21.84848 38.88672H34.029C35.4729 38.88672 36.817228 38.79267 38.04814 38.593515 38.399438 38.536809 38.742429 38.4718 39.07436 38.398504Z"
							fillRule="evenodd"
						/>
					</clipPath>
				</defs>
				<g clipPath="url(#clip_paypal_0)">
					<path
						transform="matrix(1,0,0,-1,4,44.453126)"
						d="M36.077047 40.68293 35.325349 40.023424 35.325464 40.023294 36.077047 40.68293ZM6.486701 42.57633 5.499071 42.733137 5.498904 42.732076 6.486701 42.57633ZM.016796 1.542633 1.004395 1.385632 1.004592 1.386887 .016796 1.542633ZM10.927672 .000534V-.999466H11.782363L11.915471-.155205 10.927672 .000534ZM13.336945 15.281843 14.324984 15.127642 12.349146 15.437582 13.336945 15.281843ZM13.26226 14.803308 12.27422 14.957512 14.249889 14.646502 13.26226 14.803308ZM38.02576 30.839768 37.04435 31.031689 37.044187 31.030846 38.02576 30.839768ZM36.828744 41.34244C34.217355 44.318864 29.649956 45.453126 24.222926 45.453126V43.453126C29.503464 43.453126 33.30629 42.32472 35.325349 40.023424L36.828744 41.34244ZM24.222926 45.453126H8.684366V43.453126H24.222926V45.453126ZM8.684366 45.453126C7.096432 45.453126 5.747553 44.29816 5.499072 42.733137L7.47433 42.41952C7.568846 43.014818 8.081551 43.453126 8.684366 43.453126V45.453126ZM5.498904 42.732076-.971001 1.698383 1.004592 1.386887 7.474498 42.420579 5.498904 42.732076ZM-.970802 1.699638C-1.196178 .281952-.098876-.999466 1.334842-.999466V1.000534C1.128263 1.000534 .972523 1.18515 1.004394 1.385632L-.970802 1.699638ZM1.334842-.999466H10.927672V1.000534H1.334842V-.999466ZM11.915471-.155205 14.324743 15.126106 12.349146 15.437582 9.939874 .156269 11.915471-.155205ZM12.348906 15.436047 12.27422 14.957512 14.250299 14.649107 14.324984 15.127642 12.348906 15.436047ZM14.249889 14.646502C14.345068 15.245975 14.854408 15.680107 15.451628 15.680107V17.680108C13.860863 17.680108 12.522449 16.520966 12.274631 14.960115L14.249889 14.646502ZM15.451628 15.680107H20.010157V17.680108H15.451628V15.680107ZM20.010157 15.680107C24.61142 15.680107 28.83227 16.613186 32.18758 18.999136 35.564184 21.400223 37.944158 25.187062 39.007337 30.648692L37.044187 31.030846C36.05907 25.970234 33.908868 22.677243 31.02855 20.629057 28.126944 18.565737 24.36414 17.680108 20.010157 17.680108V15.680107ZM39.00717 30.647849C39.07068 30.972603 39.125524 31.288676 39.17313 31.59741L37.19649 31.902218C37.15282 31.619009 37.102556 31.329308 37.044355 31.031689L39.00717 30.647849ZM38.6527 32.633604C38.637937 32.64142 38.64347 32.63849 38.62921 32.646039 38.616796 32.65261 38.61915 32.651369 38.60724 32.65767 38.60164 32.660634 38.60229 32.66029 38.596818 32.663187 38.55714 32.684194 38.62633 32.64756 38.58678 32.668504 38.57605 32.674184 38.57806 32.67312 38.567838 32.678529 38.556276 32.68465 38.544038 32.691129 38.534498 32.696184 38.531507 32.69776 38.50819 32.710107 38.50722 32.71062 38.503526 32.712579 38.504919 32.71184 38.501348 32.71373 38.494745 32.717226 38.50233 32.71321 38.495855 32.716638 38.460584 32.735315 38.52077 32.703447 38.486005 32.72185 38.480924 32.72454 38.486604 32.721536 38.481649 32.72416 38.476026 32.727136 38.485204 32.722276 38.47961 32.72524 38.47913 32.725496 38.479104 32.725507 38.47863 32.725759 38.47854 32.725805 38.47775 32.726224 38.47767 32.726266 38.47111 32.729738 38.476903 32.72667 38.470849 32.729875 38.466585 32.732133 38.464006 32.7335 38.461759 32.734689 38.46023 32.735498 38.460504 32.73535 38.459486 32.735895 38.459318 32.73598 38.45929 32.735998 38.459154 32.73607 38.458475 32.736429 38.459566 32.73585 38.458917 32.736196 38.45875 32.73628 38.458906 32.7362 38.458776 32.736268 38.458768 32.736276 38.45876 32.736276 38.45875 32.73628 38.458749 32.736284 38.458745 32.736288 38.45874 32.736288 38.458738 32.73629 38.458734 32.73629 38.45873 32.73629 38.45873 32.736295 38.458726 32.736295 37.990839 31.852505 37.52295 30.96872 37.522954 30.968718 37.522954 30.968716 37.522958 30.968716 37.52296 30.968714 37.522966 30.968712 37.52298 30.968703 37.522974 30.968708 37.523 30.968693 37.523054 30.968663 37.523054 30.968665 37.52314 30.968617 37.523229 30.96857 37.52326 30.968556 37.523378 30.968493 37.52339 30.968485 37.52351 30.968422 37.523534 30.96841 37.52356 30.968396 37.523588 30.96838 37.523618 30.968365 37.523649 30.96835 37.523679 30.968335 37.52371 30.968317 37.523847 30.968243 37.52439 30.967957 37.524656 30.967816 37.526449 30.96687 37.524068 30.968129 37.52598 30.967114 37.529794 30.965096 37.52545 30.967394 37.52977 30.965107 37.532644 30.963589 37.531698 30.964089 37.535074 30.9623 37.55536 30.951561 37.543077 30.958064 37.571447 30.943047 37.578447 30.939339 37.5897 30.933382 37.59872 30.928605 37.61187 30.921645 37.600984 30.927409 37.61463 30.920182 37.624437 30.91499 37.62175 30.916413 37.63206 30.910954 37.673406 30.889067 37.6675 30.892193 37.716924 30.866028L38.6527 32.633604C38.637937 32.64142 38.64347 32.63849 38.62921 32.646039 38.616796 32.65261 38.61915 32.651369 38.60724 32.65767 38.60164 32.660634 38.60229 32.66029 38.596818 32.663187 38.55714 32.684194 38.62633 32.64756 38.58678 32.668504 38.57605 32.674184 38.57806 32.67312 38.567838 32.678529 38.556276 32.68465 38.544038 32.691129 38.534498 32.696184 38.531507 32.69776 38.50819 32.710107 38.50722 32.71062 38.503526 32.712579 38.504919 32.71184 38.501348 32.71373 38.494745 32.717226 38.50233 32.71321 38.495855 32.716638 38.460584 32.735315 38.52077 32.703447 38.486005 32.72185 38.480924 32.72454 38.486604 32.721536 38.481649 32.72416 38.476026 32.727136 38.485204 32.722276 38.47961 32.72524 38.47913 32.725496 38.479104 32.725507 38.47863 32.725759 38.47854 32.725805 38.47775 32.726224 38.47767 32.726266 38.47111 32.729738 38.476903 32.72667 38.470849 32.729875 38.466585 32.732133 38.464006 32.7335 38.461759 32.734689 38.46023 32.735498 38.460504 32.73535 38.459486 32.735895 38.459318 32.73598 38.45929 32.735998 38.459154 32.73607 38.458475 32.736429 38.459566 32.73585 38.458917 32.736196 38.45875 32.73628 38.458906 32.7362 38.458776 32.736268 38.458768 32.736276 38.45876 32.736276 38.45875 32.73628 38.458749 32.736284 38.458745 32.736288 38.45874 32.736288 38.458738 32.73629 38.458734 32.73629 38.45873 32.73629 38.45873 32.736295 38.458726 32.736295 37.990839 31.852505 37.52295 30.96872 37.522954 30.968718 37.522954 30.968716 37.522958 30.968716 37.52296 30.968714 37.522966 30.968712 37.52298 30.968703 37.522974 30.968708 37.523 30.968693 37.523054 30.968663 37.523054 30.968665 37.52314 30.968617 37.523229 30.96857 37.52326 30.968556 37.523378 30.968493 37.52339 30.968485 37.52351 30.968422 37.523534 30.96841 37.52356 30.968396 37.523588 30.96838 37.523618 30.968365 37.523649 30.96835 37.523679 30.968335 37.52371 30.968317 37.523847 30.968243 37.52439 30.967957 37.524656 30.967816 37.526449 30.96687 37.524068 30.968129 37.52598 30.967114 37.529794 30.965096 37.52545 30.967394 37.52977 30.965107 37.532644 30.963589 37.531698 30.964089 37.535074 30.9623 37.55536 30.951561 37.543077 30.958064 37.571447 30.943047 37.578447 30.939339 37.5897 30.933382 37.59872 30.928605 37.61187 30.921645 37.600984 30.927409 37.61463 30.920182 37.624437 30.91499 37.62175 30.916413 37.63206 30.910954 37.673406 30.889067 37.6675 30.892193 37.716924 30.866028L38.6527 32.633604ZM39.172739 31.59488C39.49042 33.62058 39.500917 35.392587 39.12198 37.004796 38.74008 38.629606 37.975984 40.035295 36.82863 41.34257L35.325464 40.023294C36.281728 38.933748 36.876474 37.817445 37.175035 36.547185 37.47656 35.264326 37.489126 33.768186 37.196889 31.904749L39.172739 31.59488Z"
						fillOpacity=".2"
					/>
				</g>
				<g clipPath="url(#clip_paypal_1)">
					<path
						transform="matrix(1,0,0,-1,14.25,50)"
						d="M25.791115 38.150938 25.510788 37.191034 25.791115 38.150938ZM26.251669 38.0071 26.566594 38.956216 26.56528 38.95665 26.251669 38.0071ZM27.936223 37.29621 28.924939 37.146409 29.031363 37.848814 28.403134 38.180517 27.936223 37.29621ZM27.936163 37.295835 26.947447 37.44564 26.841248 36.744714 27.467492 36.41246 27.936163 37.295835ZM30.148463 35.58881 30.900155 36.248327 30.89972 36.248819 30.148463 35.58881ZM31.766633 26.275357 32.74819 26.084206 32.74823 26.0844 31.766633 26.275357ZM12.87556 12.247086 13.859061 12.066183 13.861329 12.078516 13.863288 12.0909 12.87556 12.247086ZM12.777364 11.713228 11.793862 11.894131 11.791565 11.881638 11.789585 11.869089 12.777364 11.713228ZM11.253242 2.054008 12.235436 1.866138 12.238489 1.882095 12.241021 1.898148 11.253242 2.054008ZM11.174408 1.641861 10.192214 1.829731 10.189193 1.813934 10.18668 1.798046 11.174408 1.641861ZM.014583 1.35004 1.002299 1.193779 1.00237 1.194229 .014583 1.35004ZM3.011651 20.35037 3.999438 20.19456 3.999475 20.1948 3.011651 20.35037ZM3.028293 20.44339 4.008772 20.246769 4.013009 20.267895 4.016332 20.289187 3.028293 20.44339ZM3.088357 20.828242 2.100566 20.984038 2.100318 20.982445 3.088357 20.828242ZM5.677425 37.243658 6.665215 37.08786 6.665307 37.088449 5.677425 37.243658ZM6.758969 38.695859 7.191055 37.794019 7.194402 37.795637 6.758969 38.695859ZM23.79814 38.593515 23.638419 37.60635 23.638785 37.60629 23.79814 38.593515ZM26.071442 39.11084C25.73787 39.208257 25.394043 39.29679 25.039998 39.374979L24.608723 37.422029C24.918541 37.35361 25.219223 37.27618 25.510788 37.191034L26.071442 39.11084ZM26.56528 38.95665C26.405941 39.009279 26.241106 39.061296 26.071442 39.11084L25.510788 37.191034C25.653693 37.1493 25.79589 37.1045 25.938057 37.05755L26.56528 38.95665ZM28.403134 38.180517C27.831162 38.482519 27.21824 38.739995 26.566594 38.956216L25.936745 37.057985C26.493884 36.87312 27.003994 36.657594 27.46931 36.411909L28.403134 38.180517ZM28.92488 37.14603 28.924939 37.146409 26.947506 37.44602 26.947447 37.44564 28.92488 37.14603ZM30.89972 36.248819C30.208008 37.036157 29.362126 37.671319 28.404835 38.179208L27.467492 36.41246C28.245633 35.99962 28.889332 35.506887 29.397206 34.9288L30.89972 36.248819ZM32.74823 26.0844C33.522565 30.064852 33.175268 33.655237 30.900155 36.248327L29.39677 34.929296C31.079945 33.010877 31.507159 30.17838 30.785035 26.46631L32.74823 26.0844ZM16.006783 12.888765C20.047255 12.888765 23.768124 13.708103 26.73167 15.815535 29.716485 17.93809 31.812933 21.281622 32.74819 26.084206L30.78507 26.466506C29.927899 22.064896 28.061219 19.215132 25.572615 17.44544 23.062743 15.660625 19.799904 14.888765 16.006783 14.888765V12.888765ZM14.796616 12.888765H16.006783V14.888765H14.796616V12.888765ZM13.863288 12.0909C13.935911 12.550179 14.332147 12.888765 14.796616 12.888765V14.888765C13.346944 14.888765 12.113947 13.833237 11.887832 12.403271L13.863288 12.0909ZM13.760865 11.532326 13.859061 12.066183 11.892058 12.427988 11.793862 11.894131 13.760865 11.532326ZM12.241021 1.898148 13.765142 11.557367 11.789585 11.869089 10.265464 2.209869 12.241021 1.898148ZM12.156602 1.453991 12.235436 1.866138 10.271049 2.241879 10.192214 1.829731 12.156602 1.453991ZM9.253353-.999817C10.703024-.999817 11.936021 .05571 12.162136 1.485676L10.18668 1.798046C10.114057 1.338768 9.717823 1.000183 9.253353 1.000183V-.999817ZM1.166663-.999817H9.253353V1.000183H1.166663V-.999817ZM-.973133 1.506302C-1.181056 .192017-.165265-.999817 1.166663-.999817V1.000183C1.065752 1.000183 .986168 1.09182 1.002299 1.193779L-.973133 1.506302ZM2.023864 20.506182-.973204 1.505852 1.00237 1.194229 3.999438 20.19456 2.023864 20.506182ZM2.047813 20.64001C2.038914 20.595633 2.030912 20.550936 2.023826 20.505942L3.999475 20.1948C4.002232 20.212302 4.005334 20.229624 4.008772 20.246769L2.047813 20.64001ZM2.100318 20.982445 2.040254 20.597594 4.016332 20.289187 4.076396 20.674038 2.100318 20.982445ZM4.689636 37.399454 2.100568 20.984038 4.076146 20.672446 6.665214 37.08786 4.689636 37.399454ZM6.326887 39.59769C5.476593 39.190305 4.844587 38.385698 4.689543 37.398866L6.665307 37.088449C6.714954 37.404447 6.915544 37.662027 7.191052 37.794027L6.326887 39.59769ZM7.598481 39.88672C7.146429 39.88672 6.71277 39.78435 6.323536 39.59608L7.194402 37.795637C7.314131 37.85355 7.45029 37.88672 7.598481 37.88672V39.88672ZM19.778998 39.88672H7.598481V37.88672H19.778998V39.88672ZM23.95786 39.580675C22.663949 39.790029 21.26498 39.88672 19.778998 39.88672V37.88672C21.180825 37.88672 22.470505 37.795316 23.638419 37.60635L23.95786 39.580675ZM25.039998 39.374979C24.688099 39.452688 24.326273 39.521207 23.957495 39.580736L23.638785 37.60629C23.972598 37.552408 24.296757 37.49092 24.608723 37.422029L25.039998 39.374979Z"
						fillOpacity=".2"
					/>
				</g>
			</svg>,
		],
		[
			AVAILABLE_ICONS.GOOGLE_REVIEW_OVERLAY,
			<svg
				id="10375e8e-a6ec-4108-849d-17f39493c275-google-review-overlay"
				width={ICON_SIZE}
				height={ICON_SIZE}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 50 50"
			>
				<defs>
					<clipPath id="clip_google_review_0">
						<path
							transform="matrix(1,0,0,-1,0,50)"
							d="M49.262277 28.852679 49.01004 29.92299H25.74665V20.07701H39.646203C38.20312 13.224331 31.506695 9.617188 26.036829 9.617188 22.05692 9.617188 17.861605 11.291294 15.08482 13.98214 13.619786 15.424522 12.453631 17.1417 11.653114 19.035365 10.852598 20.929028 10.433441 22.961987 10.419642 25.017857 10.419642 29.165179 12.283482 33.313615 14.995535 36.04241 17.707589 38.771207 21.80357 40.29799 25.876114 40.29799 30.540177 40.29799 33.88281 37.821428 35.13281 36.691965L42.129465 43.651788C40.077009 45.455358 34.438615 50 25.650668 50 18.870535 50 12.369418 47.4029 7.617187 42.666296 2.927455 38.00223 .5 31.257813 .5 24.999999 .5 18.742186 2.796875 12.33482 7.341518 7.633926 12.197544 2.620533 19.074776-.000004 26.156249-.000004 32.599328-.000004 38.70647 2.524551 43.05915 7.104908 47.338167 11.613838 49.55134 17.852677 49.55134 24.392857 49.55134 27.146204 49.27455 28.78125 49.262277 28.852679Z"
							fillRule="evenodd"
						/>
					</clipPath>
				</defs>
				<g clipPath="url(#clip_google_review_0)">
					<path
						transform="matrix(1,0,0,-1,.5,50)"
						d="M48.762277 28.852679 49.74782 29.022068 49.742635 29.05225 49.73561 29.082056 48.762277 28.852679ZM48.51004 29.92299 49.48338 30.152369 49.301774 30.92299H48.51004V29.92299ZM25.24665 29.92299V30.92299H24.24665V29.92299H25.24665ZM25.24665 20.07701H24.24665V19.07701H25.24665V20.07701ZM39.146203 20.07701 40.12474 19.870944 40.378725 21.07701H39.146203V20.07701ZM14.58482 13.98214 13.883221 13.269524 13.888912 13.264008 14.58482 13.98214ZM9.919642 25.017857H8.91962L8.919664 25.011145 9.919642 25.017857ZM34.63281 36.691965 33.962385 35.94999 34.665864 35.314344 35.338048 35.982995 34.63281 36.691965ZM41.629465 43.651788 42.3347 42.942819 43.092908 43.697034 42.289556 44.40297 41.629465 43.651788ZM7.117187 42.666296 7.822351 41.95725 7.823128 41.958024 7.117187 42.666296ZM6.841518 7.633926 6.122563 6.938869 6.123228 6.938183 6.841518 7.633926ZM42.55915 7.104908 43.284044 6.416046 43.284509 6.416538 42.55915 7.104908ZM49.73561 29.082056 49.48338 30.152369 47.536706 29.693612 47.788938 28.623299 49.73561 29.082056ZM48.51004 30.92299H25.24665V28.92299H48.51004V30.92299ZM24.24665 29.92299V20.07701H26.24665V29.92299H24.24665ZM25.24665 19.07701H39.146203V21.07701H25.24665V19.07701ZM38.167665 20.283078C36.84756 14.014362 30.66988 10.617188 25.536829 10.617188V8.617188C31.34351 8.617188 38.558687 12.434299 40.12474 19.870944L38.167665 20.283078ZM25.536829 10.617188C21.808777 10.617188 17.86535 12.195641 15.280726 14.700272L13.888912 13.264008C16.857859 10.386948 21.30506 8.617188 25.536829 8.617188V10.617188ZM15.286396 14.694736C13.915072 16.044857 12.823508 17.652199 12.074195 19.424736L10.232035 18.645993C11.083755 16.631203 12.324501 14.804188 13.883243 13.269547L15.286396 14.694736ZM12.074195 19.424736C11.324882 21.197276 10.932536 23.100199 10.91962 25.024569L8.919664 25.011145C8.934346 22.823775 9.380314 20.66078 10.232035 18.645993L12.074195 19.424736ZM10.919642 25.017857C10.919642 28.88647 12.668449 32.78546 15.204814 35.337484L13.786256 36.747339C10.898514 33.84177 8.919642 29.443884 8.919642 25.017857H10.919642ZM15.204814 35.337484C17.703734 37.85183 21.53148 39.29799 25.376114 39.29799V41.29799C21.075659 41.29799 16.711443 39.690584 13.786256 36.747339L15.204814 35.337484ZM25.376114 39.29799C29.687487 39.29799 32.79962 37.000627 33.962385 35.94999L35.303239 37.433938C33.966 38.642229 30.392867 41.29799 25.376114 41.29799V39.29799ZM35.338048 35.982995 42.3347 42.942819 40.924226 44.360757 33.92757 37.400934 35.338048 35.982995ZM42.289556 44.40297C40.17183 46.263898 34.301969 51 25.150668 51V49C33.57526 49 38.98218 44.64682 40.969369 42.900606L42.289556 44.40297ZM25.150668 51C18.116465 51 11.358277 48.305334 6.411245 43.374567L7.823128 41.958024C12.38056 46.500474 18.624606 49 25.150668 49V51ZM6.412023 43.37534C1.512274 38.50241-1 31.492367-1 24.999999H1C1 31.023257 3.342635 37.502054 7.82235 41.95725L6.412023 43.37534ZM-1 24.999999C-1 18.508185 1.380755 11.843708 6.122564 6.938869L7.560472 8.328983C3.212996 12.825932 1 18.976189 1 24.999999H-1ZM6.123228 6.938183C11.188171 1.709103 18.335059-1.000004 25.656249-1.000004V.999996C18.814494 .999996 12.206918 3.531963 7.559808 8.32967L6.123228 6.938183ZM25.656249-1.000004C32.360048-1.000004 38.73358 1.627563 43.284044 6.416046L41.834257 7.79377C37.67936 3.421543 31.83861 .999996 25.656249 .999996V-1.000004ZM43.284509 6.416538C47.763998 11.136711 50.05134 17.633866 50.05134 24.392857H48.05134C48.05134 18.07149 45.91234 12.090965 41.83379 7.793282L43.284509 6.416538ZM50.05134 24.392857C50.05134 27.212532 49.76795 28.90497 49.74782 29.022068L47.776727 28.683287C47.78115 28.657528 48.05134 27.079876 48.05134 24.392857H50.05134Z"
						fillOpacity=".2"
					/>
				</g>
			</svg>,
		],
		[
			AVAILABLE_ICONS.CALENDLY_OVERLAY,
			<svg
				id="10375e8e-a6ec-4108-849d-17f39493c275-calendly-overlay"
				width={ICON_SIZE}
				height={ICON_SIZE}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 50 50"
			>
				<defs>
					<clipPath id="clip-path">
						<rect id="SVGID" width="50" height="50" fill="none" />
					</clipPath>
				</defs>
				<title>calendly_overlay</title>
				<g opacity="0.2">
					<g clipPath="url(#clip-path)">
						<path
							d="M33.63,32.42c-1.59,1.41-3.57,3.16-7.17,3.16H24.31a9.23,9.23,0,0,1-6.65-2.65,9.09,9.09,0,0,1-2.57-6.46V23.53a9.05,9.05,0,0,1,2.57-6.45,9.24,9.24,0,0,1,6.65-2.66h2.15c3.6,0,5.58,1.75,7.17,3.16a8.71,8.71,0,0,0,6.86,2.72,9.9,9.9,0,0,0,1.72-.14v0a13.06,13.06,0,0,0-.8-1.64L38.87,14.1A13,13,0,0,0,27.6,7.6H22.53a13,13,0,0,0-11.28,6.5L8.72,18.49a13,13,0,0,0,0,13l2.53,4.39a13,13,0,0,0,11.28,6.51H27.6A13,13,0,0,0,38.87,35.9l2.53-4.38a13.06,13.06,0,0,0,.8-1.64v0a9.91,9.91,0,0,0-1.72-.15,8.68,8.68,0,0,0-6.86,2.72"
							fill="none"
							stroke="#000"
							strokeMiterlimit="10"
						/>
						<path d="M26.47,18.09c2.2,0,3.32,1,4.73,2.23A12.24,12.24,0,0,0,40.51,24a13.82,13.82,0,0,0,1.58-.09,11.28,11.28,0,0,1,0,2.25A14.35,14.35,0,0,0,40.49,26h0a12.26,12.26,0,0,0-9.29,3.64c-1.41,1.25-2.53,2.24-4.73,2.24H24.32a5.26,5.26,0,0,1-5.56-5.45V23.53a5.26,5.26,0,0,1,5.56-5.44h2.15m0-1H24.32a6.26,6.26,0,0,0-6.56,6.44v2.94a6.27,6.27,0,0,0,6.56,6.45h2.15c5.76,0,5.31-5.88,14-5.88h0a13.26,13.26,0,0,1,2.44.22,13.19,13.19,0,0,0,0-4.52,13.35,13.35,0,0,1-2.44.23h0c-8.71,0-8.26-5.88-14-5.88Z" />
						<path d="M25,0V1A23.86,23.86,0,0,1,47.93,17.93a1.42,1.42,0,0,1-.57,1.85,11.17,11.17,0,0,1-3.64,1.76c0-.22-.11-.43-.18-.64A10.62,10.62,0,0,0,47,19.27l.63-.47-.28-.67h0a23.29,23.29,0,1,0,0,13.77l.06-.18V31l-.41-.3a10.62,10.62,0,0,0-3.41-1.63c.07-.21.13-.42.18-.64a11.35,11.35,0,0,1,3.64,1.75,1.42,1.42,0,0,1,.57,1.86A24,24,0,1,1,25,1V0m0,0a25,25,0,0,0,0,50A25.05,25.05,0,0,0,48.88,32.37a2.39,2.39,0,0,0-.93-3,12.07,12.07,0,0,0-5-2.15v0a13.17,13.17,0,0,1-.73,2.54,9.5,9.5,0,0,1,4.14,1.7s0,0,0,0a22.29,22.29,0,1,1,0-13.16.06.06,0,0,0,0,0,9.5,9.5,0,0,1-4.14,1.7A13.17,13.17,0,0,1,43,22.7v0a12.07,12.07,0,0,0,5-2.15,2.38,2.38,0,0,0,.93-2.95A25,25,0,0,0,25,0Z" />
					</g>
				</g>
			</svg>,
		],
		[
			"snapchat_overlay",
			<svg
				id="dd8ad901-1236-4612-8feb-8cb668be184e"
				width={ICON_SIZE}
				height={ICON_SIZE}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 50 50"
			>
				<g opacity="0.2">
					<path d="M25.66,1.5v1A12.12,12.12,0,0,1,36.73,9.68a24.12,24.12,0,0,1,.56,9.61v.24l-.08,1.33,0,.52.41.32a3.06,3.06,0,0,0,1.9.66h.12a7.31,7.31,0,0,0,2.73-.75.93.93,0,0,1,.36-.07h0a1.36,1.36,0,0,1,.51.1l0,0h.11a.66.66,0,0,1,.47.44c-.06.15-.42.58-1.64,1.07-.18.07-.4.14-.65.22-1.23.39-3.08,1-3.74,2.54l0,0v0a3.68,3.68,0,0,0,.33,3c.35.79,3.58,7.7,10.59,9.22-.52.37-1.88,1-5.3,1.55-1.05.17-1.29,1.26-1.52,2.33-.06.3-.14.6-.22.9a5,5,0,0,1-.74-.1,15,15,0,0,0-3-.32,13.47,13.47,0,0,0-2.18.18h-.08A10.75,10.75,0,0,0,31.39,45a10.14,10.14,0,0,1-6.08,2.41h-.58A10.16,10.16,0,0,1,18.6,45a10.76,10.76,0,0,0-4.23-2.16h-.08a13.45,13.45,0,0,0-2.2-.18,14.88,14.88,0,0,0-3,.34,5.35,5.35,0,0,1-.72.11c-.08-.31-.15-.62-.22-.94C7.9,41.12,7.66,40,6.61,39.86c-3.48-.54-4.82-1.19-5.32-1.56a14,14,0,0,0,7.8-4.86,18.56,18.56,0,0,0,2.81-4.35,3.68,3.68,0,0,0,.33-3v0l0,0c-.66-1.56-2.52-2.15-3.75-2.54-.24-.07-.46-.14-.64-.22-1.15-.45-1.57-.9-1.64-1.06a1.08,1.08,0,0,1,.36-.39,1.11,1.11,0,0,1,.63-.18h.07a.44.44,0,0,1,.16,0,7.14,7.14,0,0,0,2.89.76h.23a3.13,3.13,0,0,0,1.92-.66l.41-.32,0-.52q0-.75-.09-1.51v-.07a24.09,24.09,0,0,1,.56-9.6A12.1,12.1,0,0,1,24.32,2.51h1.33v-1m0,0H24.32a13.1,13.1,0,0,0-12,7.84,25.22,25.22,0,0,0-.6,10.08q0,.75.09,1.49a2.12,2.12,0,0,1-1.31.45h-.15a6.13,6.13,0,0,1-2.54-.67,1.44,1.44,0,0,0-.58-.12H7.12a2.09,2.09,0,0,0-1.95,1.33C5,23,6.51,23.77,7.44,24.14c.2.08.45.16.71.24,1.06.34,2.65.84,3.13,2A2.68,2.68,0,0,1,11,28.6v0a17.57,17.57,0,0,1-2.67,4.16A13,13,0,0,1,.5,37.44a.6.6,0,0,0-.5.63,1,1,0,0,0,.08.32c.44,1,2.65,1.88,6.38,2.45.35.06.49.63.7,1.56.08.38.16.76.28,1.16a.73.73,0,0,0,.72.57h.08A6.22,6.22,0,0,0,9.3,44a13.82,13.82,0,0,1,2.8-.32,12.38,12.38,0,0,1,2,.17,9.69,9.69,0,0,1,3.84,2,11.11,11.11,0,0,0,6.73,2.65h.63A11.12,11.12,0,0,0,32,45.79a9.68,9.68,0,0,1,3.83-2,12.43,12.43,0,0,1,2-.17,14,14,0,0,1,2.8.3,6,6,0,0,0,1.06.13h.12a.7.7,0,0,0,.68-.55q.16-.57.28-1.15c.2-.93.35-1.5.7-1.55,3.74-.57,5.94-1.42,6.38-2.44a1,1,0,0,0,.08-.32.6.6,0,0,0-.5-.62h0c-7.17-1.18-10.38-8.5-10.51-8.82v0a2.68,2.68,0,0,1-.26-2.25c.48-1.14,2.08-1.64,3.13-2,.26-.08.51-.16.71-.24,1.91-.75,2.29-1.53,2.28-2.06a1.65,1.65,0,0,0-1.25-1.36h0a2.37,2.37,0,0,0-.89-.17h0a1.89,1.89,0,0,0-.76.16,6.35,6.35,0,0,1-2.39.67h0a2.05,2.05,0,0,1-1.28-.45l.08-1.33v-.16a25.25,25.25,0,0,0-.6-10.09,13.12,13.12,0,0,0-12-7.85Z" />
				</g>
			</svg>,
		],
		[
			"patreon_overlay",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_2742_1811)">
					<path
						d="M49.5011 19.0357C49.5011 28.7204 41.6501 36.5714 31.9654 36.5714C22.2807 36.5714 14.4297 28.7204 14.4297 19.0357C14.4297 9.35101 22.2807 1.5 31.9654 1.5C41.6501 1.5 49.5011 9.35101 49.5011 19.0357Z"
						stroke="black"
						strokeOpacity="0.2"
					/>
					<path
						d="M0.5 1.5H8.31554V48.6152H0.5V1.5Z"
						stroke="black"
						strokeOpacity="0.2"
					/>
				</g>
				<defs>
					<clipPath id="clip0_2742_1811">
						<rect width="50" height="50" fill="white" />
					</clipPath>
				</defs>
			</svg>,
		],
		[
			"onlyFans_overlay",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<mask id="path-1-inside-1_2799_1867" fill="white">
					<path
						fillRule="evenodd"
						clipRule="evenodd"
						d="M23.0446 9.2721C21.0226 8.43216 18.8555 8 16.6666 8C9.92585 8 3.84868 12.0721 1.26884 18.3175C-1.31037 24.5629 0.115574 31.7514 4.88187 36.5315C9.64816 41.3115 16.8167 42.7412 23.0446 40.1545C27.1272 38.4588 30.2786 35.2559 31.9652 31.3461C38.5892 30.8565 43.183 26.8802 44.6321 20.5346C44.6321 20.5346 39.6338 21.7567 35.3991 20.5346H35.3997C43.774 18.9079 48.5998 14.1841 49.9994 8H41.6301C34.4409 8 30.5752 8.38595 27.5591 12.0633C26.2146 10.8988 24.6907 9.9559 23.0446 9.2721ZM21.446 26.1918C21.5926 25.7134 21.6673 25.215 21.6668 24.713C21.6668 22.6848 20.4485 20.8567 18.5804 20.0805C16.7122 19.3044 14.5614 19.7334 13.1317 21.1675C11.702 22.6016 11.2742 24.758 12.0479 26.6318C12.8215 28.5055 14.6452 29.727 16.6672 29.727H16.6666C17.3233 29.7276 17.9737 29.5987 18.581 29.3473C19.1883 29.0959 19.7393 28.7263 20.2039 28.2604C20.6686 27.7944 21.0364 27.2415 21.2878 26.633C21.3391 26.5084 21.3853 26.382 21.4264 26.2541L21.446 26.1918Z"
					/>
				</mask>
				<path
					d="M23.0446 9.2721L22.661 10.1956V10.1956L23.0446 9.2721ZM1.26884 18.3175L0.344591 17.9357L0.344559 17.9358L1.26884 18.3175ZM4.88187 36.5315L4.17374 37.2376L4.88187 36.5315ZM23.0446 40.1545L22.661 39.231L23.0446 40.1545ZM31.9652 31.3461L31.8915 30.3489L31.2871 30.3935L31.047 30.95L31.9652 31.3461ZM44.6321 20.5346L45.607 20.7572L45.9675 19.1786L44.3946 19.5632L44.6321 20.5346ZM35.3991 20.5346V19.5346L35.1218 21.4954L35.3991 20.5346ZM35.3997 20.5346V21.5346H35.496L35.5904 21.5162L35.3997 20.5346ZM49.9994 8L50.9748 8.22075L51.2511 7H49.9994V8ZM27.5591 12.0633L26.9044 12.8192L27.6809 13.4917L28.3323 12.6975L27.5591 12.0633ZM21.446 26.1918L22.4001 26.4911L22.402 26.4849L21.446 26.1918ZM21.6668 24.713H20.6668V24.714L21.6668 24.713ZM18.5804 20.0805L18.1967 21.004H18.1967L18.5804 20.0805ZM16.6666 29.727V28.727L16.6656 30.727L16.6666 29.727ZM18.581 29.3473L18.1985 28.4234L18.1985 28.4234L18.581 29.3473ZM20.2039 28.2604L20.912 28.9665L20.912 28.9665L20.2039 28.2604ZM21.2878 26.633L22.212 27.0149L22.2124 27.014L21.2878 26.633ZM21.4264 26.2541L22.3786 26.5597L22.3805 26.5535L21.4264 26.2541ZM16.6666 9C18.7239 9 20.7606 9.40616 22.661 10.1956L23.4282 8.34861C21.2846 7.45816 18.9872 7 16.6666 7V9ZM2.19309 18.6993C4.61888 12.8268 10.332 9 16.6666 9V7C9.51973 7 3.07848 11.3174 0.344591 17.9357L2.19309 18.6993ZM5.58999 35.8254C1.10902 31.3315 -0.232256 24.5721 2.19312 18.6992L0.344559 17.9358C-2.38849 24.5537 -0.877872 32.1714 4.17374 37.2376L5.58999 35.8254ZM22.661 39.231C16.8079 41.6621 10.0704 40.3188 5.58999 35.8254L4.17374 37.2376C9.22591 42.3043 16.8255 43.8204 23.4282 41.078L22.661 39.231ZM31.047 30.95C29.4609 34.6269 26.498 37.6373 22.661 39.231L23.4282 41.078C27.7564 39.2803 31.0963 35.8849 32.8834 31.7422L31.047 30.95ZM43.6572 20.312C42.9746 23.301 41.5647 25.684 39.5886 27.3769C37.6125 29.07 35.0178 30.1178 31.8915 30.3489L32.039 32.3434C35.5366 32.0849 38.5508 30.8997 40.8898 28.8958C43.229 26.8917 44.8405 24.1137 45.607 20.7572L43.6572 20.312ZM35.1218 21.4954C37.4073 22.1549 39.8544 22.1467 41.6892 21.9892C42.6145 21.9097 43.4022 21.7906 43.9607 21.6909C44.2403 21.641 44.4633 21.5958 44.6184 21.5626C44.696 21.5459 44.7566 21.5323 44.799 21.5226C44.8201 21.5177 44.8367 21.5138 44.8485 21.511C44.8545 21.5096 44.8592 21.5085 44.8627 21.5076C44.8645 21.5072 44.8659 21.5069 44.8671 21.5066C44.8677 21.5065 44.8682 21.5063 44.8686 21.5062C44.8688 21.5062 44.869 21.5061 44.8692 21.5061C44.8694 21.506 44.8696 21.506 44.6321 20.5346C44.3946 19.5632 44.3948 19.5632 44.395 19.5631C44.395 19.5631 44.3951 19.5631 44.3952 19.5631C44.3953 19.563 44.3954 19.563 44.3953 19.563C44.3953 19.563 44.3949 19.5631 44.3942 19.5633C44.3929 19.5636 44.3904 19.5642 44.3868 19.5651C44.3794 19.5668 44.3674 19.5696 44.3509 19.5734C44.318 19.581 44.2671 19.5924 44.1997 19.6069C44.065 19.6357 43.8644 19.6764 43.6092 19.722C43.0982 19.8132 42.3717 19.9232 41.5181 19.9965C39.795 20.1445 37.6256 20.1363 35.6764 19.5738L35.1218 21.4954ZM35.3997 19.5346H35.3991V21.5346H35.3997V19.5346ZM49.0241 7.77925C47.7268 13.5111 43.2645 17.9882 35.209 19.5529L35.5904 21.5162C44.2835 19.8276 49.4727 14.8571 50.9748 8.22075L49.0241 7.77925ZM41.6301 9H49.9994V7H41.6301V9ZM28.3323 12.6975C31.0127 9.42945 34.3877 9 41.6301 9V7C34.494 7 30.1378 7.34244 26.7859 11.4291L28.3323 12.6975ZM22.661 10.1956C24.2082 10.8383 25.6406 11.7246 26.9044 12.8192L28.2138 11.3074C26.7885 10.073 25.1732 9.07348 23.4282 8.34861L22.661 10.1956ZM22.402 26.4849C22.5779 25.9114 22.6674 25.3139 22.6668 24.7119L20.6668 24.714C20.6672 25.1162 20.6074 25.5154 20.4899 25.8986L22.402 26.4849ZM22.6668 24.713C22.6668 22.2819 21.2064 20.0887 18.964 19.1571L18.1967 21.004C19.6905 21.6247 20.6668 23.0876 20.6668 24.713H22.6668ZM18.964 19.1571C16.721 18.2252 14.1391 18.7407 12.4235 20.4615L13.8399 21.8735C14.9838 20.7262 16.7034 20.3836 18.1967 21.004L18.964 19.1571ZM12.4235 20.4615C10.7086 22.1817 10.1962 24.7672 11.1236 27.0134L12.9722 26.2501C12.3523 24.7488 12.6955 23.0215 13.8399 21.8735L12.4235 20.4615ZM11.1236 27.0134C12.0513 29.2604 14.2393 30.727 16.6672 30.727V28.727C15.0512 28.727 13.5917 27.7506 12.9722 26.2501L11.1236 27.0134ZM16.6672 28.727H16.6666V30.727H16.6672V28.727ZM16.6656 30.727C17.4538 30.7277 18.2346 30.5731 18.9635 30.2713L18.1985 28.4234C17.7129 28.6244 17.1927 28.7275 16.6675 28.727L16.6656 30.727ZM18.9635 30.2713C19.6935 29.9691 20.3549 29.5251 20.912 28.9665L19.4959 27.5542C19.1236 27.9275 18.6831 28.2227 18.1985 28.4234L18.9635 30.2713ZM20.912 28.9665C21.4698 28.4072 21.9108 27.744 22.212 27.0149L20.3636 26.2512C20.162 26.7391 19.8674 27.1816 19.4959 27.5542L20.912 28.9665ZM22.2124 27.014C22.2739 26.8646 22.3293 26.713 22.3785 26.5597L20.4742 25.9486C20.4413 26.051 20.4043 26.1523 20.3632 26.2521L22.2124 27.014ZM22.3805 26.5535L22.4001 26.4911L20.4918 25.8924L20.4722 25.9548L22.3805 26.5535Z"
					fill="black"
					fillOpacity="0.2"
					mask="url(#path-1-inside-1_2799_1867)"
				/>
			</svg>,
		],
		[
			"appStore_overlay",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_3118_3346)">
					<mask id="path-1-inside-1_3118_3346" fill="white">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M12 0C5.37258 0 0 5.37258 0 12V38C0 44.6274 5.37258 50 12 50H38C44.6274 50 50 44.6274 50 38V12C50 5.37258 44.6274 0 38 0H12ZM15.8879 37.0475C15.7345 37.3092 15.5149 37.5259 15.2512 37.6757C14.9875 37.8256 14.689 37.9034 14.3856 37.9013C14.0765 37.904 13.7728 37.8205 13.5084 37.6603C13.3116 37.5462 13.1392 37.3944 13.0012 37.2136C12.8632 37.0327 12.7623 36.8264 12.7042 36.6065C12.6462 36.3865 12.6321 36.1573 12.6628 35.9319C12.6936 35.7065 12.7686 35.4894 12.8834 35.2931L14.5899 32.456C14.6761 32.3096 14.7992 32.1883 14.9468 32.1041C15.0944 32.0199 15.2615 31.9758 15.4314 31.9761H15.6836C16.9214 31.9761 17.7874 32.7205 18.0397 33.4415L15.8879 37.0475ZM30.3354 31.4672L19.1602 31.4795H11.7327C11.4991 31.4804 11.2676 31.434 11.0524 31.3428C10.8373 31.2517 10.6428 31.1177 10.481 30.9492C10.3191 30.7806 10.1931 30.581 10.1108 30.3623C10.0284 30.1436 9.99129 29.9105 10.0017 29.677C10.0374 28.7395 10.8555 28.0297 11.7874 28.0297H17.1714L23.5542 17.1647L21.4872 13.6435C21.0218 12.8411 21.2283 11.783 22.0263 11.2786C22.223 11.1513 22.4434 11.0652 22.6743 11.0253C22.9052 10.9855 23.1417 10.9927 23.3697 11.0466C23.5977 11.1005 23.8125 11.2 24.0011 11.339C24.1897 11.478 24.3482 11.6537 24.4671 11.8556L25.572 13.7429H25.5843L26.6903 11.8556C26.8094 11.6548 26.9677 11.48 27.1557 11.3417C27.3438 11.2033 27.5578 11.1043 27.785 11.0505C28.0121 10.9966 28.2478 10.9891 28.4779 11.0282C28.7081 11.0674 28.928 11.1526 29.1245 11.2786C29.918 11.783 30.1223 12.8411 29.6535 13.6469L27.5865 17.1681L25.5776 20.5933L21.2149 28.033V28.0453H27.6446C28.4504 28.0453 29.4604 28.4783 29.8689 29.1748L29.9046 29.2473C30.2651 29.86 30.4694 30.2808 30.4694 30.8935C30.4635 31.0925 30.4191 31.2884 30.3388 31.4705L30.3354 31.4672ZM39.0129 31.4795H35.9872V31.4917L38.1993 35.254C38.4372 35.6503 38.51 36.124 38.4021 36.5734C38.2942 37.0228 38.0141 37.4119 37.6223 37.6569C37.3506 37.8225 37.0386 37.9102 36.7205 37.9103C36.418 37.9101 36.1207 37.8317 35.8574 37.6827C35.5942 37.5337 35.374 37.3191 35.2182 37.0598L31.9493 31.4951L29.918 28.0353L27.2975 23.5554C26.9179 22.9157 26.7116 22.1881 26.6989 21.4444C26.6862 20.7007 26.8675 19.9666 27.2249 19.3143C27.7428 18.4002 28.139 18.1603 28.139 18.1603L33.9682 28.0196H38.9805C39.918 28.0196 40.7227 28.7406 40.7662 29.6658C40.7753 29.9011 40.7366 30.1357 40.6527 30.3556C40.5688 30.5756 40.4412 30.7762 40.2778 30.9456C40.1143 31.115 39.9183 31.2496 39.7015 31.3414C39.4847 31.4331 39.2516 31.4801 39.0162 31.4795H39.0129Z"
						/>
					</mask>
					<path
						d="M15.2512 37.6757L14.7571 36.8063L14.757 36.8063L15.2512 37.6757ZM15.8879 37.0475L15.0291 36.5351L15.0252 36.5417L15.8879 37.0475ZM14.3856 37.9013L14.3925 36.9014L14.3847 36.9013L14.377 36.9014L14.3856 37.9013ZM13.5084 37.6603L14.0269 36.8052L14.0184 36.8L14.0098 36.795L13.5084 37.6603ZM13.0012 37.2136L13.7962 36.6069L13.7962 36.6069L13.0012 37.2136ZM12.6628 35.9319L13.6537 36.0671L12.6628 35.9319ZM12.8834 35.2931L12.0264 34.7776L12.0203 34.7881L12.8834 35.2931ZM14.5899 32.456L15.4469 32.9715L15.4516 32.9635L14.5899 32.456ZM15.4314 31.9761L15.4294 32.9761H15.4314V31.9761ZM18.0397 33.4415L18.8984 33.9539L19.1379 33.5525L18.9836 33.1113L18.0397 33.4415ZM19.1602 31.4795V32.4795L19.1613 32.4795L19.1602 31.4795ZM30.3354 31.4672L31.0425 30.7601L30.7492 30.4667L30.3343 30.4672L30.3354 31.4672ZM11.7327 31.4795V30.4795L11.7285 30.4795L11.7327 31.4795ZM10.0017 29.677L11.0007 29.7216L11.001 29.7151L10.0017 29.677ZM17.1714 28.0297V29.0297H17.7437L18.0336 28.5362L17.1714 28.0297ZM23.5542 17.1647L24.4164 17.6713L24.7139 17.1649L24.4166 16.6585L23.5542 17.1647ZM21.4872 13.6435L20.6222 14.1452L20.6248 14.1498L21.4872 13.6435ZM22.0263 11.2786L22.5606 12.1239L22.5693 12.1183L22.0263 11.2786ZM22.6743 11.0253L22.5042 10.0399L22.5042 10.0399L22.6743 11.0253ZM23.3697 11.0466L23.5998 10.0734L23.5998 10.0734L23.3697 11.0466ZM24.0011 11.339L23.4077 12.1439L23.4077 12.1439L24.0011 11.339ZM24.4671 11.8556L25.3301 11.3503L25.3287 11.3479L24.4671 11.8556ZM25.572 13.7429L24.709 14.2481L24.9987 14.7429H25.572V13.7429ZM25.5843 13.7429V14.7429H26.1573L26.4471 14.2485L25.5843 13.7429ZM26.6903 11.8556L25.8302 11.3456L25.8276 11.35L26.6903 11.8556ZM27.1557 11.3417L26.5632 10.5361L26.5632 10.5361L27.1557 11.3417ZM27.785 11.0505L27.5543 10.0774L27.5543 10.0774L27.785 11.0505ZM28.4779 11.0282L28.6458 10.0424L28.6458 10.0424L28.4779 11.0282ZM29.1245 11.2786L28.5848 12.1204L28.588 12.1225L29.1245 11.2786ZM29.6535 13.6469L30.5159 14.1531L30.5179 14.1497L29.6535 13.6469ZM27.5865 17.1681L26.7241 16.6618L26.724 16.6622L27.5865 17.1681ZM25.5776 20.5933L24.715 20.0874L24.715 20.0875L25.5776 20.5933ZM21.2149 28.033L20.3523 27.5272L20.2149 27.7614V28.033H21.2149ZM21.2149 28.0453H20.2149V29.0453H21.2149V28.0453ZM29.8689 29.1748L30.7661 28.7331L30.7499 28.7003L30.7315 28.6688L29.8689 29.1748ZM29.9046 29.2473L29.0075 29.689L29.0239 29.7224L29.0427 29.7544L29.9046 29.2473ZM30.4694 30.8935L31.4689 30.9231L31.4694 30.9083V30.8935H30.4694ZM30.3388 31.4705L29.6317 32.1776L30.6642 33.2102L31.2537 31.8742L30.3388 31.4705ZM35.9872 31.4795V30.4795H34.9872V31.4795H35.9872ZM35.9872 31.4917H34.9872V31.7639L35.1252 31.9986L35.9872 31.4917ZM38.1993 35.254L37.3372 35.7609L37.3419 35.7687L38.1993 35.254ZM37.6223 37.6569L38.1428 38.5108L38.1524 38.5048L37.6223 37.6569ZM36.7205 37.9103L36.72 38.9103H36.7207L36.7205 37.9103ZM35.2182 37.0598L34.356 37.5664L34.361 37.5748L35.2182 37.0598ZM31.9493 31.4951L31.0869 32.0014L31.087 32.0016L31.9493 31.4951ZM29.918 28.0353L29.0548 28.5402L29.0557 28.5416L29.918 28.0353ZM27.2975 23.5554L28.1607 23.0504L28.1575 23.0451L27.2975 23.5554ZM27.2249 19.3143L26.3548 18.8213L26.348 18.8337L27.2249 19.3143ZM28.139 18.1603L28.9998 17.6513L28.4854 16.7814L27.621 17.3049L28.139 18.1603ZM33.9682 28.0196L33.1074 28.5286L33.3978 29.0196H33.9682V28.0196ZM40.7662 29.6658L41.7655 29.6275L41.7651 29.6188L40.7662 29.6658ZM39.7015 31.3414L40.0912 32.2623L40.0912 32.2623L39.7015 31.3414ZM39.0162 31.4795L39.0189 30.4795H39.0162V31.4795ZM1 12C1 5.92487 5.92487 1 12 1V-1C4.8203 -1 -1 4.8203 -1 12H1ZM1 38V12H-1V38H1ZM12 49C5.92487 49 1 44.0751 1 38H-1C-1 45.1797 4.8203 51 12 51V49ZM38 49H12V51H38V49ZM49 38C49 44.0751 44.0751 49 38 49V51C45.1797 51 51 45.1797 51 38H49ZM49 12V38H51V12H49ZM38 1C44.0751 1 49 5.92487 49 12H51C51 4.8203 45.1797 -1 38 -1V1ZM12 1H38V-1H12V1ZM15.7453 38.5451C16.1616 38.3085 16.5083 37.9664 16.7505 37.5533L15.0252 36.5417C14.9606 36.652 14.8681 36.7432 14.7571 36.8063L15.7453 38.5451ZM14.3788 38.9013C14.8577 38.9046 15.329 38.7817 15.7453 38.5451L14.757 36.8063C14.646 36.8695 14.5203 36.9022 14.3925 36.9014L14.3788 38.9013ZM12.9899 38.5154C13.4131 38.772 13.8994 38.9056 14.3943 38.9013L14.377 36.9014C14.2536 36.9024 14.1324 36.8691 14.0269 36.8052L12.9899 38.5154ZM12.2063 37.8202C12.4242 38.1057 12.6963 38.3454 13.007 38.5255L14.0098 36.795C13.9269 36.747 13.8543 36.6831 13.7962 36.6069L12.2063 37.8202ZM11.7374 36.8618C11.8291 37.209 11.9884 37.5347 12.2063 37.8202L13.7962 36.6069C13.7381 36.5307 13.6956 36.4438 13.6711 36.3512L11.7374 36.8618ZM11.672 35.7967C11.6235 36.1526 11.6457 36.5145 11.7374 36.8618L13.6711 36.3512C13.6466 36.2586 13.6407 36.162 13.6537 36.0671L11.672 35.7967ZM12.0203 34.7881C11.8389 35.0981 11.7206 35.4409 11.672 35.7967L13.6537 36.0671C13.6666 35.9722 13.6982 35.8807 13.7466 35.798L12.0203 34.7881ZM13.733 31.9406L12.0265 34.7776L13.7403 35.8085L15.4468 32.9715L13.733 31.9406ZM14.4514 31.2354C14.1523 31.406 13.9029 31.6519 13.7282 31.9486L15.4516 32.9635C15.4493 32.9673 15.4461 32.9705 15.4422 32.9727L14.4514 31.2354ZM15.4334 30.9761C15.0891 30.9754 14.7505 31.0648 14.4514 31.2354L15.4422 32.9727C15.4383 32.975 15.4339 32.9761 15.4294 32.9761L15.4334 30.9761ZM15.6836 30.9761H15.4314V32.9761H15.6836V30.9761ZM18.9836 33.1113C18.5825 31.9648 17.3199 30.9761 15.6836 30.9761V32.9761C16.5228 32.9761 16.9924 33.4763 17.0958 33.7717L18.9836 33.1113ZM16.7466 37.56L18.8984 33.9539L17.1809 32.9291L15.0291 36.5351L16.7466 37.56ZM19.1613 32.4795L30.3365 32.4672L30.3343 30.4672L19.1591 30.4795L19.1613 32.4795ZM11.7327 32.4795H19.1602V30.4795H11.7327V32.4795ZM10.6624 32.2636C11.0023 32.4076 11.3678 32.481 11.737 32.4795L11.7285 30.4795C11.6303 30.4799 11.533 30.4603 11.4425 30.422L10.6624 32.2636ZM9.75971 31.6419C10.0154 31.9081 10.3225 32.1196 10.6624 32.2636L11.4425 30.422C11.352 30.3837 11.2703 30.3274 11.2022 30.2565L9.75971 31.6419ZM9.17496 30.7148C9.30509 31.0602 9.50403 31.3756 9.75971 31.6419L11.2022 30.2565C11.1342 30.1857 11.0812 30.1017 11.0466 30.0098L9.17496 30.7148ZM9.00272 29.6324C8.98624 30.0011 9.04484 30.3694 9.17496 30.7148L11.0466 30.0098C11.0119 29.9178 10.9963 29.8198 11.0007 29.7216L9.00272 29.6324ZM11.7874 27.0297C10.3756 27.0297 9.06074 28.1086 9.00245 29.6389L11.001 29.7151C11.0141 29.3704 11.3354 29.0297 11.7874 29.0297V27.0297ZM17.1714 27.0297H11.7874V29.0297H17.1714V27.0297ZM22.692 16.6582L16.3091 27.5232L18.0336 28.5362L24.4164 17.6713L22.692 16.6582ZM20.6248 14.1498L22.6918 17.671L24.4166 16.6585L22.3496 13.1373L20.6248 14.1498ZM21.4919 10.4333C20.1991 11.2506 19.9119 12.9205 20.6222 14.1452L22.3523 13.1418C22.1317 12.7616 22.2575 12.3155 22.5606 12.1238L21.4919 10.4333ZM22.5042 10.0399C22.1404 10.1027 21.7932 10.2384 21.4832 10.4389L22.5693 12.1183C22.6528 12.0642 22.7464 12.0277 22.8444 12.0108L22.5042 10.0399ZM23.5998 10.0734C23.2406 9.98852 22.8679 9.97712 22.5042 10.0399L22.8444 12.0108C22.9425 11.9938 23.0429 11.9969 23.1397 12.0198L23.5998 10.0734ZM24.5944 10.534C24.2973 10.315 23.959 10.1583 23.5998 10.0734L23.1397 12.0198C23.2365 12.0427 23.3276 12.0849 23.4077 12.1439L24.5944 10.534ZM25.3287 11.3479C25.1413 11.0299 24.8916 10.7531 24.5944 10.534L23.4077 12.1439C23.4878 12.2029 23.5551 12.2775 23.6056 12.3632L25.3287 11.3479ZM26.435 13.2376L25.3301 11.3503L23.6041 12.3608L24.709 14.2481L26.435 13.2376ZM25.5843 12.7429H25.572V14.7429H25.5843V12.7429ZM25.8276 11.35L24.7215 13.2372L26.4471 14.2485L27.5531 12.3612L25.8276 11.35ZM26.5632 10.5361C26.267 10.754 26.0177 11.0293 25.8302 11.3456L27.5505 12.3656C27.6011 12.2803 27.6683 12.206 27.7483 12.1472L26.5632 10.5361ZM27.5543 10.0774C27.1965 10.1622 26.8594 10.3182 26.5632 10.5361L27.7483 12.1472C27.8282 12.0885 27.9191 12.0464 28.0156 12.0235L27.5543 10.0774ZM28.6458 10.0424C28.2833 9.98071 27.9121 9.99261 27.5543 10.0774L28.0156 12.0235C28.1121 12.0006 28.2123 11.9974 28.3101 12.0141L28.6458 10.0424ZM29.6642 10.4367C29.3546 10.2383 29.0083 10.1042 28.6458 10.0424L28.3101 12.0141C28.4078 12.0307 28.5013 12.0669 28.5848 12.1204L29.6642 10.4367ZM30.5179 14.1497C31.2302 12.9252 30.9507 11.2546 29.661 10.4347L28.588 12.1225C28.8853 12.3115 29.0143 12.757 28.7891 13.144L30.5179 14.1497ZM28.4489 17.6743L30.5159 14.1531L28.7911 13.1406L26.7241 16.6618L28.4489 17.6743ZM26.4402 21.0992L28.4491 17.674L26.724 16.6622L24.715 20.0874L26.4402 21.0992ZM22.0775 28.5389L26.4402 21.0991L24.715 20.0875L20.3523 27.5272L22.0775 28.5389ZM22.2149 28.0453V28.033H20.2149V28.0453H22.2149ZM27.6446 27.0453H21.2149V29.0453H27.6446V27.0453ZM30.7315 28.6688C30.397 28.0986 29.8615 27.7 29.3407 27.4484C28.8142 27.1941 28.2123 27.0453 27.6446 27.0453V29.0453C27.8826 29.0453 28.1887 29.1131 28.4707 29.2493C28.7585 29.3884 28.9323 29.5545 29.0063 29.6807L30.7315 28.6688ZM30.8018 28.8056L30.7661 28.7331L28.9717 29.6165L29.0075 29.689L30.8018 28.8056ZM31.4694 30.8935C31.4694 29.9986 31.1438 29.3815 30.7665 28.7402L29.0427 29.7544C29.3864 30.3386 29.4694 30.563 29.4694 30.8935H31.4694ZM31.2537 31.8742C31.3861 31.574 31.4592 31.251 31.4689 30.9231L29.4698 30.8639C29.4677 30.9339 29.4521 31.0028 29.4239 31.0669L31.2537 31.8742ZM29.6283 32.1743L29.6317 32.1776L31.0459 30.7634L31.0425 30.7601L29.6283 32.1743ZM35.9872 32.4795H39.0129V30.4795H35.9872V32.4795ZM36.9872 31.4917V31.4795H34.9872V31.4917H36.9872ZM39.0613 34.7472L36.8493 30.9849L35.1252 31.9986L37.3372 35.7609L39.0613 34.7472ZM39.3744 36.8069C39.5435 36.1027 39.4294 35.3602 39.0566 34.7393L37.3419 35.7687C37.4449 35.9403 37.4764 36.1454 37.4297 36.3399L39.3744 36.8069ZM38.1524 38.5048C38.7665 38.1209 39.2053 37.5112 39.3744 36.8069L37.4297 36.3399C37.383 36.5345 37.2618 36.7029 37.0921 36.809L38.1524 38.5048ZM36.7207 38.9103C37.2224 38.9101 37.7144 38.7719 38.1428 38.5107L37.1017 36.8031C36.9868 36.8731 36.8548 36.9102 36.7202 36.9103L36.7207 38.9103ZM35.3648 38.5529C35.7781 38.787 36.245 38.9101 36.72 38.9103L36.7209 36.9103C36.5909 36.9102 36.4632 36.8765 36.3501 36.8125L35.3648 38.5529ZM34.361 37.5748C34.6056 37.982 34.9514 38.3189 35.3648 38.5529L36.3501 36.8125C36.237 36.7485 36.1424 36.6563 36.0755 36.5449L34.361 37.5748ZM31.087 32.0016L34.356 37.5663L36.0805 36.5533L32.8115 30.9886L31.087 32.0016ZM29.0557 28.5416L31.0869 32.0014L32.8116 30.9888L30.7804 27.529L29.0557 28.5416ZM26.4343 24.0603L29.0548 28.5402L30.7812 27.5304L28.1607 23.0504L26.4343 24.0603ZM25.699 21.4615C25.7147 22.379 25.9692 23.2765 26.4375 24.0656L28.1575 23.0451C27.8666 22.5548 27.7085 21.9973 27.6987 21.4273L25.699 21.4615ZM26.348 18.8337C25.907 19.6384 25.6833 20.5441 25.699 21.4615L27.6987 21.4273C27.689 20.8574 27.8279 20.2947 28.1019 19.7949L26.348 18.8337ZM28.139 18.1603C27.621 17.3049 27.6205 17.3052 27.62 17.3055C27.6199 17.3056 27.6194 17.3058 27.6191 17.306C27.6185 17.3064 27.6178 17.3068 27.6172 17.3072C27.6159 17.308 27.6146 17.3088 27.6133 17.3096C27.6106 17.3112 27.6079 17.3129 27.6051 17.3147C27.5994 17.3183 27.5934 17.3221 27.5871 17.3263C27.5744 17.3346 27.5603 17.3441 27.545 17.3549C27.5143 17.3765 27.4785 17.4033 27.4382 17.4361C27.3575 17.5017 27.2592 17.5908 27.1475 17.7096C26.9241 17.9473 26.6493 18.3016 26.3549 18.8213L28.095 19.8072C28.3184 19.4129 28.5007 19.1901 28.6048 19.0794C28.6569 19.0239 28.6901 18.9959 28.6998 18.988C28.7048 18.9839 28.704 18.9849 28.697 18.9898C28.6935 18.9923 28.6884 18.9957 28.6818 19.0001C28.6785 19.0022 28.6747 19.0046 28.6706 19.0072C28.6686 19.0085 28.6664 19.0099 28.6641 19.0113C28.663 19.012 28.6618 19.0127 28.6607 19.0134C28.6601 19.0138 28.6595 19.0141 28.6589 19.0145C28.6586 19.0147 28.6581 19.015 28.6579 19.0151C28.6575 19.0153 28.657 19.0156 28.139 18.1603ZM34.829 27.5107L28.9998 17.6513L27.2782 18.6692L33.1074 28.5286L34.829 27.5107ZM38.9805 27.0196H33.9682V29.0196H38.9805V27.0196ZM41.7651 29.6188C41.6947 28.1211 40.412 27.0196 38.9805 27.0196V29.0196C39.424 29.0196 39.7507 29.3601 39.7673 29.7128L41.7651 29.6188ZM41.587 30.7122C41.719 30.3664 41.7797 29.9974 41.7655 29.6275L39.767 29.7042C39.7708 29.8047 39.7543 29.905 39.7184 29.999L41.587 30.7122ZM40.9974 31.64C41.2544 31.3736 41.455 31.058 41.587 30.7122L39.7184 29.999C39.6826 30.0931 39.628 30.1789 39.5582 30.2513L40.9974 31.64ZM40.0912 32.2623C40.4321 32.1181 40.7403 31.9064 40.9974 31.64L39.5582 30.2513C39.4883 30.3237 39.4045 30.3812 39.3118 30.4204L40.0912 32.2623ZM39.0136 32.4795C39.3838 32.4804 39.7503 32.4066 40.0912 32.2623L39.3118 30.4204C39.2191 30.4597 39.1195 30.4797 39.0189 30.4795L39.0136 32.4795ZM39.0129 32.4795H39.0162V30.4795H39.0129V32.4795Z"
						fill="black"
						fillOpacity="0.2"
						mask="url(#path-1-inside-1_3118_3346)"
					/>
				</g>
				<defs>
					<clipPath id="clip0_3118_3346">
						<rect width="50" height="50" fill="white" />
					</clipPath>
				</defs>
			</svg>,
		],
		[
			"googlePlay_overlay",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<path
					d="M7.42031 1.48803L32.6932 15.1323L26.4992 21.7687L7.42031 1.48803Z"
					stroke="black"
					strokeOpacity="0.2"
				/>
				<path
					d="M46.0943 22.4389L46.1146 22.4498L46.1357 22.4589C47.0883 22.8672 47.666 23.831 47.666 24.9993C47.666 26.127 47.1197 26.9721 46.0893 27.5625L36.5997 32.7094L29.3522 24.9993L36.5997 17.2893L46.0943 22.4389Z"
					stroke="black"
					strokeOpacity="0.2"
				/>
				<path
					d="M2 3.33333C2 2.94472 2.06389 2.58763 2.2143 2.28249L23.4829 25.0012L2.24958 47.8431C2.06675 47.452 2 47.0627 2 46.6667V3.33333Z"
					stroke="black"
					strokeOpacity="0.2"
				/>
				<path
					d="M32.6932 34.8677L7.42031 48.512L26.4992 28.2313L32.6932 34.8677Z"
					stroke="black"
					strokeOpacity="0.2"
				/>
			</svg>,
		],
		[
			"linkedin_overlay",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_1561_2162)">
					<g clipPath="url(#clip1_1561_2162)">
						<mask id="path-1-inside-1_1561_2162" fill="white">
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M3.69531 0C1.65508 0 0 1.60469 0 3.58164V46.4195C0 48.3967 1.65527 50 3.69531 50H46.3047C48.3457 50 50 48.3965 50 46.4189V3.58164C50 1.60469 48.3457 0 46.3047 0H3.69531ZM15.1945 19.3332V41.8433H7.7125V19.3332H15.1945ZM15.6877 12.3717C15.6877 14.5318 14.0637 16.2603 11.4551 16.2603L11.4545 16.2601H11.4061C8.89492 16.2601 7.27148 14.5316 7.27148 12.3715C7.27148 10.1623 8.94394 8.48203 11.5047 8.48203C14.0637 8.48203 15.6389 10.1623 15.6877 12.3717ZM26.8174 41.8433H19.3359L19.3357 41.8441C19.3357 41.8441 19.434 21.4457 19.3363 19.334H26.818V22.5202C27.8125 20.9867 29.5925 18.8055 33.5611 18.8055C38.4836 18.8055 42.1742 22.0228 42.1742 28.9367V41.8433H34.693V29.8023C34.693 26.776 33.6096 24.7119 30.9029 24.7119C28.8355 24.7119 27.6045 26.1039 27.0639 27.4486C26.8662 27.9285 26.8174 28.6021 26.8174 29.274V41.8433Z"
							/>
						</mask>
						<path
							d="M15.1945 41.8433V42.8433H16.1945V41.8433H15.1945ZM15.1945 19.3332H16.1945V18.3332H15.1945V19.3332ZM7.7125 41.8433H6.7125V42.8433H7.7125V41.8433ZM7.7125 19.3332V18.3332H6.7125V19.3332H7.7125ZM11.4551 16.2603L11.137 17.2084L11.2918 17.2603H11.4551V16.2603ZM15.6877 12.3717H16.6877V12.3606L16.6875 12.3496L15.6877 12.3717ZM11.4545 16.2601L11.7726 15.3121L11.6178 15.2601H11.4545V16.2601ZM19.3359 41.8433V40.8433H18.5542L18.3655 41.6019L19.3359 41.8433ZM26.8174 41.8433V42.8433H27.8174V41.8433H26.8174ZM19.3357 41.8441L18.3358 41.8393L20.3062 42.0856L19.3357 41.8441ZM19.3363 19.334V18.334H18.289L18.3374 19.3802L19.3363 19.334ZM26.818 19.334H27.818V18.334H26.818V19.334ZM26.818 22.5202H25.818V25.8999L27.657 23.0643L26.818 22.5202ZM42.1742 41.8433V42.8433H43.1742V41.8433H42.1742ZM34.693 41.8433H33.693V42.8433H34.693V41.8433ZM27.0639 27.4486L27.9885 27.8295L27.9917 27.8216L27.0639 27.4486ZM1 3.58164C1 2.1861 2.17778 1 3.69531 1V-1C1.13238 -1 -1 1.02327 -1 3.58164H1ZM1 46.4195V3.58164H-1V46.4195H1ZM3.69531 49C2.17747 49 1 47.8148 1 46.4195H-1C-1 48.9786 1.13308 51 3.69531 51V49ZM46.3047 49H3.69531V51H46.3047V49ZM49 46.4189C49 47.8149 47.8232 49 46.3047 49V51C48.8682 51 51 48.9781 51 46.4189H49ZM49 3.58164V46.4189H51V3.58164H49ZM46.3047 1C47.8229 1 49 2.18596 49 3.58164H51C51 1.02341 48.8685 -1 46.3047 -1V1ZM3.69531 1H46.3047V-1H3.69531V1ZM16.1945 41.8433V19.3332H14.1945V41.8433H16.1945ZM7.7125 42.8433H15.1945V40.8433H7.7125V42.8433ZM6.7125 19.3332V41.8433H8.7125V19.3332H6.7125ZM15.1945 18.3332H7.7125V20.3332H15.1945V18.3332ZM11.4551 17.2603C12.9855 17.2603 14.3018 16.7494 15.2418 15.8478C16.1812 14.9468 16.6877 13.7091 16.6877 12.3717H14.6877C14.6877 13.1944 14.3822 13.901 13.8574 14.4044C13.3333 14.9071 12.5332 15.2603 11.4551 15.2603V17.2603ZM11.1364 17.2082L11.137 17.2084L11.7732 15.3123L11.7726 15.3121L11.1364 17.2082ZM11.4061 17.2601H11.4545V15.2601H11.4061V17.2601ZM6.27148 12.3715C6.27148 15.1071 8.36612 17.2601 11.4061 17.2601V15.2601C9.42372 15.2601 8.27148 13.9562 8.27148 12.3715H6.27148ZM11.5047 7.48203C10.0022 7.48203 8.68814 7.97821 7.74169 8.87081C6.79333 9.76523 6.27148 11.0053 6.27148 12.3715H8.27148C8.27148 11.5285 8.58587 10.8238 9.11392 10.3258C9.64389 9.82598 10.4465 9.48203 11.5047 9.48203V7.48203ZM16.6875 12.3496C16.6578 11.0086 16.1603 9.77682 15.2328 8.87957C14.3033 7.98046 13.0094 7.48203 11.5047 7.48203V9.48203C12.559 9.48203 13.3322 9.82373 13.8422 10.3171C14.3542 10.8123 14.6687 11.5254 14.6879 12.3938L16.6875 12.3496ZM19.3359 42.8433H26.8174V40.8433H19.3359V42.8433ZM20.3062 42.0856L20.3064 42.0848L18.3655 41.6019L18.3653 41.6027L20.3062 42.0856ZM18.3374 19.3802C18.3848 20.4042 18.3851 25.9938 18.3727 31.3786C18.3665 34.0597 18.3573 36.6749 18.3496 38.6199C18.3457 39.5924 18.3423 40.3973 18.3398 40.9591C18.3385 41.2399 18.3375 41.46 18.3368 41.6099C18.3365 41.6848 18.3362 41.7422 18.336 41.7808C18.3359 41.8001 18.3359 41.8148 18.3358 41.8246C18.3358 41.8295 18.3358 41.8332 18.3358 41.8356C18.3358 41.8369 18.3358 41.8378 18.3358 41.8384C18.3358 41.8387 18.3358 41.8389 18.3358 41.8391C18.3358 41.8392 18.3358 41.8393 19.3357 41.8441C20.3357 41.8489 20.3357 41.8489 20.3357 41.8487C20.3357 41.8486 20.3357 41.8483 20.3357 41.848C20.3357 41.8474 20.3357 41.8465 20.3357 41.8452C20.3358 41.8427 20.3358 41.839 20.3358 41.8341C20.3358 41.8243 20.3359 41.8096 20.336 41.7903C20.3362 41.7516 20.3365 41.6942 20.3368 41.6192C20.3375 41.4692 20.3385 41.249 20.3398 40.968C20.3423 40.4059 20.3457 39.6007 20.3496 38.6278C20.3572 36.6822 20.3665 34.0658 20.3727 31.3833C20.385 26.0409 20.3856 20.3754 20.3353 19.2878L18.3374 19.3802ZM26.818 18.334H19.3363V20.334H26.818V18.334ZM27.818 22.5202V19.334H25.818V22.5202H27.818ZM33.5611 17.8055C31.3782 17.8055 29.7418 18.4101 28.5054 19.2654C27.2837 20.1104 26.5055 21.1642 25.979 21.9761L27.657 23.0643C28.125 22.3427 28.734 21.5391 29.6432 20.9102C30.5376 20.2915 31.7754 19.8055 33.5611 19.8055V17.8055ZM43.1742 28.9367C43.1742 25.3077 42.204 22.5048 40.4489 20.6006C38.6864 18.6885 36.2452 17.8055 33.5611 17.8055V19.8055C35.7995 19.8055 37.6648 20.5311 38.9783 21.9561C40.2992 23.3892 41.1742 25.6519 41.1742 28.9367H43.1742ZM43.1742 41.8433V28.9367H41.1742V41.8433H43.1742ZM34.693 42.8433H42.1742V40.8433H34.693V42.8433ZM33.693 29.8023V41.8433H35.693V29.8023H33.693ZM30.9029 25.7119C31.9613 25.7119 32.5828 26.0927 32.9865 26.6852C33.4335 27.3415 33.693 28.3802 33.693 29.8023H35.693C35.693 28.1981 35.4108 26.6916 34.6394 25.5593C33.8247 24.3632 32.5512 23.7119 30.9029 23.7119V25.7119ZM27.9917 27.8216C28.437 26.714 29.3776 25.7119 30.9029 25.7119V23.7119C28.2935 23.7119 26.772 25.4938 26.136 27.0756L27.9917 27.8216ZM27.8174 29.274C27.8174 28.6065 27.8729 28.1101 27.9885 27.8295L26.1392 27.0678C25.8595 27.7469 25.8174 28.5978 25.8174 29.274H27.8174ZM27.8174 41.8433V29.274H25.8174V41.8433H27.8174Z"
							fill="black"
							fillOpacity="0.2"
							mask="url(#path-1-inside-1_1561_2162)"
						/>
					</g>
				</g>
				<defs>
					<clipPath id="clip0_1561_2162">
						<rect width="50" height="50" fill="white" />
					</clipPath>
					<clipPath id="clip1_1561_2162">
						<rect width="50" height="50" fill="white" />
					</clipPath>
				</defs>
			</svg>,
		],
		[
			"facebook_overlay",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_1561_2168)">
					<g clipPath="url(#clip1_1561_2168)">
						<path
							fillRule="evenodd"
							clipRule="evenodd"
							d="M40.2579 27.9276H39.3553H35.6776V44.2434V45.2434H34.6776H26.8618H25.8618V44.2434V27.9276H23.8289H22.8289V26.9276V21.0921V20.0921H23.8289H25.8618V17.375C25.8618 14.8284 26.3878 12.5893 27.8556 10.9913C29.339 9.37629 31.601 8.61184 34.625 8.61184H40.4408H41.4408V9.61184V15.4211V16.4211H40.4408H37.0592C35.9957 16.4211 35.8284 16.6348 35.8168 16.6496L35.8167 16.6497C35.7993 16.6719 35.755 16.7414 35.7221 16.9424C35.6879 17.1514 35.6776 17.4229 35.6776 17.8092V17.8112L35.6731 20.0855H39.9868H41.1022L40.9809 21.1942L40.3949 26.553L40.4032 26.5613L40.2579 27.9276ZM39.8775 22.0855L39.3553 26.8609L39.3487 26.9211L39.3553 26.9276H39.3421H38.342H35.6776H34.6776V27.9276V43.2434V44.2434H33.6776H27.8618H26.8618V43.2434V27.9276V26.9276H25.8618H24.8289H23.8289V25.9276V22.0921V21.0921H24.8289H25.8618H26.8618V20.0921V17.375C26.8618 12.5066 28.8882 9.61184 34.625 9.61184H39.4408H40.4408V10.6118V14.4211V15.4211H39.4408H37.0592C34.8224 15.4211 34.6776 16.2566 34.6776 17.8092L34.6731 20.0855L34.6711 21.0855H34.6715H35.6711H38.9809H39.9868L39.8775 22.0855ZM9.375 1H40.625C45.2503 1 49 4.74965 49 9.375V40.625C49 45.2503 45.2503 49 40.625 49H9.375C4.74965 49 1 45.2503 1 40.625V9.375C1 4.74965 4.74965 1 9.375 1ZM40.625 0H9.375C4.19737 0 0 4.19737 0 9.375V40.625C0 45.8026 4.19737 50 9.375 50H40.625C45.8026 50 50 45.8026 50 40.625V9.375C50 4.19737 45.8026 0 40.625 0Z"
							fill="black"
							fillOpacity="0.2"
						/>
					</g>
				</g>
				<defs>
					<clipPath id="clip0_1561_2168">
						<rect width="50" height="50" fill="white" />
					</clipPath>
					<clipPath id="clip1_1561_2168">
						<rect width="50" height="50" fill="white" />
					</clipPath>
				</defs>
			</svg>,
		],
		[
			"youtube_overlay",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 50 50"
			>
				<path
					d="M26.11,42.54l-10.26-.19a53.54,53.54,0,0,1-9.91-.61c-5-1-5.3-6-5.67-10.14A71.1,71.1,0,0,1,.92,14,6,6,0,0,1,6.86,8.59a328.28,328.28,0,0,1,33.27-.32,24,24,0,0,1,3.49.42c5.68,1,5.82,6.62,6.19,11.35a64.35,64.35,0,0,1-.49,14.34c-.56,3.93-1.64,7.23-6.19,7.55-5.7.42-11.26.75-17,.64C26.16,42.54,26.12,42.54,26.11,42.54Zm-6-10,12.77-7.34L20.08,17.91Z"
					fill="none"
					opacity="0.2"
				/>
				<g opacity="0.2">
					<path d="M25.23,8V9c4.46,0,9.32.09,14.87.27a23.1,23.1,0,0,1,3.35.4c4.32.76,4.91,4.35,5.31,9.76l.05.69a63.48,63.48,0,0,1-.48,14.12c-.58,4-1.63,6.44-5.27,6.69-5.44.4-10,.66-14.73.66H26.56l0,0h-.41l-10.26-.19-2,0a39.41,39.41,0,0,1-7.77-.57c-3.84-.78-4.44-4.24-4.86-9l0-.21A69.92,69.92,0,0,1,1.9,14.16a5,5,0,0,1,5-4.58C12.59,9.19,18.58,9,25.23,9V8M19.08,34.31l1.5-.86,5.33-3.06,7.44-4.27,1.51-.87-1.51-.87-6.9-4L20.57,17l-1.5-.86V34.31M25.23,8C19.1,8,13,8.16,6.86,8.59A6,6,0,0,0,.92,14,71.1,71.1,0,0,0,.27,31.61c.37,4.16.72,9.12,5.67,10.14a53.54,53.54,0,0,0,9.91.61l10.26.19s0,0,0,0l2.18,0c5,0,9.83-.3,14.8-.66,4.55-.32,5.62-3.62,6.19-7.55A64.35,64.35,0,0,0,49.81,20c-.37-4.73-.51-10.36-6.19-11.35a24,24,0,0,0-3.49-.42c-5-.16-9.92-.27-14.9-.27ZM20.08,32.59V17.91l12.77,7.34L20.08,32.59Z" />
				</g>
			</svg>,
		],
		[
			"instagram_overlay",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				viewBox="0 0 50 50"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<g clipPath="url(#clip0_1561_2175)">
					<g clipPath="url(#clip1_1561_2175)">
						<mask id="path-1-inside-1_1561_2175" fill="white">
							<path
								fillRule="evenodd"
								clipRule="evenodd"
								d="M7.01548 48.774C8.08987 49.1931 9.70517 49.6879 12.6787 49.8232C15.8929 49.9718 16.8589 50 24.9993 50C33.1426 50 34.1085 49.9703 37.3228 49.8232C40.2963 49.6879 41.9116 49.1931 42.986 48.774C44.4096 48.2198 45.426 47.56 46.493 46.493C47.56 45.426 48.2198 44.4111 48.774 42.9875C49.1901 41.9131 49.6879 40.2978 49.8232 37.3243C49.9703 34.1071 50 33.1411 50 25.0007C50 16.8574 49.9703 15.8944 49.8232 12.6772C49.6879 9.70369 49.1931 8.08839 48.774 7.014C48.2198 5.59039 47.5614 4.57396 46.493 3.507C45.4246 2.44004 44.4096 1.77728 42.986 1.22596C41.9086 0.809879 40.2963 0.312063 37.3228 0.176836C34.1056 0.0326924 33.1426 0 24.9993 0C16.8589 0 15.8929 0.0297203 12.6772 0.176836C9.70369 0.312063 8.08839 0.806907 7.014 1.22596C5.58891 1.77728 4.57396 2.44004 3.507 3.507C2.44153 4.57693 1.78025 5.59188 1.22596 7.01548C0.809879 8.09285 0.312063 9.70517 0.176836 12.6787C0.0326924 15.8959 0 16.8589 0 25.0022C0 33.1456 0.0297203 34.11 0.178322 37.3243C0.31355 40.2978 0.808393 41.9131 1.22745 42.9875C1.77876 44.4111 2.44004 45.426 3.50849 46.493C4.57693 47.56 5.59188 48.2198 7.01548 48.774ZM25.052 18.9143C21.6325 18.9143 18.8613 21.6871 18.8613 25.1065C18.8613 28.526 21.6325 31.2988 25.052 31.2988C28.4715 31.2988 31.2442 28.526 31.2442 25.1065C31.2442 21.6871 28.4715 18.9143 25.052 18.9143ZM25.052 34.6447C19.7841 34.6447 15.5139 30.3745 15.5139 25.1065H15.514C15.514 19.8383 19.7841 15.5684 25.052 15.5684C30.3199 15.5684 34.5902 19.8386 34.5902 25.1065C34.5902 30.3745 30.3199 34.6447 25.052 34.6447ZM33.114 16.4287C32.8693 16.0621 32.7387 15.6311 32.7389 15.1902C32.7394 14.5993 32.9744 14.0327 33.3924 13.6149C33.8103 13.1972 34.377 12.9624 34.9679 12.9621H34.9688C35.4097 12.9623 35.8406 13.0932 36.207 13.3382C36.5735 13.5833 36.8591 13.9315 37.0276 14.3389C37.1961 14.7463 37.2401 15.1945 37.1539 15.6268C37.0677 16.0592 36.8553 16.4563 36.5434 16.7679C36.2316 17.0795 35.8343 17.2916 35.4019 17.3775C34.9695 17.4633 34.5213 17.419 34.1141 17.2501C33.7068 17.0812 33.3588 16.7954 33.114 16.4287ZM14.0981 39.5875C14.7523 39.8423 15.7366 40.144 17.5476 40.2265V40.2268C19.505 40.3168 20.0915 40.3348 25.052 40.3348C30.0125 40.3348 30.6007 40.3168 32.5586 40.2268C34.3696 40.1444 35.3543 39.8428 36.0081 39.5878C36.8754 39.2502 37.495 38.8474 38.1447 38.1984C38.7944 37.5493 39.1965 36.9305 39.5341 36.0632C39.7875 35.4091 40.0907 34.4248 40.1731 32.6138C40.2632 30.6541 40.2812 30.0676 40.2812 25.1071C40.2812 20.1467 40.2632 19.5601 40.1731 17.6005C40.0908 15.7895 39.7891 14.8049 39.5341 14.151C39.1965 13.2838 38.7953 12.6641 38.1447 12.0144C37.4941 11.3648 36.8754 10.9612 36.0081 10.625C35.3523 10.3724 34.3696 10.0685 32.5586 9.98603C30.599 9.89687 30.0103 9.8777 25.052 9.8777C20.0938 9.8777 19.5056 9.89568 17.5476 9.98574C15.7366 10.0681 14.752 10.3697 14.0981 10.6247C13.2294 10.9609 12.6112 11.3636 11.9615 12.0141C11.3119 12.6647 10.9097 13.2835 10.5721 14.1507C10.3195 14.8065 10.0156 15.7892 9.93313 17.6002C9.84457 19.5598 9.8251 20.1464 9.8251 25.1068C9.8251 30.0673 9.84308 30.6555 9.93313 32.6135C10.0155 34.4245 10.3171 35.4091 10.5721 36.063C10.9083 36.9302 11.311 37.5484 11.9615 38.1981C12.6121 38.8477 13.2309 39.2499 14.0981 39.5875ZM12.8851 7.50661C14.0652 7.04744 15.4164 6.73389 17.3938 6.64383H17.3946C19.3762 6.55229 20.0106 6.53134 25.0542 6.53134C30.0979 6.53134 30.7308 6.55333 32.7117 6.64383C34.6876 6.7324 36.0381 7.04744 37.2204 7.50661C38.4403 7.9808 39.4772 8.61533 40.5094 9.64915C41.5416 10.683 42.1764 11.7183 42.652 12.9396C43.1111 14.1197 43.4247 15.4708 43.5147 17.4484C43.6048 19.4289 43.6257 20.0621 43.6257 25.1065C43.6257 30.151 43.6048 30.7827 43.5147 32.7647C43.4262 34.7422 43.1111 36.0927 42.652 37.2735C42.1764 38.4948 41.5432 39.5318 40.5094 40.5639C39.4756 41.5961 38.4403 42.231 37.2189 42.7065C36.0381 43.1657 34.6878 43.4792 32.7102 43.5693C30.7296 43.6608 30.0964 43.6818 25.052 43.6818C20.0076 43.6818 19.3754 43.6593 17.3938 43.5693C15.4164 43.4792 14.0674 43.1657 12.8851 42.7065C11.6623 42.231 10.6283 41.5957 9.59462 40.5639C8.56094 39.5322 7.92627 38.4948 7.45208 37.2735C6.9929 36.0927 6.67935 34.7423 6.5893 32.7647C6.49776 30.7842 6.47681 30.151 6.47681 25.1065C6.47681 20.0621 6.49776 19.4289 6.5893 17.4484C6.67935 15.4709 6.9929 14.1204 7.45208 12.9396C7.92627 11.7168 8.5608 10.6813 9.59462 9.64915C10.6284 8.61697 11.6637 7.9808 12.8851 7.50661Z"
							/>
						</mask>
						<path
							d="M12.6787 49.8232L12.7249 48.8242L12.7241 48.8242L12.6787 49.8232ZM7.01548 48.774L7.37886 47.8424L7.37831 47.8422L7.01548 48.774ZM37.3228 49.8232L37.2774 48.8242L37.2771 48.8242L37.3228 49.8232ZM42.986 48.774L42.6232 47.8422L42.6226 47.8424L42.986 48.774ZM46.493 46.493L45.7859 45.7859L45.7859 45.7859L46.493 46.493ZM48.774 42.9875L49.7059 43.3503L49.7065 43.3486L48.774 42.9875ZM49.8232 37.3243L48.8242 37.2786L48.8242 37.2789L49.8232 37.3243ZM49.8232 12.6772L48.8242 12.7226L48.8242 12.7229L49.8232 12.6772ZM48.774 7.014L47.8422 7.37682L47.8424 7.37738L48.774 7.014ZM46.493 3.507L45.7864 4.2146V4.2146L46.493 3.507ZM42.986 1.22596L43.3471 0.293448L43.3463 0.293116L42.986 1.22596ZM37.3228 0.176836L37.3682 -0.822132L37.3676 -0.822162L37.3228 0.176836ZM12.6772 0.176836L12.7226 1.1758L12.7229 1.17579L12.6772 0.176836ZM7.014 1.22596L7.3748 2.15861L7.37738 2.15761L7.014 1.22596ZM3.507 3.507L2.79989 2.79989L2.79842 2.80137L3.507 3.507ZM1.22596 7.01548L0.294102 6.65266L0.293116 6.65521L1.22596 7.01548ZM0.176836 12.6787L-0.822132 12.6333L-0.822162 12.6339L0.176836 12.6787ZM0.178322 37.3243L1.17729 37.2789L1.17726 37.2781L0.178322 37.3243ZM1.22745 42.9875L2.15997 42.6264L2.15909 42.6241L1.22745 42.9875ZM3.50849 46.493L4.2151 45.7854L4.2151 45.7854L3.50849 46.493ZM15.5139 25.1065V24.1065H14.5139V25.1065H15.5139ZM15.514 25.1065V26.1065H16.514V25.1065H15.514ZM32.7389 15.1902L31.7389 15.1893V15.1898L32.7389 15.1902ZM33.114 16.4287L33.9457 15.8735L33.9457 15.8735L33.114 16.4287ZM33.3924 13.6149L34.0993 14.3222V14.3222L33.3924 13.6149ZM34.9679 12.9621V11.9621H34.9674L34.9679 12.9621ZM34.9688 12.9621L34.9692 11.9621H34.9688V12.9621ZM36.207 13.3382L35.6511 14.1695L35.6511 14.1695L36.207 13.3382ZM37.0276 14.3389L37.9516 13.9566L37.9516 13.9566L37.0276 14.3389ZM37.1539 15.6268L36.1732 15.4314L36.1732 15.4314L37.1539 15.6268ZM36.5434 16.7679L37.2503 17.4753V17.4753L36.5434 16.7679ZM35.4019 17.3775L35.2072 16.3966L35.4019 17.3775ZM17.5476 40.2265H18.5476V39.271L17.5931 39.2275L17.5476 40.2265ZM14.0981 39.5875L14.4612 38.6557L14.4609 38.6556L14.0981 39.5875ZM17.5476 40.2268H16.5476V41.1818L17.5017 41.2257L17.5476 40.2268ZM32.5586 40.2268L32.5132 39.2278L32.5127 39.2278L32.5586 40.2268ZM36.0081 39.5878L35.6453 38.6559L35.6448 38.6561L36.0081 39.5878ZM38.1447 38.1984L37.4379 37.4909L37.4379 37.4909L38.1447 38.1984ZM39.5341 36.0632L40.466 36.426L40.4666 36.4244L39.5341 36.0632ZM40.1731 32.6138L39.1742 32.5678L39.1742 32.5683L40.1731 32.6138ZM40.1731 17.6005L39.1742 17.6459L39.1742 17.6464L40.1731 17.6005ZM39.5341 14.151L38.6023 14.5138L38.6025 14.5144L39.5341 14.151ZM38.1447 12.0144L38.8513 11.3069L38.1447 12.0144ZM36.0081 10.625L36.3695 9.69261L36.3676 9.69187L36.0081 10.625ZM32.5586 9.98603L32.6041 8.98707L32.6041 8.98707L32.5586 9.98603ZM17.5476 9.98574L17.593 10.9847L17.5936 10.9847L17.5476 9.98574ZM14.0981 10.6247L14.459 11.5573L14.4615 11.5564L14.0981 10.6247ZM11.9615 12.0141L12.6691 12.7208L11.9615 12.0141ZM10.5721 14.1507L9.64024 13.788L9.63896 13.7913L10.5721 14.1507ZM9.93313 17.6002L8.93417 17.5547L8.93415 17.5551L9.93313 17.6002ZM9.93313 32.6135L10.9321 32.568L10.9321 32.5675L9.93313 32.6135ZM10.5721 36.063L11.5045 35.7015L11.5038 35.6996L10.5721 36.063ZM11.9615 38.1981L12.6682 37.4905L12.6682 37.4905L11.9615 38.1981ZM17.3938 6.64383V5.64383H17.3711L17.3483 5.64487L17.3938 6.64383ZM12.8851 7.50661L13.247 8.43882L13.2477 8.43855L12.8851 7.50661ZM17.3946 6.64383V7.64383H17.4177L17.4407 7.64277L17.3946 6.64383ZM32.7117 6.64383L32.666 7.64279L32.6669 7.64283L32.7117 6.64383ZM37.2204 7.50661L37.5827 6.57456L37.5824 6.57445L37.2204 7.50661ZM40.5094 9.64915L39.8017 10.3557L39.8017 10.3557L40.5094 9.64915ZM42.652 12.9396L43.5839 12.577L43.5838 12.5768L42.652 12.9396ZM43.5147 17.4484L44.5137 17.4029V17.4029L43.5147 17.4484ZM43.5147 32.7647L42.5158 32.7193L42.5157 32.72L43.5147 32.7647ZM42.652 37.2735L43.5838 37.6363L43.584 37.6359L42.652 37.2735ZM40.5094 40.5639L39.8029 39.8563V39.8563L40.5094 40.5639ZM37.2189 42.7065L37.5814 43.6385L37.5817 43.6383L37.2189 42.7065ZM32.7102 43.5693L32.6647 42.5703L32.664 42.5703L32.7102 43.5693ZM17.3938 43.5693L17.3483 44.5682L17.3484 44.5682L17.3938 43.5693ZM12.8851 42.7065L12.5227 43.6385L12.5231 43.6386L12.8851 42.7065ZM7.45208 37.2735L8.38429 36.9115L8.38409 36.911L7.45208 37.2735ZM6.5893 32.7647L7.58826 32.7192L7.58823 32.7186L6.5893 32.7647ZM6.5893 17.4484L7.58823 17.4945L7.58826 17.4939L6.5893 17.4484ZM7.45208 12.9396L8.38409 13.3021L8.38443 13.3012L7.45208 12.9396ZM9.59462 9.64915L10.3012 10.3568L9.59462 9.64915ZM12.7241 48.8242C9.86004 48.6939 8.35211 48.222 7.37886 47.8424L6.65211 49.7057C7.82764 50.1642 9.55031 50.6819 12.6333 50.8221L12.7241 48.8242ZM24.9993 49C16.8623 49 15.9152 48.9717 12.7249 48.8242L12.6325 50.8221C15.8707 50.9718 16.8554 51 24.9993 51V49ZM37.2771 48.8242C34.0862 48.9703 33.1387 49 24.9993 49V51C33.1465 51 34.1308 50.9703 37.3685 50.8221L37.2771 48.8242ZM42.6226 47.8424C41.6494 48.222 40.1415 48.6939 37.2774 48.8242L37.3682 50.8221C40.4512 50.6819 42.1738 50.1642 43.3494 49.7057L42.6226 47.8424ZM45.7859 45.7859C44.8187 46.7531 43.9201 47.3372 42.6232 47.8422L43.3488 49.7059C44.8991 49.1023 46.0334 48.3668 47.2001 47.2001L45.7859 45.7859ZM47.8422 42.6247C47.3374 43.9212 46.7534 44.8184 45.7859 45.7859L47.2001 47.2001C48.3665 46.0337 49.1021 44.901 49.7059 43.3503L47.8422 42.6247ZM48.8242 37.2789C48.694 40.1416 48.2195 41.6504 47.8415 42.6263L49.7065 43.3486C50.1608 42.1758 50.6819 40.454 50.8221 37.3697L48.8242 37.2789ZM49 25.0007C49 33.1372 48.9703 34.0848 48.8242 37.2786L50.8221 37.37C50.9703 34.1293 51 33.1451 51 25.0007H49ZM48.8242 12.7229C48.9703 15.9167 49 16.8613 49 25.0007H51C51 16.8534 50.9703 15.8721 50.8221 12.6315L48.8242 12.7229ZM47.8424 7.37738C48.222 8.35062 48.6939 9.85855 48.8242 12.7226L50.8221 12.6318C50.6819 9.54883 50.1642 7.82616 49.7057 6.65062L47.8424 7.37738ZM45.7864 4.2146C46.7543 5.18115 47.337 6.07939 47.8422 7.37682L49.7059 6.65118C49.1025 5.1014 48.3686 3.96677 47.1996 2.7994L45.7864 4.2146ZM42.6249 2.15848C43.919 2.65963 44.8162 3.2458 45.7864 4.2146L47.1996 2.7994C46.0329 1.63428 44.9003 0.894918 43.3471 0.293449L42.6249 2.15848ZM37.2774 1.1758C40.1397 1.30598 41.6459 1.78039 42.6257 2.15881L43.3463 0.293116C42.1714 -0.16063 40.4529 -0.681848 37.3682 -0.822132L37.2774 1.1758ZM24.9993 1C33.1378 1 34.0832 1.03269 37.278 1.17583L37.3676 -0.822162C34.1279 -0.96731 33.1474 -1 24.9993 -1V1ZM12.7229 1.17579C15.9152 1.02975 16.8628 1 24.9993 1V-1C16.8549 -1 15.8707 -0.970306 12.6315 -0.822119L12.7229 1.17579ZM7.37738 2.15761C8.35062 1.778 9.85855 1.30605 12.7226 1.1758L12.6318 -0.822132C9.54883 -0.681927 7.82616 -0.164187 6.65062 0.294322L7.37738 2.15761ZM4.21411 4.21411C5.18242 3.24579 6.07936 2.65976 7.3748 2.15861L6.6532 0.293322C5.09846 0.894789 3.9655 1.63428 2.79989 2.79989L4.21411 4.21411ZM2.15782 7.37831C2.6624 6.08237 3.24794 5.18432 4.21558 4.21263L2.79842 2.80137C1.63511 3.96955 0.898097 5.10139 0.294105 6.65266L2.15782 7.37831ZM1.1758 12.7241C1.30598 9.86178 1.78039 8.3556 2.15881 7.37576L0.293116 6.65521C-0.16063 7.83009 -0.681848 9.54857 -0.822132 12.6333L1.1758 12.7241ZM1 25.0022C1 16.8637 1.03269 15.9183 1.17583 12.7235L-0.822162 12.6339C-0.96731 15.8736 -1 16.8541 -1 25.0022H1ZM1.17726 37.2781C1.02975 34.0875 1 33.1417 1 25.0022H-1C-1 33.1495 -0.970308 34.1325 -0.820611 37.3705L1.17726 37.2781ZM2.15909 42.6241C1.77949 41.6509 1.30754 40.1429 1.17729 37.2789L-0.820646 37.3697C-0.680441 40.4527 -0.162701 42.1753 0.295809 43.3509L2.15909 42.6241ZM4.2151 45.7854C3.24603 44.8177 2.66133 43.921 2.15997 42.6264L0.294934 43.3486C0.896191 44.9012 1.63404 46.0344 2.80187 47.2006L4.2151 45.7854ZM7.37831 47.8422C6.08182 47.3374 5.18436 46.7533 4.2151 45.7854L2.80187 47.2006C3.9695 48.3666 5.10195 49.1021 6.65266 49.7059L7.37831 47.8422ZM19.8613 25.1065C19.8613 22.239 22.1851 19.9143 25.052 19.9143V17.9143C21.0799 17.9143 17.8613 21.1351 17.8613 25.1065H19.8613ZM25.052 30.2988C22.1851 30.2988 19.8613 27.974 19.8613 25.1065H17.8613C17.8613 29.078 21.0799 32.2988 25.052 32.2988V30.2988ZM30.2442 25.1065C30.2442 27.9737 27.9192 30.2988 25.052 30.2988V32.2988C29.0238 32.2988 32.2442 29.0783 32.2442 25.1065H30.2442ZM25.052 19.9143C27.9192 19.9143 30.2442 22.2394 30.2442 25.1065H32.2442C32.2442 21.1348 29.0238 17.9143 25.052 17.9143V19.9143ZM14.5139 25.1065C14.5139 30.9268 19.2318 35.6447 25.052 35.6447V33.6447C20.3364 33.6447 16.5139 29.8222 16.5139 25.1065H14.5139ZM15.514 24.1065H15.5139V26.1065H15.514V24.1065ZM25.052 14.5684C19.2318 14.5684 14.514 19.286 14.514 25.1065H16.514C16.514 20.3906 20.3364 16.5684 25.052 16.5684V14.5684ZM35.5902 25.1065C35.5902 19.2863 30.8722 14.5684 25.052 14.5684V16.5684C29.7677 16.5684 33.5902 20.3909 33.5902 25.1065H35.5902ZM25.052 35.6447C30.8722 35.6447 35.5902 30.9268 35.5902 25.1065H33.5902C33.5902 29.8222 29.7677 33.6447 25.052 33.6447V35.6447ZM31.7389 15.1898C31.7386 15.8285 31.9278 16.4528 32.2824 16.984L33.9457 15.8735C33.8108 15.6713 33.7388 15.4337 33.7389 15.1906L31.7389 15.1898ZM32.6854 12.9077C32.0801 13.5128 31.7396 14.3334 31.7389 15.1893L33.7389 15.1911C33.7392 14.8651 33.8688 14.5526 34.0993 14.3222L32.6854 12.9077ZM34.9674 11.9621C34.1115 11.9625 33.2908 12.3026 32.6854 12.9077L34.0993 14.3222C34.3299 14.0917 34.6424 13.9622 34.9684 13.9621L34.9674 11.9621ZM34.9688 11.9621H34.9679V13.9621H34.9688V11.9621ZM36.7629 12.507C36.2321 12.152 35.6078 11.9623 34.9692 11.9621L34.9684 13.9621C35.2115 13.9622 35.4491 14.0344 35.6511 14.1695L36.7629 12.507ZM37.9516 13.9566C37.7075 13.3665 37.2938 12.862 36.7629 12.507L35.6511 14.1695C35.8532 14.3046 36.0106 14.4966 36.1036 14.7212L37.9516 13.9566ZM38.1346 15.8223C38.2595 15.196 38.1958 14.5467 37.9516 13.9566L36.1036 14.7212C36.1965 14.9458 36.2207 15.193 36.1732 15.4314L38.1346 15.8223ZM37.2503 17.4753C37.702 17.0239 38.0098 16.4486 38.1346 15.8223L36.1732 15.4314C36.1257 15.6697 36.0086 15.8887 35.8366 16.0605L37.2503 17.4753ZM35.5966 18.3583C36.223 18.234 36.7985 17.9267 37.2503 17.4753L35.8366 16.0605C35.6647 16.2323 35.4456 16.3493 35.2072 16.3966L35.5966 18.3583ZM33.731 18.1738C34.321 18.4185 34.9702 18.4827 35.5966 18.3583L35.2072 16.3966C34.9688 16.4439 34.7217 16.4195 34.4971 16.3264L33.731 18.1738ZM32.2824 16.984C32.637 17.5151 33.1411 17.9292 33.731 18.1738L34.4971 16.3264C34.2726 16.2333 34.0807 16.0757 33.9457 15.8735L32.2824 16.984ZM17.5931 39.2275C15.8916 39.15 15.0145 38.8713 14.4612 38.6557L13.7351 40.5193C14.4901 40.8134 15.5816 41.138 17.5021 41.2254L17.5931 39.2275ZM18.5476 40.2268V40.2265H16.5476V40.2268H18.5476ZM25.052 39.3348C20.0954 39.3348 19.5274 39.3168 17.5936 39.2278L17.5017 41.2257C19.4826 41.3168 20.0877 41.3348 25.052 41.3348V39.3348ZM32.5127 39.2278C30.5783 39.3168 30.0086 39.3348 25.052 39.3348V41.3348C30.0163 41.3348 30.623 41.3168 32.6046 41.2257L32.5127 39.2278ZM35.6448 38.6561C35.092 38.8717 34.2148 39.1504 32.5132 39.2278L32.604 41.2257C34.5245 41.1384 35.6165 40.8139 36.3715 40.5194L35.6448 38.6561ZM37.4379 37.4909C36.8877 38.0407 36.3856 38.3677 35.6453 38.6559L36.3709 40.5197C37.3651 40.1326 38.1024 39.6542 38.8515 38.9058L37.4379 37.4909ZM38.6023 35.7005C38.3141 36.4407 37.9878 36.9416 37.4379 37.4909L38.8515 38.9058C39.601 38.1569 40.079 37.4202 40.466 36.426L38.6023 35.7005ZM39.1742 32.5683C39.0967 34.2687 38.8168 35.1465 38.6016 35.7021L40.4666 36.4244C40.7582 35.6717 41.0846 34.5809 41.1721 32.6592L39.1742 32.5683ZM39.2812 25.1071C39.2812 30.0638 39.2631 30.6318 39.1742 32.5678L41.1721 32.6597C41.2632 30.6765 41.2812 30.0715 41.2812 25.1071H39.2812ZM39.1742 17.6464C39.2631 19.5825 39.2812 20.1505 39.2812 25.1071H41.2812C41.2812 20.1428 41.2632 19.5378 41.1721 17.5546L39.1742 17.6464ZM38.6025 14.5144C38.8181 15.0671 39.0968 15.9444 39.1742 17.6459L41.1721 17.5551C41.0848 15.6346 40.7602 14.5426 40.4658 13.7877L38.6025 14.5144ZM37.4381 12.722C37.988 13.2712 38.3137 13.7727 38.6023 14.5138L40.466 13.7883C40.0793 12.7949 39.6025 12.057 38.8513 11.3069L37.4381 12.722ZM35.6467 11.5574C36.385 11.8436 36.8861 12.1708 37.4381 12.722L38.8513 11.3069C38.1022 10.5587 37.3657 10.0787 36.3695 9.69261L35.6467 11.5574ZM32.5131 10.985C34.2126 11.0624 35.0895 11.3428 35.6486 11.5582L36.3676 9.69187C35.6152 9.40202 34.5267 9.07462 32.6041 8.98707L32.5131 10.985ZM25.052 10.8777C30.0059 10.8777 30.5766 10.8969 32.5132 10.985L32.6041 8.98707C30.6215 8.89686 30.0147 8.8777 25.052 8.8777V10.8777ZM17.5936 10.9847C19.528 10.8957 20.0976 10.8777 25.052 10.8777V8.8777C20.0899 8.8777 19.4832 8.89565 17.5017 8.98679L17.5936 10.9847ZM14.4615 11.5564C15.0142 11.3408 15.8915 11.0621 17.593 10.9847L17.5022 8.98677C15.5817 9.07407 14.4897 9.39864 13.7348 9.69307L14.4615 11.5564ZM12.6691 12.7208C13.2194 12.1697 13.7192 11.8436 14.459 11.5573L13.7373 9.6921C12.7396 10.0781 12.003 10.5574 11.254 11.3075L12.6691 12.7208ZM11.504 14.5135C11.7922 13.7733 12.1186 13.2721 12.6691 12.7208L11.254 11.3075C10.5051 12.0574 10.0273 12.7937 9.64025 13.788L11.504 14.5135ZM10.9321 17.6457C11.0095 15.9463 11.2899 15.0694 11.5053 14.5102L9.63896 13.7913C9.34912 14.5437 9.02172 15.6322 8.93417 17.5547L10.9321 17.6457ZM10.8251 25.1068C10.8251 20.1509 10.8446 19.5822 10.9321 17.6454L8.93415 17.5551C8.84456 19.5375 8.8251 20.1418 8.8251 25.1068H10.8251ZM10.9321 32.5675C10.8431 30.6331 10.8251 30.0635 10.8251 25.1068H8.8251C8.8251 30.0712 8.84305 30.6778 8.93419 32.6594L10.9321 32.5675ZM11.5038 35.6996C11.2882 35.1469 11.0094 34.2696 10.9321 32.568L8.93417 32.6589C9.02147 34.5794 9.34604 35.6714 9.64046 36.4263L11.5038 35.6996ZM12.6682 37.4905C12.117 36.9401 11.7908 36.4401 11.5045 35.7015L9.63971 36.4244C10.0257 37.4203 10.5049 38.1567 11.2549 38.9056L12.6682 37.4905ZM14.4609 38.6556C13.7207 38.3674 13.2195 38.041 12.6682 37.4905L11.2549 38.9056C12.0048 39.6545 12.7411 40.1323 13.7354 40.5194L14.4609 38.6556ZM17.3483 5.64487C15.2764 5.73922 13.8163 6.07122 12.5225 6.57468L13.2477 8.43855C14.314 8.02365 15.5563 7.72855 17.4393 7.6428L17.3483 5.64487ZM17.3946 5.64383H17.3938V7.64383H17.3946V5.64383ZM25.0542 5.53134C20.0059 5.53134 19.3533 5.55228 17.3484 5.6449L17.4407 7.64277C19.399 7.5523 20.0152 7.53134 25.0542 7.53134V5.53134ZM32.7573 5.64488C30.7537 5.55334 30.1031 5.53134 25.0542 5.53134V7.53134C30.0928 7.53134 30.7079 7.55333 32.666 7.64279L32.7573 5.64488ZM37.5824 6.57445C36.2874 6.07149 34.8283 5.7377 32.7565 5.64484L32.6669 7.64283C34.547 7.7271 35.7888 8.02338 36.8584 8.43878L37.5824 6.57445ZM41.2171 8.94261C40.0794 7.80308 38.9221 7.09519 37.5827 6.57456L36.8581 8.43867C37.9585 8.86641 38.8751 9.42758 39.8017 10.3557L41.2171 8.94261ZM43.5838 12.5768C43.0617 11.2359 42.3538 10.0811 41.2171 8.94261L39.8017 10.3557C40.7294 11.2849 41.2911 12.2007 41.7201 13.3025L43.5838 12.5768ZM44.5137 17.4029C44.4193 15.3308 44.0873 13.8708 43.5839 12.577L41.72 13.3023C42.1349 14.3685 42.43 15.6107 42.5158 17.4939L44.5137 17.4029ZM44.6257 25.1065C44.6257 20.0574 44.6048 19.4063 44.5137 17.4029L42.5158 17.4938C42.6048 19.4515 42.6257 20.0668 42.6257 25.1065H44.6257ZM44.5137 32.8101C44.6048 30.8053 44.6257 30.1557 44.6257 25.1065H42.6257C42.6257 30.1462 42.6048 30.7601 42.5158 32.7193L44.5137 32.8101ZM43.584 37.6359C44.0871 36.342 44.4209 34.8826 44.5137 32.8095L42.5157 32.72C42.4315 34.6017 42.1351 35.8433 41.7199 36.911L43.584 37.6359ZM41.216 41.2716C42.3559 40.1334 43.0622 38.9761 43.5838 37.6363L41.7201 36.9106C41.2907 38.0136 40.7305 38.9301 39.8029 39.8563L41.216 41.2716ZM37.5817 43.6383C38.9227 43.1163 40.0775 42.4083 41.216 41.2716L39.8029 39.8563C38.8737 40.784 37.9579 41.3456 36.8561 41.7746L37.5817 43.6383ZM32.7557 44.5682C34.8279 44.4739 36.287 44.1418 37.5814 43.6385L36.8565 41.7745C35.7893 42.1895 34.5477 42.4846 32.6647 42.5703L32.7557 44.5682ZM25.052 44.6818C30.1011 44.6818 30.7525 44.6608 32.7564 44.5682L32.664 42.5703C30.7068 42.6608 30.0918 42.6818 25.052 42.6818V44.6818ZM17.3484 44.5682C19.3525 44.6593 20.0022 44.6818 25.052 44.6818V42.6818C20.0129 42.6818 19.3984 42.6593 17.4392 42.5703L17.3484 44.5682ZM12.5231 43.6386C13.8185 44.1418 15.2761 44.4739 17.3483 44.5682L17.4393 42.5703C15.5567 42.4846 14.3163 42.1895 13.2471 41.7743L12.5231 43.6386ZM8.88817 41.2717C10.0261 42.4075 11.1795 43.1162 12.5227 43.6385L13.2475 41.7745C12.145 41.3457 11.2305 40.7838 10.3011 39.8562L8.88817 41.2717ZM6.51987 37.6354C7.04051 38.9764 7.74861 40.1343 8.88817 41.2717L10.3011 39.8562C9.37328 38.9301 8.81203 38.0133 8.38429 36.9115L6.51987 37.6354ZM5.59033 32.8102C5.68469 34.8824 6.01672 36.3415 6.52007 37.6359L8.38409 36.911C7.96908 35.8438 7.67401 34.6022 7.58826 32.7192L5.59033 32.8102ZM5.47681 25.1065C5.47681 30.1556 5.49775 30.8071 5.59036 32.8109L7.58823 32.7186C7.49777 30.7613 7.47681 30.1463 7.47681 25.1065H5.47681ZM5.59036 17.4022C5.49775 19.406 5.47681 20.0575 5.47681 25.1065H7.47681C7.47681 20.0668 7.49777 19.4518 7.58823 17.4945L5.59036 17.4022ZM6.52007 12.5772C6.01672 13.8716 5.68469 15.3308 5.59033 17.4029L7.58826 17.4939C7.67401 15.611 7.96908 14.3693 8.38409 13.3021L6.52007 12.5772ZM8.88807 8.94149C7.74873 10.079 7.04057 11.2349 6.51972 12.5781L8.38443 13.3012C8.81196 12.1987 9.37286 11.2837 10.3012 10.3568L8.88807 8.94149ZM12.5232 6.57441C11.181 7.09551 10.0261 7.80523 8.88807 8.94149L10.3012 10.3568C11.2308 9.4287 12.1465 8.8661 13.247 8.43882L12.5232 6.57441Z"
							fill="black"
							fillOpacity="0.2"
							mask="url(#path-1-inside-1_1561_2175)"
						/>
					</g>
				</g>
				<defs>
					<clipPath id="clip0_1561_2175">
						<rect width="50" height="50" fill="white" />
					</clipPath>
					<clipPath id="clip1_1561_2175">
						<rect width="50" height="50" fill="white" />
					</clipPath>
				</defs>
			</svg>,
		],
		[
			"tiktok_overlay",
			<svg
				width={ICON_SIZE}
				height={ICON_SIZE}
				xmlns="http://www.w3.org/2000/svg"
				viewBox="0 0 50 50"
			>
				<g opacity="0.2">
					<path d="M34.07,1a14.71,14.71,0,0,0,1.67,5.61c1.41,2.58,4.31,5.68,10.2,6.21v6.75c-2.19-.23-7.31-1-10.25-3.71L34,14.35V33.44A19.06,19.06,0,0,1,33.89,36,15,15,0,0,1,19,49a15.33,15.33,0,0,1-2-.13,14.91,14.91,0,0,1-10-5.72,14.74,14.74,0,0,1-3-11A15,15,0,0,1,19,19.2c.36,0,.73,0,1.09,0v6.91A8,8,0,0,0,19,26.08a8.07,8.07,0,0,0-8.1,8,7.93,7.93,0,0,0,2.34,5.65A8.09,8.09,0,0,0,27.08,34.1V1h7M35,0H26.08V34.1a7,7,0,0,1-7.07,7h0a7,7,0,1,1,0-14,7.44,7.44,0,0,1,2.08.31v-9A16.4,16.4,0,0,0,19,18.2a15.89,15.89,0,0,0-2.08,31.67A16.28,16.28,0,0,0,19,50,16,16,0,0,0,34.89,36.15,20.14,20.14,0,0,0,35,33.44V16.61c4.11,3.73,11.92,4.05,11.92,4.05V11.89C35.3,11.41,35,1,35,0Z" />
				</g>
			</svg>,
		],
		[
			AVAILABLE_ICONS.QR_CODE,
			<svg
				width="251"
				height="251"
				viewBox="0 0 251 251"
				fill="none"
				xmlns="http://www.w3.org/2000/svg"
				className={className}
			>
				<g filter="url(#filter0_d_2351_4988)">
					<rect x="30" y="10" width="191" height="191" rx="10" fill="white" />
				</g>
				<path d="M96.2123 28H90.7129V33.4995H96.2123V28Z" fill="black" />
				<path d="M112.233 28H106.733V33.4995H112.233V28Z" fill="black" />
				<path d="M117.572 28H112.072V33.4995H117.572V28Z" fill="black" />
				<path d="M122.911 28H117.411V33.4995H122.911V28Z" fill="black" />
				<path d="M133.593 28H128.094V33.4995H133.593V28Z" fill="black" />
				<path d="M138.932 28H133.433V33.4995H138.932V28Z" fill="black" />
				<path d="M144.267 28H138.768V33.4995H144.267V28Z" fill="black" />
				<path d="M154.946 28H149.446V33.4995H154.946V28Z" fill="black" />
				<path d="M160.285 28H154.785V33.4995H160.285V28Z" fill="black" />
				<path
					d="M101.551 33.3359H96.0518V38.8354H101.551V33.3359Z"
					fill="black"
				/>
				<path
					d="M106.89 33.3359H101.391V38.8354H106.89V33.3359Z"
					fill="black"
				/>
				<path
					d="M122.911 33.3359H117.411V38.8354H122.911V33.3359Z"
					fill="black"
				/>
				<path
					d="M133.593 33.3359H128.094V38.8354H133.593V33.3359Z"
					fill="black"
				/>
				<path
					d="M138.932 33.3359H133.433V38.8354H138.932V33.3359Z"
					fill="black"
				/>
				<path
					d="M144.267 33.3359H138.768V38.8354H144.267V33.3359Z"
					fill="black"
				/>
				<path
					d="M160.285 33.3359H154.785V38.8354H160.285V33.3359Z"
					fill="black"
				/>
				<path
					d="M101.551 38.6797H96.0518V44.1791H101.551V38.6797Z"
					fill="black"
				/>
				<path
					d="M106.89 38.6797H101.391V44.1791H106.89V38.6797Z"
					fill="black"
				/>
				<path
					d="M122.911 38.6797H117.411V44.1791H122.911V38.6797Z"
					fill="black"
				/>
				<path
					d="M149.607 38.6797H144.107V44.1791H149.607V38.6797Z"
					fill="black"
				/>
				<path
					d="M112.233 44.0117H106.733V49.5112H112.233V44.0117Z"
					fill="black"
				/>
				<path
					d="M128.25 44.0117H122.751V49.5112H128.25V44.0117Z"
					fill="black"
				/>
				<path
					d="M133.593 44.0117H128.094V49.5112H133.593V44.0117Z"
					fill="black"
				/>
				<path
					d="M144.267 44.0117H138.768V49.5112H144.267V44.0117Z"
					fill="black"
				/>
				<path
					d="M96.2123 49.3555H90.7129V54.8549H96.2123V49.3555Z"
					fill="black"
				/>
				<path
					d="M101.551 49.3555H96.0518V54.8549H101.551V49.3555Z"
					fill="black"
				/>
				<path
					d="M117.572 49.3555H112.072V54.8549H117.572V49.3555Z"
					fill="black"
				/>
				<path
					d="M138.932 49.3555H133.433V54.8549H138.932V49.3555Z"
					fill="black"
				/>
				<path
					d="M149.607 49.3555H144.107V54.8549H149.607V49.3555Z"
					fill="black"
				/>
				<path
					d="M154.946 49.3555H149.446V54.8549H154.946V49.3555Z"
					fill="black"
				/>
				<path
					d="M160.285 49.3555H154.785V54.8549H160.285V49.3555Z"
					fill="black"
				/>
				<path
					d="M96.2123 54.6914H90.7129V60.1909H96.2123V54.6914Z"
					fill="black"
				/>
				<path
					d="M106.89 54.6914H101.391V60.1909H106.89V54.6914Z"
					fill="black"
				/>
				<path
					d="M122.911 54.6914H117.411V60.1909H122.911V54.6914Z"
					fill="black"
				/>
				<path
					d="M128.25 54.6914H122.751V60.1909H128.25V54.6914Z"
					fill="black"
				/>
				<path
					d="M133.593 54.6914H128.094V60.1909H133.593V54.6914Z"
					fill="black"
				/>
				<path
					d="M149.607 54.6914H144.107V60.1909H149.607V54.6914Z"
					fill="black"
				/>
				<path
					d="M160.285 54.6914H154.785V60.1909H160.285V54.6914Z"
					fill="black"
				/>
				<path
					d="M96.2123 60.0352H90.7129V65.5346H96.2123V60.0352Z"
					fill="black"
				/>
				<path
					d="M106.89 60.0352H101.391V65.5346H106.89V60.0352Z"
					fill="black"
				/>
				<path
					d="M117.572 60.0352H112.072V65.5346H117.572V60.0352Z"
					fill="black"
				/>
				<path
					d="M128.25 60.0352H122.751V65.5346H128.25V60.0352Z"
					fill="black"
				/>
				<path
					d="M138.932 60.0352H133.433V65.5346H138.932V60.0352Z"
					fill="black"
				/>
				<path
					d="M149.607 60.0352H144.107V65.5346H149.607V60.0352Z"
					fill="black"
				/>
				<path
					d="M160.285 60.0352H154.785V65.5346H160.285V60.0352Z"
					fill="black"
				/>
				<path
					d="M101.551 65.3711H96.0518V70.8705H101.551V65.3711Z"
					fill="black"
				/>
				<path
					d="M112.233 65.3711H106.733V70.8705H112.233V65.3711Z"
					fill="black"
				/>
				<path
					d="M117.572 65.3711H112.072V70.8705H117.572V65.3711Z"
					fill="black"
				/>
				<path
					d="M122.911 65.3711H117.411V70.8705H122.911V65.3711Z"
					fill="black"
				/>
				<path
					d="M138.932 65.3711H133.433V70.8705H138.932V65.3711Z"
					fill="black"
				/>
				<path
					d="M149.607 65.3711H144.107V70.8705H149.607V65.3711Z"
					fill="black"
				/>
				<path
					d="M154.946 65.3711H149.446V70.8705H154.946V65.3711Z"
					fill="black"
				/>
				<path
					d="M160.285 65.3711H154.785V70.8705H160.285V65.3711Z"
					fill="black"
				/>
				<path
					d="M58.8383 70.7109H53.3389V76.2104H58.8383V70.7109Z"
					fill="black"
				/>
				<path
					d="M64.1772 70.7109H58.6777V76.2104H64.1772V70.7109Z"
					fill="black"
				/>
				<path
					d="M69.517 70.7109H64.0176V76.2104H69.517V70.7109Z"
					fill="black"
				/>
				<path
					d="M74.8559 70.7109H69.3564V76.2104H74.8559V70.7109Z"
					fill="black"
				/>
				<path
					d="M80.1987 70.7109H74.6992V76.2104H80.1987V70.7109Z"
					fill="black"
				/>
				<path
					d="M85.5336 70.7109H80.0342V76.2104H85.5336V70.7109Z"
					fill="black"
				/>
				<path
					d="M90.8735 70.7109H85.374V76.2104H90.8735V70.7109Z"
					fill="black"
				/>
				<path
					d="M101.551 70.7109H96.0518V76.2104H101.551V70.7109Z"
					fill="black"
				/>
				<path
					d="M106.89 70.7109H101.391V76.2104H106.89V70.7109Z"
					fill="black"
				/>
				<path
					d="M122.911 70.7109H117.411V76.2104H122.911V70.7109Z"
					fill="black"
				/>
				<path
					d="M138.932 70.7109H133.433V76.2104H138.932V70.7109Z"
					fill="black"
				/>
				<path
					d="M144.267 70.7109H138.768V76.2104H144.267V70.7109Z"
					fill="black"
				/>
				<path
					d="M154.946 70.7109H149.446V76.2104H154.946V70.7109Z"
					fill="black"
				/>
				<path
					d="M176.302 70.7109H170.803V76.2104H176.302V70.7109Z"
					fill="black"
				/>
				<path
					d="M181.641 70.7109H176.142V76.2104H181.641V70.7109Z"
					fill="black"
				/>
				<path
					d="M202.998 70.7109H197.498V76.2104H202.998V70.7109Z"
					fill="black"
				/>
				<path d="M53.4995 76.0469H48V81.5463H53.4995V76.0469Z" fill="black" />
				<path
					d="M58.8383 76.0469H53.3389V81.5463H58.8383V76.0469Z"
					fill="black"
				/>
				<path
					d="M74.8559 76.0469H69.3564V81.5463H74.8559V76.0469Z"
					fill="black"
				/>
				<path
					d="M90.8735 76.0469H85.374V81.5463H90.8735V76.0469Z"
					fill="black"
				/>
				<path
					d="M112.233 76.0469H106.733V81.5463H112.233V76.0469Z"
					fill="black"
				/>
				<path
					d="M138.932 76.0469H133.433V81.5463H138.932V76.0469Z"
					fill="black"
				/>
				<path
					d="M154.946 76.0469H149.446V81.5463H154.946V76.0469Z"
					fill="black"
				/>
				<path
					d="M160.285 76.0469H154.785V81.5463H160.285V76.0469Z"
					fill="black"
				/>
				<path
					d="M165.623 76.0469H160.124V81.5463H165.623V76.0469Z"
					fill="black"
				/>
				<path
					d="M170.962 76.0469H165.463V81.5463H170.962V76.0469Z"
					fill="black"
				/>
				<path
					d="M176.302 76.0469H170.803V81.5463H176.302V76.0469Z"
					fill="black"
				/>
				<path
					d="M181.641 76.0469H176.142V81.5463H181.641V76.0469Z"
					fill="black"
				/>
				<path d="M186.98 76.0469H181.48V81.5463H186.98V76.0469Z" fill="black" />
				<path
					d="M192.323 76.0469H186.823V81.5463H192.323V76.0469Z"
					fill="black"
				/>
				<path
					d="M202.998 76.0469H197.498V81.5463H202.998V76.0469Z"
					fill="black"
				/>
				<path
					d="M58.8383 81.3984H53.3389V86.8979H58.8383V81.3984Z"
					fill="black"
				/>
				<path
					d="M64.1772 81.3984H58.6777V86.8979H64.1772V81.3984Z"
					fill="black"
				/>
				<path
					d="M80.1987 81.3984H74.6992V86.8979H80.1987V81.3984Z"
					fill="black"
				/>
				<path
					d="M85.5336 81.3984H80.0342V86.8979H85.5336V81.3984Z"
					fill="black"
				/>
				<path
					d="M96.2123 81.3984H90.7129V86.8979H96.2123V81.3984Z"
					fill="black"
				/>
				<path
					d="M112.233 81.3984H106.733V86.8979H112.233V81.3984Z"
					fill="black"
				/>
				<path
					d="M117.572 81.3984H112.072V86.8979H117.572V81.3984Z"
					fill="black"
				/>
				<path
					d="M133.593 81.3984H128.094V86.8979H133.593V81.3984Z"
					fill="black"
				/>
				<path
					d="M160.285 81.3984H154.785V86.8979H160.285V81.3984Z"
					fill="black"
				/>
				<path
					d="M165.623 81.3984H160.124V86.8979H165.623V81.3984Z"
					fill="black"
				/>
				<path
					d="M170.962 81.3984H165.463V86.8979H170.962V81.3984Z"
					fill="black"
				/>
				<path
					d="M176.302 81.3984H170.803V86.8979H176.302V81.3984Z"
					fill="black"
				/>
				<path
					d="M192.323 81.3984H186.823V86.8979H192.323V81.3984Z"
					fill="black"
				/>
				<path
					d="M64.1772 86.7344H58.6777V92.2338H64.1772V86.7344Z"
					fill="black"
				/>
				<path
					d="M69.517 86.7344H64.0176V92.2338H69.517V86.7344Z"
					fill="black"
				/>
				<path
					d="M80.1987 86.7344H74.6992V92.2338H80.1987V86.7344Z"
					fill="black"
				/>
				<path
					d="M90.8735 86.7344H85.374V92.2338H90.8735V86.7344Z"
					fill="black"
				/>
				<path
					d="M101.551 86.7344H96.0518V92.2338H101.551V86.7344Z"
					fill="black"
				/>
				<path
					d="M117.572 86.7344H112.072V92.2338H117.572V86.7344Z"
					fill="black"
				/>
				<path
					d="M122.911 86.7344H117.411V92.2338H122.911V86.7344Z"
					fill="black"
				/>
				<path
					d="M128.25 86.7344H122.751V92.2338H128.25V86.7344Z"
					fill="black"
				/>
				<path
					d="M138.932 86.7344H133.433V92.2338H138.932V86.7344Z"
					fill="black"
				/>
				<path
					d="M149.607 86.7344H144.107V92.2338H149.607V86.7344Z"
					fill="black"
				/>
				<path
					d="M160.285 86.7344H154.785V92.2338H160.285V86.7344Z"
					fill="black"
				/>
				<path
					d="M165.623 86.7344H160.124V92.2338H165.623V86.7344Z"
					fill="black"
				/>
				<path
					d="M170.962 86.7344H165.463V92.2338H170.962V86.7344Z"
					fill="black"
				/>
				<path
					d="M176.302 86.7344H170.803V92.2338H176.302V86.7344Z"
					fill="black"
				/>
				<path d="M186.98 86.7344H181.48V92.2338H186.98V86.7344Z" fill="black" />
				<path
					d="M197.662 86.7344H192.162V92.2338H197.662V86.7344Z"
					fill="black"
				/>
				<path
					d="M85.5336 92.0781H80.0342V97.5776H85.5336V92.0781Z"
					fill="black"
				/>
				<path
					d="M90.8735 92.0781H85.374V97.5776H90.8735V92.0781Z"
					fill="black"
				/>
				<path
					d="M96.2123 92.0781H90.7129V97.5776H96.2123V92.0781Z"
					fill="black"
				/>
				<path
					d="M106.89 92.0781H101.391V97.5776H106.89V92.0781Z"
					fill="black"
				/>
				<path
					d="M112.233 92.0781H106.733V97.5776H112.233V92.0781Z"
					fill="black"
				/>
				<path
					d="M122.911 92.0781H117.411V97.5776H122.911V92.0781Z"
					fill="black"
				/>
				<path
					d="M133.593 92.0781H128.094V97.5776H133.593V92.0781Z"
					fill="black"
				/>
				<path
					d="M144.267 92.0781H138.768V97.5776H144.267V92.0781Z"
					fill="black"
				/>
				<path
					d="M149.607 92.0781H144.107V97.5776H149.607V92.0781Z"
					fill="black"
				/>
				<path
					d="M154.946 92.0781H149.446V97.5776H154.946V92.0781Z"
					fill="black"
				/>
				<path
					d="M165.623 92.0781H160.124V97.5776H165.623V92.0781Z"
					fill="black"
				/>
				<path
					d="M176.302 92.0781H170.803V97.5776H176.302V92.0781Z"
					fill="black"
				/>
				<path
					d="M192.323 92.0781H186.823V97.5776H192.323V92.0781Z"
					fill="black"
				/>
				<path
					d="M197.662 92.0781H192.162V97.5776H197.662V92.0781Z"
					fill="black"
				/>
				<path
					d="M202.998 92.0781H197.498V97.5776H202.998V92.0781Z"
					fill="black"
				/>
				<path d="M53.4995 97.4102H48V102.91H53.4995V97.4102Z" fill="black" />
				<path
					d="M90.8735 97.4102H85.374V102.91H90.8735V97.4102Z"
					fill="black"
				/>
				<path
					d="M101.551 97.4102H96.0518V102.91H101.551V97.4102Z"
					fill="black"
				/>
				<path d="M106.89 97.4102H101.391V102.91H106.89V97.4102Z" fill="black" />
				<path
					d="M133.593 97.4102H128.094V102.91H133.593V97.4102Z"
					fill="black"
				/>
				<path
					d="M149.607 97.4102H144.107V102.91H149.607V97.4102Z"
					fill="black"
				/>
				<path
					d="M154.946 97.4102H149.446V102.91H154.946V97.4102Z"
					fill="black"
				/>
				<path
					d="M160.285 97.4102H154.785V102.91H160.285V97.4102Z"
					fill="black"
				/>
				<path
					d="M165.623 97.4102H160.124V102.91H165.623V97.4102Z"
					fill="black"
				/>
				<path
					d="M170.962 97.4102H165.463V102.91H170.962V97.4102Z"
					fill="black"
				/>
				<path
					d="M181.641 97.4102H176.142V102.91H181.641V97.4102Z"
					fill="black"
				/>
				<path d="M186.98 97.4102H181.48V102.91H186.98V97.4102Z" fill="black" />
				<path
					d="M197.662 97.4102H192.162V102.91H197.662V97.4102Z"
					fill="black"
				/>
				<path
					d="M202.998 97.4102H197.498V102.91H202.998V97.4102Z"
					fill="black"
				/>
				<path
					d="M64.1772 102.754H58.6777V108.253H64.1772V102.754Z"
					fill="black"
				/>
				<path
					d="M69.517 102.754H64.0176V108.253H69.517V102.754Z"
					fill="black"
				/>
				<path
					d="M85.5336 102.754H80.0342V108.253H85.5336V102.754Z"
					fill="black"
				/>
				<path
					d="M96.2123 102.754H90.7129V108.253H96.2123V102.754Z"
					fill="black"
				/>
				<path
					d="M106.89 102.754H101.391V108.253H106.89V102.754Z"
					fill="black"
				/>
				<path
					d="M117.572 102.754H112.072V108.253H117.572V102.754Z"
					fill="black"
				/>
				<path
					d="M138.932 102.754H133.433V108.253H138.932V102.754Z"
					fill="black"
				/>
				<path
					d="M149.607 102.754H144.107V108.253H149.607V102.754Z"
					fill="black"
				/>
				<path
					d="M176.302 102.754H170.803V108.253H176.302V102.754Z"
					fill="black"
				/>
				<path
					d="M197.662 102.754H192.162V108.253H197.662V102.754Z"
					fill="black"
				/>
				<path d="M53.4995 108.09H48V113.589H53.4995V108.09Z" fill="black" />
				<path
					d="M58.8383 108.09H53.3389V113.589H58.8383V108.09Z"
					fill="black"
				/>
				<path
					d="M64.1772 108.09H58.6777V113.589H64.1772V108.09Z"
					fill="black"
				/>
				<path d="M69.517 108.09H64.0176V113.589H69.517V108.09Z" fill="black" />
				<path
					d="M74.8559 108.09H69.3564V113.589H74.8559V108.09Z"
					fill="black"
				/>
				<path d="M106.89 108.09H101.391V113.589H106.89V108.09Z" fill="black" />
				<path d="M128.25 108.09H122.751V113.589H128.25V108.09Z" fill="black" />
				<path
					d="M138.932 108.09H133.433V113.589H138.932V108.09Z"
					fill="black"
				/>
				<path
					d="M149.607 108.09H144.107V113.589H149.607V108.09Z"
					fill="black"
				/>
				<path
					d="M154.946 108.09H149.446V113.589H154.946V108.09Z"
					fill="black"
				/>
				<path
					d="M170.962 108.09H165.463V113.589H170.962V108.09Z"
					fill="black"
				/>
				<path
					d="M181.641 108.09H176.142V113.589H181.641V108.09Z"
					fill="black"
				/>
				<path d="M186.98 108.09H181.48V113.589H186.98V108.09Z" fill="black" />
				<path
					d="M197.662 108.09H192.162V113.589H197.662V108.09Z"
					fill="black"
				/>
				<path d="M53.4995 113.434H48V118.933H53.4995V113.434Z" fill="black" />
				<path
					d="M74.8559 113.434H69.3564V118.933H74.8559V113.434Z"
					fill="black"
				/>
				<path
					d="M80.1987 113.434H74.6992V118.933H80.1987V113.434Z"
					fill="black"
				/>
				<path
					d="M85.5336 113.434H80.0342V118.933H85.5336V113.434Z"
					fill="black"
				/>
				<path
					d="M101.551 113.434H96.0518V118.933H101.551V113.434Z"
					fill="black"
				/>
				<path
					d="M106.89 113.434H101.391V118.933H106.89V113.434Z"
					fill="black"
				/>
				<path
					d="M112.233 113.434H106.733V118.933H112.233V113.434Z"
					fill="black"
				/>
				<path
					d="M128.25 113.434H122.751V118.933H128.25V113.434Z"
					fill="black"
				/>
				<path
					d="M133.593 113.434H128.094V118.933H133.593V113.434Z"
					fill="black"
				/>
				<path
					d="M149.607 113.434H144.107V118.933H149.607V113.434Z"
					fill="black"
				/>
				<path d="M186.98 113.434H181.48V118.933H186.98V113.434Z" fill="black" />
				<path
					d="M192.323 113.434H186.823V118.933H192.323V113.434Z"
					fill="black"
				/>
				<path d="M53.4995 118.77H48V124.269H53.4995V118.77Z" fill="black" />
				<path
					d="M64.1772 118.77H58.6777V124.269H64.1772V118.77Z"
					fill="black"
				/>
				<path d="M69.517 118.77H64.0176V124.269H69.517V118.77Z" fill="black" />
				<path
					d="M96.2123 118.77H90.7129V124.269H96.2123V118.77Z"
					fill="black"
				/>
				<path
					d="M101.551 118.77H96.0518V124.269H101.551V118.77Z"
					fill="black"
				/>
				<path d="M106.89 118.77H101.391V124.269H106.89V118.77Z" fill="black" />
				<path
					d="M117.572 118.77H112.072V124.269H117.572V118.77Z"
					fill="black"
				/>
				<path
					d="M122.911 118.77H117.411V124.269H122.911V118.77Z"
					fill="black"
				/>
				<path
					d="M133.593 118.77H128.094V124.269H133.593V118.77Z"
					fill="black"
				/>
				<path
					d="M138.932 118.77H133.433V124.269H138.932V118.77Z"
					fill="black"
				/>
				<path
					d="M144.267 118.77H138.768V124.269H144.267V118.77Z"
					fill="black"
				/>
				<path
					d="M149.607 118.77H144.107V124.269H149.607V118.77Z"
					fill="black"
				/>
				<path
					d="M154.946 118.77H149.446V124.269H154.946V118.77Z"
					fill="black"
				/>
				<path
					d="M165.623 118.77H160.124V124.269H165.623V118.77Z"
					fill="black"
				/>
				<path
					d="M170.962 118.77H165.463V124.269H170.962V118.77Z"
					fill="black"
				/>
				<path
					d="M181.641 118.77H176.142V124.269H181.641V118.77Z"
					fill="black"
				/>
				<path
					d="M197.662 118.77H192.162V124.269H197.662V118.77Z"
					fill="black"
				/>
				<path
					d="M202.998 118.77H197.498V124.269H202.998V118.77Z"
					fill="black"
				/>
				<path d="M53.4995 124.109H48V129.609H53.4995V124.109Z" fill="black" />
				<path
					d="M64.1772 124.109H58.6777V129.609H64.1772V124.109Z"
					fill="black"
				/>
				<path
					d="M85.5336 124.109H80.0342V129.609H85.5336V124.109Z"
					fill="black"
				/>
				<path
					d="M90.8735 124.109H85.374V129.609H90.8735V124.109Z"
					fill="black"
				/>
				<path
					d="M96.2123 124.109H90.7129V129.609H96.2123V124.109Z"
					fill="black"
				/>
				<path
					d="M101.551 124.109H96.0518V129.609H101.551V124.109Z"
					fill="black"
				/>
				<path
					d="M117.572 124.109H112.072V129.609H117.572V124.109Z"
					fill="black"
				/>
				<path
					d="M128.25 124.109H122.751V129.609H128.25V124.109Z"
					fill="black"
				/>
				<path
					d="M170.962 124.109H165.463V129.609H170.962V124.109Z"
					fill="black"
				/>
				<path
					d="M176.302 124.109H170.803V129.609H176.302V124.109Z"
					fill="black"
				/>
				<path
					d="M181.641 124.109H176.142V129.609H181.641V124.109Z"
					fill="black"
				/>
				<path d="M186.98 124.109H181.48V129.609H186.98V124.109Z" fill="black" />
				<path
					d="M192.323 124.109H186.823V129.609H192.323V124.109Z"
					fill="black"
				/>
				<path d="M53.4995 129.445H48V134.945H53.4995V129.445Z" fill="black" />
				<path
					d="M80.1987 129.445H74.6992V134.945H80.1987V129.445Z"
					fill="black"
				/>
				<path
					d="M90.8735 129.445H85.374V134.945H90.8735V129.445Z"
					fill="black"
				/>
				<path
					d="M117.572 129.445H112.072V134.945H117.572V129.445Z"
					fill="black"
				/>
				<path
					d="M122.911 129.445H117.411V134.945H122.911V129.445Z"
					fill="black"
				/>
				<path
					d="M138.932 129.445H133.433V134.945H138.932V129.445Z"
					fill="black"
				/>
				<path
					d="M160.285 129.445H154.785V134.945H160.285V129.445Z"
					fill="black"
				/>
				<path
					d="M170.962 129.445H165.463V134.945H170.962V129.445Z"
					fill="black"
				/>
				<path
					d="M176.302 129.445H170.803V134.945H176.302V129.445Z"
					fill="black"
				/>
				<path d="M186.98 129.445H181.48V134.945H186.98V129.445Z" fill="black" />
				<path d="M53.4995 134.789H48V140.289H53.4995V134.789Z" fill="black" />
				<path
					d="M64.1772 134.789H58.6777V140.289H64.1772V134.789Z"
					fill="black"
				/>
				<path
					d="M74.8559 134.789H69.3564V140.289H74.8559V134.789Z"
					fill="black"
				/>
				<path
					d="M80.1987 134.789H74.6992V140.289H80.1987V134.789Z"
					fill="black"
				/>
				<path
					d="M85.5336 134.789H80.0342V140.289H85.5336V134.789Z"
					fill="black"
				/>
				<path
					d="M101.551 134.789H96.0518V140.289H101.551V134.789Z"
					fill="black"
				/>
				<path
					d="M106.89 134.789H101.391V140.289H106.89V134.789Z"
					fill="black"
				/>
				<path
					d="M117.572 134.789H112.072V140.289H117.572V134.789Z"
					fill="black"
				/>
				<path
					d="M122.911 134.789H117.411V140.289H122.911V134.789Z"
					fill="black"
				/>
				<path
					d="M128.25 134.789H122.751V140.289H128.25V134.789Z"
					fill="black"
				/>
				<path
					d="M138.932 134.789H133.433V140.289H138.932V134.789Z"
					fill="black"
				/>
				<path
					d="M144.267 134.789H138.768V140.289H144.267V134.789Z"
					fill="black"
				/>
				<path
					d="M160.285 134.789H154.785V140.289H160.285V134.789Z"
					fill="black"
				/>
				<path
					d="M165.623 134.789H160.124V140.289H165.623V134.789Z"
					fill="black"
				/>
				<path
					d="M170.962 134.789H165.463V140.289H170.962V134.789Z"
					fill="black"
				/>
				<path
					d="M176.302 134.789H170.803V140.289H176.302V134.789Z"
					fill="black"
				/>
				<path
					d="M181.641 134.789H176.142V140.289H181.641V134.789Z"
					fill="black"
				/>
				<path
					d="M192.323 134.789H186.823V140.289H192.323V134.789Z"
					fill="black"
				/>
				<path
					d="M202.998 134.789H197.498V140.289H202.998V134.789Z"
					fill="black"
				/>
				<path
					d="M96.2123 140.125H90.7129V145.624H96.2123V140.125Z"
					fill="black"
				/>
				<path
					d="M112.233 140.125H106.733V145.624H112.233V140.125Z"
					fill="black"
				/>
				<path
					d="M128.25 140.125H122.751V145.624H128.25V140.125Z"
					fill="black"
				/>
				<path
					d="M138.932 140.125H133.433V145.624H138.932V140.125Z"
					fill="black"
				/>
				<path
					d="M144.267 140.125H138.768V145.624H144.267V140.125Z"
					fill="black"
				/>
				<path
					d="M149.607 140.125H144.107V145.624H149.607V140.125Z"
					fill="black"
				/>
				<path
					d="M160.285 140.125H154.785V145.624H160.285V140.125Z"
					fill="black"
				/>
				<path
					d="M181.641 140.125H176.142V145.624H181.641V140.125Z"
					fill="black"
				/>
				<path d="M186.98 140.125H181.48V145.624H186.98V140.125Z" fill="black" />
				<path
					d="M197.662 140.125H192.162V145.624H197.662V140.125Z"
					fill="black"
				/>
				<path
					d="M202.998 140.125H197.498V145.624H202.998V140.125Z"
					fill="black"
				/>
				<path
					d="M96.2123 145.461H90.7129V150.96H96.2123V145.461Z"
					fill="black"
				/>
				<path d="M106.89 145.461H101.391V150.96H106.89V145.461Z" fill="black" />
				<path
					d="M112.233 145.461H106.733V150.96H112.233V145.461Z"
					fill="black"
				/>
				<path
					d="M122.911 145.461H117.411V150.96H122.911V145.461Z"
					fill="black"
				/>
				<path d="M128.25 145.461H122.751V150.96H128.25V145.461Z" fill="black" />
				<path
					d="M133.593 145.461H128.094V150.96H133.593V145.461Z"
					fill="black"
				/>
				<path
					d="M138.932 145.461H133.433V150.96H138.932V145.461Z"
					fill="black"
				/>
				<path
					d="M144.267 145.461H138.768V150.96H144.267V145.461Z"
					fill="black"
				/>
				<path
					d="M154.946 145.461H149.446V150.96H154.946V145.461Z"
					fill="black"
				/>
				<path
					d="M160.285 145.461H154.785V150.96H160.285V145.461Z"
					fill="black"
				/>
				<path
					d="M170.962 145.461H165.463V150.96H170.962V145.461Z"
					fill="black"
				/>
				<path
					d="M181.641 145.461H176.142V150.96H181.641V145.461Z"
					fill="black"
				/>
				<path
					d="M96.2123 150.801H90.7129V156.3H96.2123V150.801Z"
					fill="black"
				/>
				<path
					d="M112.233 150.801H106.733V156.3H112.233V150.801Z"
					fill="black"
				/>
				<path
					d="M122.911 150.801H117.411V156.3H122.911V150.801Z"
					fill="black"
				/>
				<path d="M128.25 150.801H122.751V156.3H128.25V150.801Z" fill="black" />
				<path
					d="M133.593 150.801H128.094V156.3H133.593V150.801Z"
					fill="black"
				/>
				<path
					d="M144.267 150.801H138.768V156.3H144.267V150.801Z"
					fill="black"
				/>
				<path
					d="M149.607 150.801H144.107V156.3H149.607V150.801Z"
					fill="black"
				/>
				<path
					d="M154.946 150.801H149.446V156.3H154.946V150.801Z"
					fill="black"
				/>
				<path
					d="M160.285 150.801H154.785V156.3H160.285V150.801Z"
					fill="black"
				/>
				<path
					d="M181.641 150.801H176.142V156.3H181.641V150.801Z"
					fill="black"
				/>
				<path d="M186.98 150.801H181.48V156.3H186.98V150.801Z" fill="black" />
				<path
					d="M197.662 150.801H192.162V156.3H197.662V150.801Z"
					fill="black"
				/>
				<path
					d="M202.998 150.801H197.498V156.3H202.998V150.801Z"
					fill="black"
				/>
				<path
					d="M96.2123 156.137H90.7129V161.636H96.2123V156.137Z"
					fill="black"
				/>
				<path
					d="M117.572 156.137H112.072V161.636H117.572V156.137Z"
					fill="black"
				/>
				<path
					d="M122.911 156.137H117.411V161.636H122.911V156.137Z"
					fill="black"
				/>
				<path
					d="M128.25 156.137H122.751V161.636H128.25V156.137Z"
					fill="black"
				/>
				<path
					d="M133.593 156.137H128.094V161.636H133.593V156.137Z"
					fill="black"
				/>
				<path
					d="M138.932 156.137H133.433V161.636H138.932V156.137Z"
					fill="black"
				/>
				<path
					d="M160.285 156.137H154.785V161.636H160.285V156.137Z"
					fill="black"
				/>
				<path
					d="M165.623 156.137H160.124V161.636H165.623V156.137Z"
					fill="black"
				/>
				<path
					d="M170.962 156.137H165.463V161.636H170.962V156.137Z"
					fill="black"
				/>
				<path
					d="M176.302 156.137H170.803V161.636H176.302V156.137Z"
					fill="black"
				/>
				<path
					d="M181.641 156.137H176.142V161.636H181.641V156.137Z"
					fill="black"
				/>
				<path d="M186.98 156.137H181.48V161.636H186.98V156.137Z" fill="black" />
				<path
					d="M192.323 156.137H186.823V161.636H192.323V156.137Z"
					fill="black"
				/>
				<path
					d="M197.662 156.137H192.162V161.636H197.662V156.137Z"
					fill="black"
				/>
				<path d="M96.2123 161.48H90.7129V166.98H96.2123V161.48Z" fill="black" />
				<path d="M117.572 161.48H112.072V166.98H117.572V161.48Z" fill="black" />
				<path d="M133.593 161.48H128.094V166.98H133.593V161.48Z" fill="black" />
				<path d="M149.607 161.48H144.107V166.98H149.607V161.48Z" fill="black" />
				<path d="M154.946 161.48H149.446V166.98H154.946V161.48Z" fill="black" />
				<path d="M160.285 161.48H154.785V166.98H160.285V161.48Z" fill="black" />
				<path d="M165.623 161.48H160.124V166.98H165.623V161.48Z" fill="black" />
				<path d="M176.302 161.48H170.803V166.98H176.302V161.48Z" fill="black" />
				<path d="M186.98 161.48H181.48V166.98H186.98V161.48Z" fill="black" />
				<path d="M192.323 161.48H186.823V166.98H192.323V161.48Z" fill="black" />
				<path
					d="M96.2123 166.816H90.7129V172.316H96.2123V166.816Z"
					fill="black"
				/>
				<path
					d="M101.551 166.816H96.0518V172.316H101.551V166.816Z"
					fill="black"
				/>
				<path
					d="M112.233 166.816H106.733V172.316H112.233V166.816Z"
					fill="black"
				/>
				<path
					d="M133.593 166.816H128.094V172.316H133.593V166.816Z"
					fill="black"
				/>
				<path
					d="M138.932 166.816H133.433V172.316H138.932V166.816Z"
					fill="black"
				/>
				<path
					d="M144.267 166.816H138.768V172.316H144.267V166.816Z"
					fill="black"
				/>
				<path
					d="M149.607 166.816H144.107V172.316H149.607V166.816Z"
					fill="black"
				/>
				<path
					d="M154.946 166.816H149.446V172.316H154.946V166.816Z"
					fill="black"
				/>
				<path
					d="M160.285 166.816H154.785V172.316H160.285V166.816Z"
					fill="black"
				/>
				<path
					d="M165.623 166.816H160.124V172.316H165.623V166.816Z"
					fill="black"
				/>
				<path
					d="M170.962 166.816H165.463V172.316H170.962V166.816Z"
					fill="black"
				/>
				<path
					d="M176.302 166.816H170.803V172.316H176.302V166.816Z"
					fill="black"
				/>
				<path
					d="M181.641 166.816H176.142V172.316H181.641V166.816Z"
					fill="black"
				/>
				<path d="M186.98 166.816H181.48V172.316H186.98V166.816Z" fill="black" />
				<path
					d="M192.323 166.816H186.823V172.316H192.323V166.816Z"
					fill="black"
				/>
				<path
					d="M197.662 166.816H192.162V172.316H197.662V166.816Z"
					fill="black"
				/>
				<path d="M96.2123 172.16H90.7129V177.66H96.2123V172.16Z" fill="black" />
				<path d="M101.551 172.16H96.0518V177.66H101.551V172.16Z" fill="black" />
				<path d="M112.233 172.16H106.733V177.66H112.233V172.16Z" fill="black" />
				<path d="M133.593 172.16H128.094V177.66H133.593V172.16Z" fill="black" />
				<path d="M154.946 172.16H149.446V177.66H154.946V172.16Z" fill="black" />
				<path d="M160.285 172.16H154.785V177.66H160.285V172.16Z" fill="black" />
				<path d="M181.641 172.16H176.142V177.66H181.641V172.16Z" fill="black" />
				<path d="M186.98 172.16H181.48V177.66H186.98V172.16Z" fill="black" />
				<path d="M197.662 172.16H192.162V177.66H197.662V172.16Z" fill="black" />
				<path
					d="M106.89 177.492H101.391V182.992H106.89V177.492Z"
					fill="black"
				/>
				<path
					d="M117.572 177.492H112.072V182.992H117.572V177.492Z"
					fill="black"
				/>
				<path
					d="M133.593 177.492H128.094V182.992H133.593V177.492Z"
					fill="black"
				/>
				<path
					d="M144.267 177.492H138.768V182.992H144.267V177.492Z"
					fill="black"
				/>
				<path
					d="M154.946 177.492H149.446V182.992H154.946V177.492Z"
					fill="black"
				/>
				<path
					d="M181.641 177.492H176.142V182.992H181.641V177.492Z"
					fill="black"
				/>
				<path
					d="M192.323 177.492H186.823V182.992H192.323V177.492Z"
					fill="black"
				/>
				<path
					d="M48 28V65.3749H85.3749V28H48ZM80.0357 60.0357H53.3393V33.3393H80.0357V60.0357Z"
					fill="black"
				/>
				<path
					d="M165.463 28V65.3749H202.838V28H165.463ZM197.499 60.0357H170.802V33.3393H197.499V60.0357Z"
					fill="black"
				/>
				<path
					d="M48 145.461V182.836H85.3749V145.461H48ZM80.0357 177.497H53.3393V150.8H80.0357V177.497Z"
					fill="black"
				/>
				<path
					d="M74.6956 38.6758H58.6777V54.6936H74.6956V38.6758Z"
					fill="black"
				/>
				<path
					d="M192.157 38.6758H176.14V54.6936H192.157V38.6758Z"
					fill="black"
				/>
				<path
					d="M74.6956 156.137H58.6777V172.155H74.6956V156.137Z"
					fill="black"
				/>
				<rect x="101" y="81" width="49" height="49" fill="white" />
				<rect x="104.5" y="84.5" width="42" height="42" rx="4" fill="black" />
				<path
					d="M127.214 109.381L126.966 109.702L126.711 109.988L126.454 110.246L126.282 110.399L125.744 110.882L126.385 111.215C127.349 111.717 128.444 112 129.604 112C133.465 112 136.594 108.865 136.594 105C136.594 101.135 133.465 98 129.604 98C127.881 98 126.303 98.6246 125.085 99.6592L124.883 99.8209L124.861 99.8382L124.842 99.8579L124.532 100.167L124.521 100.178L124.511 100.19L124.267 100.467L124.254 100.482L124.242 100.498L124.153 100.617C123.19 101.816 122.613 103.341 122.613 105C122.613 106.255 122.943 107.434 123.522 108.454L123.811 108.963C123.13 109.363 122.337 109.593 121.491 109.593C118.959 109.593 116.905 107.537 116.905 105C116.905 102.463 118.959 100.407 121.491 100.407C122.134 100.407 122.745 100.539 123.299 100.778L123.682 100.942L123.91 100.601L124.165 100.27L124.42 99.9843L124.677 99.7269L124.816 99.6024L125.354 99.1204L124.713 98.7867C123.748 98.284 122.652 98 121.491 98C117.629 98 114.5 101.135 114.5 105C114.5 108.865 117.629 112 121.491 112C123.195 112 124.758 111.389 125.971 110.373L126.248 110.152L126.27 110.134L126.289 110.115L126.598 109.805L126.609 109.794L126.62 109.782L126.864 109.505L126.877 109.49L126.889 109.474L126.96 109.38L127.255 108.985L127.244 108.977C128.024 107.847 128.481 106.477 128.481 105C128.481 103.749 128.153 102.573 127.578 101.556L127.289 101.044L126.83 101.412L126.518 101.662L126.496 101.679L126.476 101.699L126.167 102.009L126.156 102.02L126.146 102.031L125.902 102.308L125.889 102.323L125.877 102.339L125.756 102.501C126.574 101.24 127.992 100.407 129.604 100.407C132.136 100.407 134.189 102.463 134.189 105C134.189 107.537 132.136 109.593 129.604 109.593C128.965 109.593 128.357 109.462 127.806 109.227L127.45 109.075L127.214 109.381ZM125.392 107.415C125.001 108.047 124.461 108.577 123.822 108.956L124.27 108.597L124.532 108.387L124.554 108.369L124.573 108.35L124.882 108.04L124.893 108.029L124.904 108.018L125.148 107.741L125.161 107.726L125.173 107.71L125.368 107.449L125.374 107.441L125.38 107.432L125.392 107.415ZM126.076 105C126.076 105.777 125.883 106.51 125.543 107.151L125.436 106.919C125.168 106.336 125.018 105.686 125.018 105C125.018 104.223 125.211 103.491 125.551 102.849L125.655 103.074C125.925 103.659 126.076 104.311 126.076 105Z"
					fill="url(#paint0_linear_2351_4988)"
				/>
				<path
					d="M127.214 109.381L126.966 109.702L126.711 109.988L126.454 110.246L126.282 110.399L125.744 110.882L126.385 111.215C127.349 111.717 128.444 112 129.604 112C133.465 112 136.594 108.865 136.594 105C136.594 101.135 133.465 98 129.604 98C127.881 98 126.303 98.6246 125.085 99.6592L124.883 99.8209L124.861 99.8382L124.842 99.8579L124.532 100.167L124.521 100.178L124.511 100.19L124.267 100.467L124.254 100.482L124.242 100.498L124.153 100.617C123.19 101.816 122.613 103.341 122.613 105C122.613 106.255 122.943 107.434 123.522 108.454L123.811 108.963C123.13 109.363 122.337 109.593 121.491 109.593C118.959 109.593 116.905 107.537 116.905 105C116.905 102.463 118.959 100.407 121.491 100.407C122.134 100.407 122.745 100.539 123.299 100.778L123.682 100.942L123.91 100.601L124.165 100.27L124.42 99.9843L124.677 99.7269L124.816 99.6024L125.354 99.1204L124.713 98.7867C123.748 98.284 122.652 98 121.491 98C117.629 98 114.5 101.135 114.5 105C114.5 108.865 117.629 112 121.491 112C123.195 112 124.758 111.389 125.971 110.373L126.248 110.152L126.27 110.134L126.289 110.115L126.598 109.805L126.609 109.794L126.62 109.782L126.864 109.505L126.877 109.49L126.889 109.474L126.96 109.38L127.255 108.985L127.244 108.977C128.024 107.847 128.481 106.477 128.481 105C128.481 103.749 128.153 102.573 127.578 101.556L127.289 101.044L126.83 101.412L126.518 101.662L126.496 101.679L126.476 101.699L126.167 102.009L126.156 102.02L126.146 102.031L125.902 102.308L125.889 102.323L125.877 102.339L125.756 102.501C126.574 101.24 127.992 100.407 129.604 100.407C132.136 100.407 134.189 102.463 134.189 105C134.189 107.537 132.136 109.593 129.604 109.593C128.965 109.593 128.357 109.462 127.806 109.227L127.45 109.075L127.214 109.381ZM125.392 107.415C125.001 108.047 124.461 108.577 123.822 108.956L124.27 108.597L124.532 108.387L124.554 108.369L124.573 108.35L124.882 108.04L124.893 108.029L124.904 108.018L125.148 107.741L125.161 107.726L125.173 107.71L125.368 107.449L125.374 107.441L125.38 107.432L125.392 107.415ZM126.076 105C126.076 105.777 125.883 106.51 125.543 107.151L125.436 106.919C125.168 106.336 125.018 105.686 125.018 105C125.018 104.223 125.211 103.491 125.551 102.849L125.655 103.074C125.925 103.659 126.076 104.311 126.076 105Z"
					fill="white"
				/>
				<path
					d="M127.214 109.381L126.966 109.702L126.711 109.988L126.454 110.246L126.282 110.399L125.744 110.882L126.385 111.215C127.349 111.717 128.444 112 129.604 112C133.465 112 136.594 108.865 136.594 105C136.594 101.135 133.465 98 129.604 98C127.881 98 126.303 98.6246 125.085 99.6592L124.883 99.8209L124.861 99.8382L124.842 99.8579L124.532 100.167L124.521 100.178L124.511 100.19L124.267 100.467L124.254 100.482L124.242 100.498L124.153 100.617C123.19 101.816 122.613 103.341 122.613 105C122.613 106.255 122.943 107.434 123.522 108.454L123.811 108.963C123.13 109.363 122.337 109.593 121.491 109.593C118.959 109.593 116.905 107.537 116.905 105C116.905 102.463 118.959 100.407 121.491 100.407C122.134 100.407 122.745 100.539 123.299 100.778L123.682 100.942L123.91 100.601L124.165 100.27L124.42 99.9843L124.677 99.7269L124.816 99.6024L125.354 99.1204L124.713 98.7867C123.748 98.284 122.652 98 121.491 98C117.629 98 114.5 101.135 114.5 105C114.5 108.865 117.629 112 121.491 112C123.195 112 124.758 111.389 125.971 110.373L126.248 110.152L126.27 110.134L126.289 110.115L126.598 109.805L126.609 109.794L126.62 109.782L126.864 109.505L126.877 109.49L126.889 109.474L126.96 109.38L127.255 108.985L127.244 108.977C128.024 107.847 128.481 106.477 128.481 105C128.481 103.749 128.153 102.573 127.578 101.556L127.289 101.044L126.83 101.412L126.518 101.662L126.496 101.679L126.476 101.699L126.167 102.009L126.156 102.02L126.146 102.031L125.902 102.308L125.889 102.323L125.877 102.339L125.756 102.501C126.574 101.24 127.992 100.407 129.604 100.407C132.136 100.407 134.189 102.463 134.189 105C134.189 107.537 132.136 109.593 129.604 109.593C128.965 109.593 128.357 109.462 127.806 109.227L127.45 109.075L127.214 109.381ZM125.392 107.415C125.001 108.047 124.461 108.577 123.822 108.956L124.27 108.597L124.532 108.387L124.554 108.369L124.573 108.35L124.882 108.04L124.893 108.029L124.904 108.018L125.148 107.741L125.161 107.726L125.173 107.71L125.368 107.449L125.374 107.441L125.38 107.432L125.392 107.415ZM126.076 105C126.076 105.777 125.883 106.51 125.543 107.151L125.436 106.919C125.168 106.336 125.018 105.686 125.018 105C125.018 104.223 125.211 103.491 125.551 102.849L125.655 103.074C125.925 103.659 126.076 104.311 126.076 105Z"
					stroke="black"
				/>
				<defs>
					<filter
						id="filter0_d_2351_4988"
						x="0"
						y="0"
						width="251"
						height="251"
						filterUnits="userSpaceOnUse"
						colorInterpolationFilters="sRGB"
					>
						<feFlood floodOpacity="0" result="BackgroundImageFix" />
						<feColorMatrix
							in="SourceAlpha"
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
							result="hardAlpha"
						/>
						<feOffset dy="20" />
						<feGaussianBlur stdDeviation="15" />
						<feComposite in2="hardAlpha" operator="out" />
						<feColorMatrix
							type="matrix"
							values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
						/>
						<feBlend
							mode="normal"
							in2="BackgroundImageFix"
							result="effect1_dropShadow_2351_4988"
						/>
						<feBlend
							mode="normal"
							in="SourceGraphic"
							in2="effect1_dropShadow_2351_4988"
							result="shape"
						/>
					</filter>
					<linearGradient
						id="paint0_linear_2351_4988"
						x1="117.168"
						y1="99.3424"
						x2="134.893"
						y2="110.648"
						gradientUnits="userSpaceOnUse"
					>
						<stop offset="0.25" stopColor="white" />
						<stop offset="1" stopColor="#959595" />
					</linearGradient>
				</defs>
			</svg>,
		],
	]);

	return icons.get(icon) || null;
};

export default Icon;
